<template>
    <div class="container-fluid" id="dvcrud">
		<detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>       
        <consultaprodutos v-bind:idtabela="vidtabela" v-bind:filialadesivo="lancamentousu.idfilial" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa" v-bind:incmassa="true" v-bind:idestoque="lancamentousu.idestoque"></consultaprodutos>
        <cadastrorapidocliente v-bind:idfilial="vidfilialcadrapido" v-bind:descfil="vdescfiliacadrapido"></cadastrorapidocliente>    
		<consultaclientes></consultaclientes>
		<baixartitulosreceber v-bind:vdtbaixa              		= "rdtbasebaixa"
							v-bind:vidclientebaixa         		= "vidclientebaixa"
							v-bind:proplstselecionados     		= "vvariaveisbaixar.lstselecionadosbaixa"
							v-bind:vclientebaixa           		= "idnomeclientebaixa"
							v-bind:vvariaveisbaixarcmp     		= "vvariaveisbaixar"
							v-bind:propvaldescontojuros    		= "valdescontojuros"
							v-bind:propvaldescontomulta    		= "valdescontomulta"
							v-bind:propidlancamentopdv     		= "lancamentomenu.id"
							v-bind:propidpdv     		   		= "lancamentomenu.idpdv"
							v-bind:propidperfiltrocorecebimento = "vidperfiltrocovirtualreceb"
							v-bind:proptrocovirtual             = "trocovirtual">
		</baixartitulosreceber>		
        <consultapedidos v-bind:idfilial="vidfilial"></consultapedidos>

		<!--Luiz Trindade - Utilização do componente-->
		<listarpedidosifood 
			:lstPedidosIfoodSocketIO				="lstPedidosIfoodSocketIO"
			:lstPedidosIfoodAnterioresSocketIO		="lstPedidosIfoodAnterioresSocketIO"
			@triggerParentFunction					="computarExternalCodes"
		/>
		<!-- </listarpedidosifood> -->

		<alertacliente v-bind:idcliente="vidclientealerta"></alertacliente>
        <div class="row" id="dvrotinascrud">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-12 col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>							
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edconteudopesq">Id:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">PDV</span>
								<select id="cbpdvpesq" data-placeholder="Selecione um PDV" v-model="pidpdv" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Usuário</span>
								<select id="cbusuariopesq" data-placeholder="Selecione um usuário" v-model="pidusuario" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Fechados</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>							                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstpdvs"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->									
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_situacaopdv" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacaopdv) === 0" class="badge badge-pill badge-primary" style="background: #727cf5;">ABERTO</span>
                                        <span v-else class="badge badge-pill badge-success" style="background: #0acf97;">FECHADO 
											<i v-if="parseInt(item.row.processadofc) === 1" style="color: #f82b54; font-size: 15px;" class="fa fa-check-circle-o" title="FC Processado"></i>
											<i v-if="parseInt(item.row.temdif) === 1" style="color: #ffbb00; font-size: 15px;" class="fa fa-exclamation-triangle" title="Caixa com diferença"></i>
										</span>
                                    </template>
                                    <template slot="slot_valorabertura" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(item.row.valorabertura, 2) }}</span>
                                    </template>
                                    <template slot="slot_especie" slot-scope="item">
										<table style="width:100%">
											<tr v-for="(forma, indexf) in item.row.formasfeechamento" v-bind:key="indexf">												
												<td v-if="parseInt(forma.especie) === 1">
													<span class="lbldescformapedido" style="float: left;">{{forma.descricao}}</span>
													<span class="lbldescformapedido" style="float: right;">{{mtdformatavalordecimal(parseFloat(forma.valor), 2)}}</span>													
												</td>
											</tr>
										</table>										
                                    </template>									                                                                        
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>
                                    </template>									
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpdvs.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Id:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">*PDV</span>
								<select id="cbpdv" data-placeholder="Selecione um PDV" v-model="vidpdv" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvalorabertura">*Valor da abertura:</label>
								<money type="text" class="form-control form-control-sm" id="edvalorabertura" v-model="vvalorabertura" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">*Forma de pagamento</span>
								<select id="cbforma" data-placeholder="Selecione um forma de pagamento" v-model="vidforma" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edobservacoes">Observações:</label>
                                <input type="text" v-model="vobservacoes" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="edobservacoes" maxlength="255">
                            </div>
							<div v-show="parseInt(opcrud) === 1" class="col-md-4">
								<span class="lblselect2">Perfil do fluxo:</span>
								<select id="cbperfilfluxopdv" v-model="vidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
								</select>
							</div>							
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="dvlancamentospdv" style="display: none;">
            <div class="col-md-12">
                <div class="card" id="cdlancamentos">
                    <div class="card-header text-center">
						<i class="fa fa-cube opcoes-venda"   id="btitensvenda" @click.prevent="mtdmostraritens()" title="Produtos"></i>
						<i class="fa fa-wrench opcoes-venda" id="btservicosvenda" @click.prevent="mtdmostrarservicos()" style="margin-left: 15px;" title="Serviços"></i>
						<i class="fa fa-print opcoes-venda"  id="btimprimirultimavenda" @click.prevent="mtdreimpressaopedido()" style="margin-left: 15px;" title="Imprimir última venda"></i>
						<i v-show="mtdverificasistemafood()" class="fa fa-cutlery opcoes-venda" id="btbuscarcomanda" @click.prevent="mtdbuscarcomanda()" style="margin-left: 15px;" title="Buscar comanda"></i>
						<i v-show="mtdverificasistemafood()" class="fa fa-percent opcoes-venda" id="btadicionartaxa" @click.prevent="mtdadicionartaxa()" style="margin-left: 15px;" title="Adicionar taxa"></i>
						<i v-show="mtdverificasistemapet()"  class="fa fa-paw opcoes-venda" id="btbuscaragendamento" @click.prevent="mtdAdicionarAgendamento()"  style="margin-left: 15px;" title="Buscar agendamento"></i>
						
						<!--Luiz Trindade - ícone do ifood para abrir o modal-->
						<i v-show="mtdverificasistemafood()" class="fa opcoes-venda" @click.prevent="mtdmodalifood()" style="margin-left: 15px; position: relative;" title="Ifood">
							<i v-if="qtdPedidosBadge > 0" class="badge badge-pill badge-danger bdg-qtd-pedidos">{{ qtdPedidosBadge }}</i>
							<svg width="28" height="28" viewBox="0 0 24 24" fill="#CCCCCC" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.428 1.67c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006c4.244 0 7.184-3.854 7.184-6.998 0-2.29-2.175-3.293-4.244-3.293zm11.328 0c-4.65 0-7.184 4.149-7.184 6.998 0 2.294 2.2 3.299 4.25 3.299l-.006-.006C21.061 11.96 24 8.107 24 4.963c0-2.29-2.18-3.293-4.244-3.293zM14.172 14.52l2.435 1.834c-2.17 2.07-6.124 3.525-9.353 3.17A8.913 8.913 0 01.23 14.541H0a9.598 9.598 0 008.828 7.758c3.814.24 7.323-.905 9.947-3.13l-.004.007 1.08 2.988 1.555-7.623-7.234-.02Z"/>
							</svg>
						</i>

						<span id="spn-titulo-pdv" @click.prevent="mtdajustestela()">{{ lancamentousu.descpdv }} - {{ lancamentousu.nomeusu }}</span>					
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdfecharlancamentospdv()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" id="dvcorpolancamentos">
                        <div class="row">
							<div class="col-12 col-md-8">
								<div class="row">
									<div class="col-12 col-md-12" id="dv-codigoproduto">
										<div class="input-group" style="z-index: 1;">
											<div class="input-group-append" id="dv-btn-camera">
                                                <a href="#" id="btn-camera" class="btn btn-success btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdscannearcode()" title="Ler código de barras com a câmera"><i class="fa fa-barcode"></i></a>
                                            </div>											
											<input type="text" class="form-control form-control-sm" id="edlidproduto" v-model="vcoddigedicao" 
												v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" v-bind:disabled="desativaidpro" 
												maxlength="20" autocomplete="off" style="text-align: center;">
											<div class="input-group-append">
												<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()" style="border-top-right-radius: 10px!important; border-bottom-right-radius: 10px!important;">
													<i class="fa fa-search" style="padding-top: 3px;"></i>
												</a>
											</div>
										</div>
									</div>
									<!-- itens da venda -->
									<div class="col-md-12" id="dv-lst-itens">
										<div class="row">
											<div class="col-12">
												<ul class="list-group">                                           
													<li v-for="(item, index) in lstitens" v-bind:key="index" class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
														<div class="row">
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-center">
																<span v-if="item.nrvenda !== '' && parseInt(item.nrvenda) > 0" class="item-devtroca"><i class="fa fa-refresh" v-bind:title="'Devolução/Troca: '+item.nrvenda"></i></span>
																<span class="lbl-item">{{ mtdformatarzeros(item.item, 3) }}</span>
															</div>
															<div class="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-2">
																<span class="lbl-item" style="font-weight: bold;">{{ item.coddig }}</span>
															</div>
															<div class="col-8 col-sm-7 col-md-7 col-lg-7 col-xl-3" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">{{ item.descproduto }}</span>
															</div>
															<div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-1 text-right">
																<span class="lbl-item">{{ mtdformatavalordecimal(item.vlunitario, 2) }}</span>
															</div>
															<div class="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-right" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">{{ item.qtditem }} {{ item.unditem }}</span>
															</div>
															<div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-2 text-right">
																<span class="lbl-item" style="font-weight: bold;">{{ mtdformatavalordecimal(item.vltotal, 2) }}</span>
															</div>
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right" style="padding: 0px; padding-right: 5px;">
																<button type="button" class="btn btn-info btn-sm btn-item-pdv" @click.prevent="mtdalteraritem(item)" title="Alterar item"><i class="fa fa-edit"></i></button>&nbsp;
																<button type="button" class="btn btn-danger btn-sm btn-item-pdv" @click.prevent="mtdexcluiritem(item.item)" title="Excluir item"><i class="fa fa-trash"></i></button>                                                        
															</div>                                                                                                                                                                                                                                                                                                                        
														</div>
													</li>
													<!-- aqui colocar taxa de entrega ou serviço--->
													<li v-show="lstitens.length > 0 &&  lstcomandasvenda.length > 0 && vtottaxaservico > 0"  class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
														<div class="row">
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-center">
																<span class="lbl-item"><i class="fa fa-coffee" aria-hidden="true"></i></span>
															</div>
															<div class="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-2">
																<span class="lbl-item" style="font-weight: bold;"></span>
															</div>
															<div class="col-8 col-sm-7 col-md-7 col-lg-7 col-xl-3" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">Taxa de serviço</span>
															</div>
															<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-2 text-right">
																
															</div>
															
															<div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-2 text-right">
																<span class="lbl-item" style="font-weight: bold;">{{ mtdformatavalordecimal(vtottaxaservico, 2) }}</span>
															</div>
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right" style="padding: 0px; padding-right: 5px;">
																<button type="button" class="btn btn-info btn-sm btn-item-pdv" @click.prevent="mtdalterartaxa(1)" title="Alterar item"><i class="fa fa-edit"></i></button>&nbsp;
																<button type="button" class="btn btn-danger btn-sm btn-item-pdv" @click.prevent="mtdexcluirtaxa(1)" title="Excluir item"><i class="fa fa-trash"></i></button>                                                        
															</div>                                                                                                                                                                                                                                                                                                                        
														</div>
													</li>

													<li v-show="lstitens.length > 0 && vtottaxaentrega > 0" class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
														<div class="row">
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-center">
															
																<span class="lbl-item"><i class="fa fa-motorcycle" aria-hidden="true"></i></span>
															</div>
															<div class="col-4 col-sm-3 col-md-3 col-lg-3 col-xl-2">
																<span class="lbl-item" style="font-weight: bold;"></span>
															</div>
															<div class="col-8 col-sm-7 col-md-7 col-lg-7 col-xl-3" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">Taxa de entrega</span>
															</div>
															<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-2">
																<span class="lbl-item">{{ nomeEntregador }}</span>
															</div>
															
															<div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-2 text-right">
																<span class="lbl-item" style="font-weight: bold;">{{ mtdformatavalordecimal(vtottaxaentrega, 2) }}</span>
															</div>
															<div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right" style="padding: 0px; padding-right: 5px;">
																<button type="button" class="btn btn-info btn-sm btn-item-pdv" @click.prevent="mtdalterartaxa(2)" title="Alterar item"><i class="fa fa-edit"></i></button>&nbsp;
																<button type="button" class="btn btn-danger btn-sm btn-item-pdv" @click.prevent="mtdexcluirtaxa(2)" title="Excluir item"><i class="fa fa-trash"></i></button>                                                        
															</div>                                                                                                                                                                                                                                                                                                                        
														</div>
													</li>


												</ul>												
											</div>
										</div>

										<div v-show="lstitens.length === 0 &&  lstservicos.length === 0" style="height: 100%; display: flex; justify-content: center; text-align: center;">
												
											<div id="blinking-text" style="
													display: block;
													font-size: 80px;
													font-weight: 900;
													color: teal;
													align-self: center;">CAIXA LIVRE
											</div>
										</div>

									</div>
									<!-- serviços da venda -->
									<div class="col-12 col-md-12 col-md-12" id="dv-servicos" style="display: none;">
										<div v-show="parseInt(opcrud) < 3" class="row" id="dv-opcoes-servicos">
											<div  class="col-sm-12 col-md-7 col-lg-7">
												<span class="lblselect2">Serviço:</span>
												<select id="cbservico" data-placeholder="Selecione um serviço" v-model="vidservicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-5 col-lg-5">
												<span class="lblselect2">Técnico:</span>
												<select id="cbtecnico" data-placeholder="Selecione um técnico" v-model="vidtecnicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edqtdservedicao">Qtd:</label>
												<input type="number" class="form-control form-control-sm" id="edqtdservedicao" v-model="vqtdservicoedicao" v-bind="calculatotalserv" min="1" maxlength="11"/>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="cbtipodescontoservicoedicao">Tp. Descto.:</label>
												<select class="form-control form-control-sm" id="cbtipodescontoservicoedicao" v-model="vtipodescontoservicoedicao" v-bind="calculatotalserv">
													<option value="0">Percentual</option>
													<option value="1" >Valor</option>
												</select>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvalordescontoservicoedicao">{{ vtitdescserv }}</label>
												<money type="text" class="form-control form-control-sm" id="edvalordescontoservicoedicao" v-model="vvalordescontoservicoedicao" v-bind="[calculatotalserv, money]" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvlservicoedicao">Valor Unitário:</label>
												<money type="text" class="form-control form-control-sm" id="edvlservicoedicao" v-model="vvlservicoedicao" v-bind:disabled="manipulaval" v-bind="money" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2">
												<label for="edvltotalservicoedicao">Total:</label>
												<money type="text" class="form-control form-control-sm" id="edvltotalservicoedicao" v-model="vvltotalservicoedicao" v-bind="[calculatotalserv, money]" readonly style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarservico()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
										</div>								
										<div class="row" id="dv-lst-servicos" style="overflow:auto; margin-top: 10px;">
											<div class="col-12">
												<ul class="list-group">                                           
													<li v-for="(servico, index) in lstservicos" v-bind:key="index" class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
														<div class="row">
															<div class="col-2 col-sm-2 col-md-2 col-lg-1">
																<span class="lbl-item">{{ servico.idservico }}</span>
															</div>
															<div class="col-5 col-sm-5 col-md-5 col-lg-3" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">{{ servico.descservico }}</span>
															</div>
															<div class="col-5 col-sm-5 col-md-5 col-lg-2" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">{{ servico.nometecnico }}</span>
															</div>													
															<div class="col-3 col-sm-3 col-md-3 col-lg-2 text-right">
																<span class="lbl-item">{{ mtdformatavalordecimal(servico.vlservico, 2) }}</span>
															</div>
															<div class="col-3 col-sm-3 col-md-3 col-lg-1 text-right" style="padding-left: 2px; padding-right: 2px;">
																<span class="lbl-item">{{ servico.qtdservico }}</span>
															</div>
															<div class="col-4 col-sm-4 col-md-4 col-lg-2 text-right">
																<span class="lbl-item" style="font-weight: bold;">{{ mtdformatavalordecimal(servico.vltotal, 2) }}</span>
															</div>
															<div class="col-2 col-sm-2 col-md-2 col-lg-1 text-center" style="padding: 0px;">
																<button type="button" class="btn btn-danger btn-sm btn-item-pdv" @click.prevent="mtdexcluirservico(servico)" title="Excluir item"><i class="fa fa-trash"></i></button>                                                        
															</div>                                                                                                                                                                                                                                                                                                                        
														</div>
													</li>
												</ul>                                        
											</div>		
										</div>								
									</div>
								</div>
							</div>
							<div class="col-12 col-md-4" id="dv-menugeral">
								<div class="row" id="dv-menu-row">
									<div class="col-12" style="padding-right: 0px;">
										<div class="row" id="dv-menu">
											<div class="col">
												<button type="button" class="btn btn-success btn-sm btn-block btn-green btn-menu-pdv" @click.prevent="mtdfinalizarvenda()"><i class="fa fa-money fa-ajuste"></i> Finalizar</button>
											</div>                                    
											<div class="col">
												<button type="button" class="btn btn-primary btn-sm btn-block btn-purple btn-menu-pdv" @click.prevent="mtdconsultapedidoimportar()"><i class="fa fa-mail-reply fa-ajuste"></i> Importar</button>
											</div>
											<div class="col">
												<button type="button" class="btn btn-primary btn-sm btn-block btn-red btn-menu-pdv" @click.prevent="mtdlimparvenda(true, mtdatribuirplano)"><i class="fa fa-trash-o fa-ajuste"></i> Limpar</button>
											</div>
											<div class="col">
												<button type="button" class="btn btn-secondary btn-sm btn-block btn-primary btn-menu-pdv" @click.prevent="mtdmenuoutras()"><i class="fa fa-navicon fa-ajuste"></i> Outras</button>						
											</div>
										</div>
										<!-- fazer aqui o v-if dos botões rapidos -->
										<div v-if=" vbotoesrapidos=== 0" class="row text-center" id="dv-logo">
											<div class="col-12">
												<img id="img-cliente-pdv" class="img-fluid" v-bind:src="vlogovisualizar">
											</div>
										</div>
										<div v-else class="row">
											 <div class="col-12">
												<div class="row" style="padding-top: 10px !important;">
													<div class="col-12">
														<div id="slickbtns">
															<div v-for="(item, index) in lstbotoes" :key="index" class="row" @click.prevent="mtdselecionabotao(index)">
																<div class="col-12" style="padding-right: 0">
																	<div v-if="parseInt(item.ativo)===0" class="card cardbtn">
																		<!-- <div class="card-body">
																			<div class="text-center">
																				<span class="responsive">{{ item.descricao }}</span>
																			</div>
																		</div> -->
																		<div class="card-body d-flex align-items-center justify-content-center">
																			<div class="row">
																				<div class="container">
																					<div class="d-flex">
																						<!-- Conteúdo do card aqui -->
																						<span class="responsive">{{ item.descricao }}</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>

																	<div v-else class="card cardbtn-ativo">
																		<!-- <div class="card-body">
																			<div class="text-center">
																				<span class="responsive">{{ item.descricao }}</span>
																			</div>
																		</div> -->
																		<div class="card-body d-flex align-items-center justify-content-center">
																			<div class="row">
																				<div class="container">
																					<div class="d-flex">
																						<!-- Conteúdo do card aqui -->
																						<span class="responsive">{{ item.descricao }}</span>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="row"  style="padding-top: 10px"  >
													<div class="col-12">
														<div class="container" id="dv-lista-itens-slick" style="overflow-y: auto; padding: 0;" >
															<ul class="list-group">                                           
																<li v-for="(item, index) in lstitensbotoes" :key="index"  class="list-group-item list-group-item-action" style="padding: 5px 15px 5px 15px;">
																	<div class="row">
																		<div class="col-10">
																			<div class="row">
																				<div class="col-10 col-md-12 col-lg-2 col-xl-2">
																					{{ item.idproduto }}
																				</div>   
																				<div class="col-12 col-md-12 col-lg-10 col-xl-10">
																					{{ item.descricao }}
																				</div>  
																				<div class="col-8 col-md-8 col-lg-5 col-xl-3" style="padding-top: 15px; font-size: 12px; !important">
																					{{mtdformatavalordecimal(item.valor, 2)}}
																				</div> 
																				<div class="col-10 col-md-10 col-lg-8 col-xl-5">
																					<!-- <label for="qtditembtn">Quantidade:</label> -->
																					<div class="input-group" style="z-index: 1; padding: 10px;">
																						<div class="input-group-append">
																							<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdalterarqtd(false, 1, index)"><i class="fa fa-minus"></i></a>
																						</div>									
																						<money type="text" class="form-control form-control-sm" id="qtditembtn" disabled v-model="item.qtd" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																						<div class="input-group-append">
																							<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdalterarqtd(true, 1, index)"><i class="fa fa-plus"></i></a>
																						</div>									
																					</div>
																				</div>    
																				<div class="col-8 col-md-8 col-lg-3 col-xl-3" style="padding-top: 15px; font-size: 12px !important;">
																					{{mtdformatavalordecimal(item.total, 2)}}
																				</div>                                                                                                                                                                                                                                                                                                                 
																			</div>
																		</div>
																		<div style="background-color: #0acf97 !important; border-radius: 15px" class="col-2" @click.prevent="mtdincluirproduto(item, index)">
																			<div class="card-body d-flex align-items-center justify-content-center" style="margin-top: 8px">
																				<div class="row">
																					<div class="container">
																						<div class="d-flex">
																							<!-- Conteúdo do card aqui -->
																							<span class="responsive" style="color: white;" ><i class="fa fa-plus" aria-hidden="true"></i></span>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>	
																</li>
															</ul>	
														</div>									
													</div>
												</div>	
											 </div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row" style="padding: 15px!important;">
							<div class="col-12 col-md-8">
								<div class="row dv-subtotal">
									<div class="col-6 col-sm-6 col-md-3 col-lg-3">
										<span class="inf-rodape-item">ITENS {{mtdformatarzeros(lstitens.length, 3)}}</span>
									</div>
									<div class="col-6 col-sm-6 col-md-3 col-lg-3 text-right">
										<span v-if="lstitens.length > 0 && lstservicos.length > 0" class="inf-rodape-item">{{ mtdformatavalordecimal(vtotalprodutos, 2) }}</span>
									</div>									
									<div class="col-6 col-sm-6 col-md-3 col-lg-3">
										<span v-if="lstservicos.length > 0" class="inf-rodape-item">SERVIÇOS {{ mtdformatarzeros(lstservicos.length, 3) }}:</span>
									</div>
									<div class="col-6 col-sm-6 col-md-3 col-lg-3 text-right">
										<span v-if="lstservicos.length > 0" class="inf-rodape-item">{{ mtdformatavalordecimal(vtotalservicos, 2) }}</span>
									</div>																		
									<div class="col-6 col-sm-6 col-md-6 col-lg-6">
										<span>SUBTOTAL:</span>
									</div>
									<div class="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
										<span>{{ mtdformatavalordecimal(vtotalgeral, 2) }}</span>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-4 dv-informacoes-venda">
								<div class="row">
									<div class="col-12">
										<span>CLIENTE:</span>
										<span v-if="vdoccli === ''" class="spn-informacoes-venda">{{ mtdformatarzeros(vidcliente, 5) }} - {{ vnomecliente }}</span>
										<span v-else class="spn-informacoes-venda">{{ mtdformatarzeros(vidcliente, 5) }} - {{ vnomecliente }} ({{ vdoccli }})</span>
									</div>
									<div class="col-12">
										<span>VENDEDOR:</span><span class="spn-informacoes-venda">{{ mtdformatarzeros(vidvendedor, 3) }} - {{ vnomevendedor }}</span>
									</div>
									<div class="col-12">
										<span>PLANO:</span><span class="spn-informacoes-venda">{{ mtdformatarzeros(vidplano, 2) }} - {{ vdescplano }}</span>
									</div>														
								</div>								
							</div>							
						</div>
                    </div>
                </div>
				<div class="card" id="cdrecebimentos" style="display: none;">
                    <div class="card-header text-center"><span style="font-size: 18px; font-weight: 700;">RECEBIMENTOS - {{ lancamentousu.descpdv }}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdfecharrecebimentos()"><span aria-hidden="true">&times;</span></button>
                    </div>
					<div class="card-body">
						<div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edrcodcli">Cliente:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="edrcodcli" v-model="ridcliente" maxlength="11" v-on:blur="mtdlocalizarcliente(ridcliente)" style="text-transform: uppercase;" v-on:change="mtdlimpar_listagem_titulos()">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarcliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-10 col-lg-8">
                                <label for="edrnomecliente">Nome do cliente:</label>
                                <input type="text" class="form-control form-control-sm" id="edrnomecliente" v-model="rnomecliente"
                                    data-bv-group=".group" maxlength="50" disabled/>
									<i v-if="valertarcliente" class="fa fa-exclamation-triangle icone-alerta-cliente"  style="top: 25px; right: 20px;"
										@click.prevent="mtdvisualizaralerta(2)" title="Clique para visualizar conteúdo do alerta do cliente."></i>																			
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <label for="edridpedido">Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edridpedido" v-model="ridpedido"
                                    maxlength="11" data-bv-group=".group" v-on:change="mtdlimpar_listagem_titulos()" title="Número do pedido/venda">
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-6">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialrecebimento" v-model="vidfilialrecebimento"
										data-placeholder="Selecione uma filial" data-allow-clear="true" style="width:100%;">
								</select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <label for="edrultimorecebimento">Ult. Recebimento:</label>
                                <input type="text" class="form-control form-control-sm" id="edrultimorecebimento" v-model="rdtultrecebimento"
                                    data-bv-group=".group" disabled>
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="edrvlultimorecebimento">Vl. Ult. Rec:</label>
								<money type="text" class="form-control form-control-sm" id="edrvlultimorecebimento" v-model="rvalorultrecebimento"
										v-bind="money" disabled data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>														
                            <div class="col-12 col-sm-12 col-md-3 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistartituloscliente()"><i class="fa fa-search"></i></button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" @on-select-row="mtdcalculaselecionados()"
                                    @on-unselect-row="mtdcalculaselecionados()"
                                    @on-all-select-rows="mtdcalculaselecionados()"
                                    @on-all-unselect-rows="mtdcalculaselecionados()"
                                        :rows="lsttitulos"
                                        :columns="columnstitulos"
                                        :config="configtitulos"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->									
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                     
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                    <template slot="slot_vlapagar" slot-scope="item">
                                        <span style="color: #5A956A; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlapagar), 2) }}</span>
                                    </template>
									<template slot="slot_detalhes" slot-scope="item">
                                        <i v-if="parseInt(item.row.idpedido) > 0" @click.prevent="mtddetalhespedido(item.row.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido/venda"></i>
										<span v-else></span>
                                    </template>										                                                                         
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 10px;">
                                <div class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Selecionados <span class="badge badge-info bdgtitulos">{{ vqtdtitsel }}</span></a>
                                                    <a class="list-group-item lstdetrec">Soma dos títulos <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vTotalPagarSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vTotalJurosSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vTotalMultaSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral à pagar <span
                                                            class="badge badge-success bdgtitulos">{{ mtdformatavalordecimal(vTotalGeralSel, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
							<div class="col-md-8">
							</div>
							<div class="col-md-2" v-show="vqtdtitsel > 0">
								<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdimprimirextrato()"><i class="fa fa-print"></i> Extrato</button>								
							</div>							
							<div class="col-md-2" v-show="vqtdtitsel > 0">
								<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdbaixartitulos()"><i class="fa fa-money"></i> Pagamento</button>								
							</div>	
						</div>
					</div>
				</div>
            </div>            
        </div>        
		<div class="modal fade" id="mdmenulancamento">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(lancamentomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(lancamentomenu)"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(lancamentomenu)"><i class="fa fa-trash"></i> EXCLUIR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimirabertura(lancamentomenu.id, 1)"><i class="fa fa-print"></i> IMPRIMIR ABERTURA</li>								
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdlancamentospdv(lancamentomenu)"><i class="fa fa-money"></i> LANÇAMENTOS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdmovimentos(lancamentomenu)" data-dismiss="modal"><i class="fa fa-exchange"></i> MOVIMENTOS</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
		<!-- Menu do outras opções do pdv -->
		<div class="modal fade" id="mdmenupdv">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddefinicoesvenda()" data-dismiss="modal"><i class="fa fa-pencil-square-o"></i> DEFINIÇÕES DA VENDA</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdidentificaconsumidor()" data-dismiss="modal"><i class="fa fa fa-user"></i> IDENTIFICAR CONSUMIDOR<i v-if="parseInt(planocliente) < 2" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i></li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdaplicardesconto()" data-dismiss="modal"><i class="fa fa-percent"></i> APLICAR DESCONTOS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdaplicaracrescimo()" data-dismiss="modal"><i class="fa fa-percent"></i> APLICAR ACRÉSCIMO</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrecebimentos()" data-dismiss="modal"><i class="fa fa-dollar"></i> RECEBIMENTOS<i v-if="parseInt(planocliente) < 2" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i></li>								
                                <li v-show="vidpedido == '' && mtdopcaousuario('020Z.010Z.280Z')"   class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdarmazenar()" data-dismiss="modal"><i class="fa fa-box"></i> ARMAZENAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdmovimentocaixa(0)" data-dismiss="modal"><i class="fa fa-plus"></i> ENTRADAS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdmovimentocaixa(1)" data-dismiss="modal"><i class="fa fa-minus"></i> SAÍDAS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddevolucaotroca()" data-dismiss="modal"><i class="fa fa-refresh"></i> DEVOLUÇÃO/TROCA</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdmovimentos(lancamentousu)" data-dismiss="modal"><i class="fa fa-exchange"></i> MOVIMENTOS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdfechamento()" data-dismiss="modal"><i class="fa fa-money"></i> FECHAMENTO DO CAIXA</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>		
		<!-- Modal de edição do ítem do pedido -->
		<div class="modal fade" id="mdedicaoitem">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
						<h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração)</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidprodutoedicao">Produto:</label>
								<input type="text" class="form-control form-control-sm" id="edidprodutoedicao" disabled v-model="vcoddigedicao" maxlength="20" style="text-transform: uppercase;">
							</div>
							<div class="col-sm-12 col-md-8 col-lg-7">
								<label for="eddescricaoprodutoedicao">Descrição do produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" v-bind:disabled="vedicaodescpro" v-on:blur="mtddesabilitaedicaodescpro()">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdhabilitaedicaodescpro()" title="Alterar descrição"><i class="fa fa-edit" style="padding-top: 3px;"></i></a>
									</div>
								</div>									
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edundprodutoedicao">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edqtditemedicao">*Quantidade:</label>
								<div class="input-group" style="z-index: 1;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus"></i></a>
									</div>									
									<money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-on:blur="mtdverificadescontoquantidade()" v-on:input="mtdverificadescontoquantidade()" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus"></i></a>
									</div>									
								</div>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="cbmanipulavaledicao">Manipular valor:</label>
								<select class="form-control form-control-sm" id="cbmanipulavaledicao" v-model="vmanipulavaledicao" v-bind:disabled="pmanipularvaloritem">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbdescacresedicao">Atribuir:</label>
								<select class="form-control form-control-sm" id="cbdescacresedicao" v-model="vdescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Desconto</option>
									<option value="1">Acréscimo</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbtipodescacresedicao">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="vtipodescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvaldescacresedicao">{{ vtitdesc }}</label>
								<money type="text" class="form-control form-control-sm" id="edvaldescacresedicao" v-model="vvalordescacresedicao" v-bind="[calculatotalitem, money]" v-bind:disabled="manipulaval ? false : true" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvlunitarioedicao">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vvlunitarioedicao" v-bind:disabled="manipulaval" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvltotaledicao">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotaledicao" v-model="vvltotaledicao" v-bind="[calculatotalitem, money]" readonly style="font-weight: bold; text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-6">
								<span class="lblselect2">*Estoque:</span>
								<select id="cbestoqueedicao" data-placeholder="Selecione um estoque" v-model="videstoqueedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
								</select>
							</div>																																																		
						</div>
						<div class="row">
							<div class="col-sm-12">
								<label for="txtinfadprod">Informações adicionais do item:</label>
								<textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprodedicao" maxlength="500"></textarea>
							</div>							
						</div>						
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnsalvaritem" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para aplicação do desconto nos ítens -->
		<div class="modal fade" id="mdaplicardesconto">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Aplicar desconto</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">							
							<div class="col-md-12">
								<label for="edtotalitenssemdesconto">Total dos ítens SEM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="vtotalsemdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
							<div class="col-md-12">
								<label for="cbtipodesctotal">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodesctotal" v-model="vtipodesctotal" style="font-size: 18px; font-weight: bold;">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Percentual do desconto</label>
								<label v-else for="edfatordescontototal">Valor do desconto</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vfatordescontototal" v-bind="[calculadescontototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Desconto(R$)</label>
								<label v-else for="edfatordescontototal">Desconto(%)</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vresdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
							</div>														
							<div class="col-md-12">
								<label for="edtotalitenscomdesconto">Total dos ítens COM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenscomdesconto" v-model="vtotalcomdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnconfirmadesconto" @click.prevent="mtdconfirmaaplicacaodesconto()"><i class="fa fa-check"></i> Aplicar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>

		<!-- Modal para aplicação do acrescimo nos ítens -->
		<div class="modal fade" id="mdaplicaracrescimo">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Aplicar acrescimo</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">							
							<div class="col-md-12">
								<label for="edtotalitenssemdesconto">Total dos ítens SEM acrescimo:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="vtotalsemacrescimo" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
							<div class="col-md-12">
								<label for="cbtipodeacrescimo">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodeacrescimo" v-model="vtipoacresctotal" style="font-size: 18px; font-weight: bold;">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipoacresctotal) === 0" for="edfatoracrescimototal">Percentual do acrescimo</label>
								<label v-else for="edfatoracrescimototal">Valor do acrescimo</label>
								<money type="text" class="form-control form-control-sm" id="edfatoracrescimototal" v-model="vfatoracrescimototal" v-bind="[calculaacrescimototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipoacresctotal) === 0" for="edfatoracrescimototal">Acrescimo(R$)</label>
								<label v-else for="edfatoracrescimototal">Acrescimo(%)</label>
								<money type="text" class="form-control form-control-sm" id="edfatoracrescimototal" v-model="vresacrescimo" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
							</div>														
							<div class="col-md-12">
								<label for="edtotalitenscomacrescimo">Total dos ítens COM acrescimo:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenscomacrescimo" v-model="vtotalcomacrescimo" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnconfirmadesconto" @click.prevent="mtdconfirmaaplicacaoacrescimo()"><i class="fa fa-check"></i> Aplicar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para finalizar a venda -->
		<div class="modal fade" id="mdfinalizarvenda">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">      
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-money"></i> Finalizar venda</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label>Cliente:</label>
								<input type="text" class="form-control form-control-sm" v-bind:value="mtdformatarzeros(vidcliente, 5) + ' - ' + vnomecliente" disabled style="font-weight: bold;">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="edcreditodisponivelfinal">Créd. Disp.:</label>
								<money type="text" class="form-control form-control-sm" id="edcreditodisponivelfinal" v-model="vvlcreditodisponivel" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 12px;" disabled></money>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvlfaturar">Total da venda:</label>
								<money type="text" class="form-control form-control-sm" id="edvlfaturar" v-model="vtotalgeral" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
							</div>						
							<div  class="col-sm-12 col-md-4 col-lg-3">
								<span class="lblselect2">Forma de pagamento:</span>
								<select id="cbformapagamento" data-placeholder="Selecione uma forma" v-model="vidformapagamento" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="edvlforma">Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvlforma" v-model="vvlforma" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednrvendaforma">Nr. Venda:</label>
								<input type="text" class="form-control form-control-sm" id="ednrvendaforma" v-model="vnrvendaforma" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vabatecredito) === 0">									
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edqtdparcelascartao">Parcelas:</label>
								<input type="text" class="form-control form-control-sm" id="edqtdparcelascartao" v-model="vqtdparcelascartao" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vtipoforma) !== 3">									
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednsu">NSU:</label>
								<input type="text" class="form-control form-control-sm" id="ednsu" v-model="vnsu" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vtipoforma) !== 3">									
							</div>														
							<div class="col-sm-12 col-md-12 col-lg-1">
								<button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdincluirforma()"><i class="fa fa-plus"></i></button>
							</div>																														
						</div>
						<div class="row">
							<div class="col-lg-12">
								<div class="table-responsive">
									<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
										<thead class="thead-light">
										<tr>
											<th width="35px" style="text-align: center;"></th>
											<th width="300">Forma de pagamento:</th>
											<th width="100">Valor:</th>										
											<th width="100">Nr. Venda:</th>
											<th width="100">Parc. cartão:</th>
											<th width="100">NSU:</th>
											<th width="100">Perfil fluxo:</th>
										</tr>
										</thead>
										<tbody>
											<tr v-for="(forma, index) in lstformasfaturar" v-bind:key="index">
												<td width="35px" class="center" style="text-align: center;">
													<a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
													v-bind:disabled="ativadesativa"
													@click.prevent="mtddeletarforma(index)"><i class="fa fa-trash"></i></a>
												</td>												
												<td width="230px">{{ forma.descforma }}</td>
												<td width="100px" style="text-align: right;">
													<strong>{{ mtdformatavalordecimal(forma.vlforma, 2) }}</strong>
												</td>
												<td width="100px">{{ forma.nrvenda }}</td>													
												<td width="70px" style="text-align: right;">{{ forma.qtdparcelascartao }}</td>													
												<td width="70px" style="text-align: right;">{{ forma.nsu }}</td>													
												<td><i class="fa fa-edit icon-editar-perfil" title="Alterar perfil do fluxo" @click.prevent="mtdalterarperfilfluxo(forma, index, 6)"></i>{{ forma.descperfilfluxo }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
									<ul class="list-group">
										<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
											<span style="color: #666666; font-weight: bold;">Soma das formas</span>
											<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #0acf97;">{{mtdformatavalordecimal(parseFloat(vtotalformas), 2)}}</span>
										</li>
									</ul>
								</div>							
								<div v-show="vdiferenca > 0" class="col-md-12" style="padding-left: 0px; padding-right: 0px;margin-top: 10px;">
									<ul class="list-group">
										<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
											<span v-if="temtrocadev && parseFloat(vtotalgeral) < 0" style="color: #666666; font-weight: bold;">Devolver</span>
											<span v-else style="color: #666666; font-weight: bold;">Troco</span>
											<span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #f82b54;">{{mtdformatavalordecimal(parseFloat(vdiferenca), 2)}}</span>
										</li>
									</ul>
								</div>														
							</div>
							<div v-show="lsttitulosfaturar.length > 0" class="col-lg-12">
								<div class="table-responsive">
									<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
										<thead class="thead-light">
										<tr>
											<th width="35px" style="text-align: center;"></th>
											<th width="80">Nr. título:</th>
											<th width="80">Vencimento:</th>
											<th width="100">Tipo de cobrança:</th>
											<th width="80">Valor:</th>															
										</tr>
										</thead>
										<tbody>
											<tr v-for="(titulo, index) in lsttitulosfaturar" v-bind:key="index">
												<td width="35px" class="center" style="text-align: center;">
													<a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
													v-bind:disabled="ativadesativa"
													@click.prevent="mtdalterartitulo(titulo, index)"><i class="fa fa-edit"></i></a>
												</td>												
												<td width="80px">{{ titulo.codtit }}</td>
												<td width="80px">{{ titulo.dtventit }}</td>
												<td width="100px">{{ titulo.descricaocob }}</td>
												<td width="80px" style="text-align: right;">
													<strong>{{ mtdformatavalordecimal(titulo.vltit, 2) }}</strong>
												</td>                                                       												
											</tr>
										</tbody>
									</table>
								</div>
								<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
									<ul class="list-group">
										<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
											<span style="color: #666666; font-weight: bold;">Soma do títulos</span>
											<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotaltitulos), 2)}}</span>
										</li>
									</ul>
								</div>							
							</div>
							<div v-bind:class="mtdverificatrocovirtual() ? 'col-sm-9 col-md-9 col-lg-9' : 'col-sm-12 col-md-12 col-lg-12'" style="padding-top: 5px;">
								<span class="lblselect2">Vendedor:</span>
								<select id="cbvendedorfinalvenda" data-placeholder="Selecione um vendedor" v-bind:disabled="!mtdverificaliberavend()" v-model="vidvendedorfinal" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-3 col-md-3 col-lg-3" v-if="mtdverificatrocovirtual()" style="padding-top: 25px;">
								<div class="custom-control custom-switch" style="margin-left: 15px" >
									<input type="checkbox" class="custom-control-input" id="swctrocovirtual" name="swctrocovirtual" v-model="vseltrocovirtual">
									<label class="custom-control-label" for="swctrocovirtual">Troco virtual</label>
								</div>
							</div>		
						</div>						
					</div>       
					<div class="modal-footer">
						<div class="custom-control custom-switch" style="position: absolute; left: 15px;" >
							<input type="checkbox" class="custom-control-input" id="swcgerarnfce" name="swcgerarnfce" v-model="vgerarnfce">
							<label class="custom-control-label" for="swcgerarnfce">NFC-e<i v-show="parseInt(planocliente) < 2" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i></label>
						    </div>
						<!-- <div class="row" style="height: 100%" >
							<div class="col-12">
								<div style="background-color: #4d9d30; height: 100%; color: white; padding: 1px; border-radius: 10px;">
									<strong>CASHBACK R$ {{ mtdformatavalordecimal(vltotalcashback, 2) }}!</strong> Destes, R$ {{  mtdformatavalordecimal(vlcashbackdisponivelvenda, 2)  }} estão disponíveis para <br> esta compra, correspondendo a {{ lancamentousu.fatorcreditoutilizar }}% do valor total da venda.
								</div>
							</div>
						
						</div>	 -->
						<div class="alert alert-success alerta-cashback" v-show="parseFloat(vltotalcashback) > 0 && !vclienteematraso">
							<strong>CASHBACK R$ {{ mtdformatavalordecimal(vltotalcashback, 2) }}!</strong> Destes, R$ {{  mtdformatavalordecimal(vlcashbackdisponivelvenda, 2)  }} estão disponíveis para <br> esta compra, para abater até {{ lancamentousu.fatorcreditoutilizar }}% do valor total da venda.
						</div>	
					
															
						<button type="button" class="btn btn-primary btn-sm" id="btnfinalizarvenda" @click.prevent="mtdrotinasfinaisvenda()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
					
				</div>
			</div>
		</div>
		<!-- Modal para alteração da parcela -->
		<div class="modal fade" id="mdalterartitulo">
			<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				 
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<label>Nr. título:</label>
							<input type="text" class="form-control form-control-sm" v-model="tacodtit" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="eddtventit">Dt. Vencimento:</label>
							<div class="input-group">
								<date-picker id="eddtventit" v-model="tadtventit" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edvltit">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvltit" v-model="tavltit" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div  class="col-sm-12 col-md-12 col-lg-12">
							<span class="lblselect2">Tipo de cobrança:</span>
							<select id="cbtipocobranca" data-placeholder="Selecione um tipo de cobrança" v-model="taidtipocobranca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div v-show="parseInt(tatipocobranca) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
							<div class="card">
								<div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
								<div class="card-body" style="padding: 10px;">
									<div class="row">
										<div class="col-md-4">
											<label>Nr. Cheque:</label>
											<input type="text" id="ednumerocheque" class="form-control form-control-sm" v-model="tanumerocheque">
										</div>
										<div  class="col-sm-12 col-md-8 col-lg-8">
											<span class="lblselect2">Banco:</span>
											<select id="cbbanco" data-placeholder="Selecione um banco" v-model="taidbanco" data-allow-clear="true" style="width:100%;">
											</select>
										</div>
										<div class="col-md-4">
											<label>Agência:</label>
											<input type="text" id="edagencia" class="form-control form-control-sm" v-model="taagencia">
										</div>
										<div class="col-md-4">
											<label>Conta:</label>
											<input type="text" id="edconta" class="form-control form-control-sm" v-model="taconta">
										</div>
										<div class="col-md-4">
											<label>Praça:</label>
											<input type="text" id="edpraca" class="form-control form-control-sm" v-model="tapraca">
										</div>
										<div class="col-md-12">
											<label>Emitente:</label>
											<input type="text" id="edemitente" class="form-control form-control-sm" v-model="taemitente">
										</div>
										<div class="col-md-5">
											<label for="edfone1">CNPJ/CPF:</label>
											<input type="text" v-model="tacnpjcpf"
												class="form-control form-control-sm" id="edcnpjcpf" 
												v-mask="['###.###.###-##', '##.###.###/####-##']">
										</div>
										<div  class="col-md-7">
											<span class="lblselect2">Situação do cheque:</span>
											<select id="cbsituacaocheque" data-placeholder="Selecione uma situação" v-model="taidsituacaocheque" data-allow-clear="true" style="width:100%;">
											</select>
										</div>																																																	
									</div>
								</div>
							</div>
						</div>																														
					</div>
					<div class="row" v-show="parseInt(tindiceparcela) === 0">
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustardias" v-model="tajustardatas">
								<label class="custom-control-label" for="cbajustardias" id="lblajustardias" title="Ajusta o mesmo dia as demais datas">Ajustar mesmo dia nas demais parcelas</label>
							</div>
						</div>					
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustarparcelas" v-model="tajustarparcelas">
								<label class="custom-control-label" for="cbajustarparcelas" id="lblajustarparcelas" title="Ajusta o valor das demais parcelas">Ajustar valor das demais parcelas</label>
							</div>
						</div>				
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustarcentavos" v-model="tajustarcentavos">
								<label class="custom-control-label" for="cbajustarcentavos" id="lblajustarcentavos" title="Lança os centavos para a última parcela">Centavos na última parcela</label>
							</div>
						</div>
					</div>
				</div>        
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div> 
		<!-- Modal para definições da venda -->		
		<div class="modal fade" id="mddefinircoesvenda" tabindex="-1" style="z-index: 1041 !important">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">      
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-refresh"></i> Definições da venda</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-4 col-md-4 col-lg-4">
								<button @click.prevent="mtdchamacadastrorapido()" class="btn btn-primary btn-sm btn-block"><i class="fa fa-address-card"></i> Cadastro rápido</button>
							</div>
							<div class="col-sm-8 col-md-8 col-lg-8">
							</div>
							
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="eddcliente">Cliente:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddcliente" v-model="didcliente" maxlength="11" v-on:blur="mtdlocalizarcliente(didcliente)">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarcliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-7 col-lg-7 col-xl-7">
								<label for="eddnomecliente">Nome do cliente:</label>
								<input type="text" class="form-control form-control-sm" id="eddnomecliente" v-model="dnomecliente"
									data-bv-group=".group" maxlength="50" disabled style="font-weight: bold;"/>
									<i v-if="valertarcliente" class="fa fa-exclamation-triangle icone-alerta-cliente"  style="top: 25px; right: 20px;"
										@click.prevent="mtdvisualizaralerta(1)" title="Clique para visualizar conteúdo do alerta do cliente."></i>																			
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="edcreditodisponiveldef">Créd. Disp.:</label>
								<money type="text" class="form-control form-control-sm" id="edcreditodisponiveldef" v-model="dvlcreditodisponivel" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 12px;" disabled></money>
							</div>		
							<div class="col-10" >
								<div class="row">
									<div class="col-sm-12 col-md-12 col-lg-12">						
										<label for="cbplanodef">Plano:</label>
										<select class="form-control form-control-sm" id="cbplanodef" v-model="didplano">
											<option v-for="(plano, index) in dlstplanos" v-bind:key="index" v-bind:value="plano.id">{{ plano.id }} - {{ plano.descricao }}</option>
										</select>
									</div>
									<div class="col-sm-12 col-md-12 col-lg-12">
										<span class="lblselect2">Vendedor:</span>
										<select id="cbvendedordef" data-placeholder="Selecione um vendedor"  v-model="didvendedor" data-allow-clear="true" style="width:100%;">
										</select>
									</div>		
								</div>
							</div>		
							<div class="col-2">
								<img id="img-consumidor-pdv" style="padding-top: 20px;" class="img-fluid" v-bind:src="dimgcliente">
							</div>			
												
							<div class="col-sm-12">
								<label for="txtobservacoesdef">Observações:</label>
								<textarea class="form-control center" rows="5" id="txtobservacoesdef" v-model="dobservacoes"></textarea>
							</div>							
						</div>						
					</div>       
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaratribuicoesvenda()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para movimento do caixa -->		
		<div class="modal fade" id="mdmovimentoscaixa">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">      
					<div class="modal-header">
						<h4 v-if="parseInt(opmovcx) === 0" class="modal-title"><i class="fa fa-plus"></i> Entrada no caixa</h4>
						<h4 v-else class="modal-title"><i class="fa fa-minus"></i> Saída do caixa</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="eddescmovcx">Descrição do movimento:</label>
								<input type="text" v-model="descmovcx"
									   class="form-control form-control-sm" id="eddescmovcx" data-bv-group=".group" maxlength="100"
									   style="text-transform: uppercase;">
							</div>
							<div v-show="parseInt(opmovcx) === 1" class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">Grupo de saída:</span>
								<select id="cbgruposaidapdv" v-model="idgruposaidapdv"
										data-placeholder="Selecione um grupo" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvalormovcx">Valor:</label>
								<money class="form-control form-control-sm" id="edvalormovcx" v-bind="money" v-model="valormovcx"
									   data-bv-group=".group" style="text-align:right;">
								</money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Forma:</span>
								<select id="cbformamovcx" v-model="idformamovcx"
										data-placeholder="Selecione uma forma" data-allow-clear="true"
										style="width:100%;">
								</select>
							</div>
						</div>						
					</div>       
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmalancamentocaixa()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para status da venda -->
		<div class="modal fade" id="mdstatusaxios" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-body text-center">
						<div class="d-flex justify-content-center" style="margin-bottom: 15px;">
							<div class="spinner-border text-info" style="width: 3rem; height: 3rem;" role="status">
								<span class="sr-only"></span>
							</div>
						</div>      
						<span style="font-weight: 500; color: #666666;">{{ statusaxios }}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal para fechamento do caixa -->		
		<div class="modal fade" id="mdfechamento">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">      
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-calculator"></i> Fechamento do caixa</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12 text-center" style="margin-bottom: 10px;">
								<ul class="list-group">
									<li class="list-group-item">
										<span style="font-size: 18px; font-weight: 700; color: #666666;">{{ lancamentousu.descpdv }}</span>
									</li>
								</ul>
							</div>
							<div class="col-md-12">
								<ul class="list-group">
									<li v-for="(forma, indice) in lstformasfechamento" v-bind:key="indice" class="list-group-item">
										<div class="row">
											<div class="col-md-6" style="padding-top: 5px; padding-bottom: 0px;">
												<span class="spn-forma-fechamento">{{ forma.descricao }}</span>
											</div>
											<div class="col-md-3">
												<money v-show="!fechamentocego" type="text" class="form-control form-control-sm spn-forma-fechamento" v-model="forma.valorregistrado" v-bind="money" v-bind:id="'edvalorregistrado'+indice" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
											</div>											
											<div class="col-md-3">
												<money type="text" class="form-control form-control-sm spn-forma-fechamento" v-model="forma.valorfechamento" v-bind="[money, calculatotalfechamento]" v-bind:id="'edvalorformafechamento'+indice" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
											</div>
										</div>
									</li>
								</ul>								
							</div>
							<div class="col-md-12 text-center" style="margin-top: 10px;">
								<ul class="list-group">
									<li class="list-group-item">
										<div class="row">
											<div class="col-md-9 text-left" style="padding-top: 5px; padding-bottom: 0px;">
												<span class="spn-forma-fechamento" style="">TOTAL DO FECHAMENTO</span>
											</div>
											<div class="col-md-3">
												<money type="text" class="form-control form-control-sm spn-forma-fechamento" v-model="vsomavaloresfechamento" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
											</div>			
										</div>								
									</li>
								</ul>
							</div>							
						</div>						
					</div>       
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmafechamento()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal com os movimentos do caixa -->		
		<div class="modal fade" id="mdlistamovimentos" tabindex="-1">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">      
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-calculator"></i> Movimentos do caixa</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">						
						<div class="row">
							<!-- Detalhe do lançamento -->
							<div class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">ABERTURA</h6>
								</div>
							</div>							
							<div class="col-sm-12 table-responsive">
								<table class="table table-striped table-bordered table-sm table-hover" style="background: white;">
									<thead>
										<tr>
											<th>Id. Lancamento</th>
											<th>PDV</th>
											<th>Dt. Abertura</th>
											<th>Valor</th>
											<th>Forma</th>
											<th width="250" v-if="parseInt(lancamentosmov.situacaopdv) === 1  && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">Pefil Fluxo</th>
											<th>Situação</th>
											<th>Dt. Fechamento</th>
											<th width="35"></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td class="text-right">{{ mtdformatarzeros(lancamentosmov.id, 7) }}</td>
											<td>{{lancamentosmov.descpdv}}</td>
											<td class="text-right">{{ lancamentosmov.dtabertura }}</td>
											<td class="text-right">{{ mtdformatavalordecimal(lancamentosmov.valorabertura, 2) }}</td>
											<td>{{ lancamentosmov.descforma }}</td>
											<td v-if="parseInt(lancamentosmov.situacaopdv) === 1  && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">
												<button type="button" @click.prevent="mtdalteraperfilabertura(2, lancamentosmov.idperfilfluxoaberturas, lancamentosmov.descperfilfluxoaberturas)" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Alterar perfil"><i class="fa fa-edit"></i></button> {{lancamentosmov.descperfilfluxoaberturas}}
											</td>
											<td class="text-center" v-if="parseInt(lancamentosmov.situacaopdv) === 0"><span class="badge badge-pill badge-primary" style="background: #727cf5;">ABERTO</span></td>
											<td class="text-center" v-else><span class="badge badge-pill badge-success" style="background: #0acf97;">FECHADO <i v-if="parseInt(lancamentosmov.processadofc) === 1" style="color: #f82b54; font-size: 15px;" class="fa fa-check-circle-o" title="FC Processado"></i></span></td>
											<td v-if="parseInt(lancamentosmov.situacaopdv) === 1">{{lancamentosmov.dtfechamento}}</td>
											<td v-else></td>
											<td class="text-center">
												<button v-if="parseInt(lancamentosmov.situacaopdv) === 0" type="button" class="btn btn-primary btn-sm btn-purple" title="Imprimir abertura"
												@click.prevent="mtdimprimirabertura(lancamentosmov.id, 1)"><i class="fa fa-print"></i></button>
												<div v-if="parseInt(lancamentosmov.situacaopdv) === 1" class="dropdown">
													<button type="button" class="btn btn-primary btn-sm btn-green dropdown-toggle" title="Opções para impressão" data-toggle="dropdown">
														<i class="fa fa-print"></i>
													</button>
													<div class="dropdown-menu">
														<a class="dropdown-item" href="#" @click.prevent="mtdimprimirabertura(lancamentosmov.id, 1)">Abertura</a>
														<a class="dropdown-item" href="#" @click.prevent="mtdimprimirmovimentocaixa(lancamentosmov.id, lancamentosmov.idmovimentofechamento, 1)">Fechamento</a>
													</div>
												</div>												
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<!-- Vendas -->
							<div v-if="lpedidos.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">VENDAS</h6>
								</div>
							</div>						
							<div v-if="lpedidos.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive" style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="100">Nr. Venda</th>
										<th>Cliente</th>
										<th>Dt/Hr</th>
										<th>Plano</th>
										<th>Valor</th>										
										<th>Situação</th>
										<th>Formas pgto.</th>
										<th width="35"></th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(pedido, indicep) in lpedidos" v-bind:key="indicep">
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(pedido.id, 8)}}</td>
										<td style='vertical-align: middle;'>{{mtdformatarzeros(pedido.idcliente,6)}} - {{pedido.nomecli}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{pedido.dtfatura}}</td>
										<td style='vertical-align: middle;'>{{mtdformatarzeros(pedido.idplano,2)}} - {{pedido.descplano}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
										<td v-if="parseInt(pedido.stpedido) === 1" style='vertical-align: middle;' class="text-center"><span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">FATURADO</span></td>
										<td v-else style='vertical-align: middle;' class="text-center"><span class="badge badge-danger badge-pill">CANCELADO</span></td>
										<td style="vertical-align: middle;">
											<ul class="list-group">
												<li v-for="(forma, indexf) in pedido.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
													<span v-if="parseInt(forma.qtdparcelascartao) > 0" class="lblforma">{{forma.descricao}}({{forma.qtdparcelascartao}})</span>
													<span v-else class="lblforma">{{forma.descricao}}</span>
													<span class="lblforma">{{mtdformatavalordecimal(parseFloat(forma.valor), 2)}}</span>
												</li>
											</ul>
										</td>
										<td class="text-center">
											<!-- <button v-if="parseInt(pedido.idnotafiscal) === 0" type="button" class="btn btn-primary btn-sm btn-purple" title="Imprimir Venda"
											@click.prevent="mtdimprimirpedido(pedido.id, 1)"><i class="fa fa-print"></i></button>  -->
											<div class="dropdown">
												<button type="button" class="btn btn-primary btn-sm dropdown-toggle btn-purple" title="Opções da venda" data-toggle="dropdown">
													<i class="fa fa-navicon"></i>
												</button>
												<div class="dropdown-menu">
													<a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(pedido.id, 1)"><i class="fa fa-print"></i> Imprimir venda</a>
													<a v-if="parseInt(pedido.idnotafiscal) === 0" class="dropdown-item" href="#" @click.prevent="mtdconfirmagerarnfce(pedido)"><i class="fa fa-qrcode"></i> Gerar NFC-e <i v-if="parseInt(planocliente) < 2" style="float: none!important;" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i></a>
													<a v-if="parseInt(pedido.idnotafiscal) > 0" class="dropdown-item" href="#" @click.prevent="mtdimprimirdanfe(pedido.idnotafiscal)"><i class="fa fa-print"></i> Imprimir NFC-e <i v-if="parseInt(planocliente) < 2" style="float: none!important;" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i></a>
												</div>
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lformasvendas.length > 0 && resumoformas" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">RESUMO DAS FORMAS PGTO. DAS VENDAS</h6>
								</div>
							</div>															
							<div v-if="lformasvendas.length > 0 && resumoformas" class="col-12 table-responsive" style="padding-bottom: 15px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="30">Id.</th>
										<th>Forma de pagamento</th>
										<th>Valor</th>
										<th v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">Perfil Fluxo</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(forma, i) in lformasvendas" v-bind:key="i">
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(forma.id, 3)}}</td>
										<td style='vertical-align: middle;'>{{forma.descricao}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valor, 2)}}</td>									
										<td v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0"><button type="button" @click.prevent="mtdalterarperfilfluxo(forma, i, 0)" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Alterar perfil"><i class="fa fa-edit"></i></button> {{forma.descperfilfluxo}}</td>									
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lpedidos.length > 0" class="col-md-12" style="padding-bottom: 5px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Vendas <span class="badge badge-info" style="font-size: 12px;">{{ lpedidos.length }}</span><span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalpedidos, 2) }}</span></a>                                                                                                     
								</ul>
							</div>	
							<div v-if="parseInt(ltotaldescontos) > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Descontos <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ltotaldescontos, 2) }}</span></a>
								</ul>
							</div>																											
							<div v-if="parseInt(lqtdpedidoscancelados) > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Canceladas <span class="badge badge-info" style="font-size: 12px;">{{ lqtdpedidoscancelados }}</span><span class="badge badge-danger bdg-totais">{{ mtdformatavalordecimal(ltotalpedidoscancelados, 2) }}</span></a>
								</ul>
							</div>														
							<!-- Recebimentos -->
							<div v-if="lrecebimentos.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">RECEBIMENTOS</h6>
								</div>
							</div>						
							<div v-if="lrecebimentos.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive" style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="100">Id. Mov</th>
										<th>Cliente</th>
										<th>Dt/Hr</th>
										<th>Valor</th>
										<th>Situação</th>
										<th>Formas pgto.</th>
										<th width="35"></th>
										<th width="35"></th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(recebimento, indicer) in lrecebimentos" v-bind:key="indicer">
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(recebimento.idmovimento, 5)}}</td>
										<td style='vertical-align: middle;'>{{mtdformatarzeros(recebimento.idcliente, 6)}} - {{recebimento.nome}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{recebimento.dthrlancamento}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(recebimento.valor, 2)}}</td>
										<td v-if="parseInt(recebimento.situacao) === 0" style='vertical-align: middle;' class="text-center"></td>
										<td v-else style='vertical-align: middle;' class="text-center"><span class="badge badge-danger badge-pill">CANCELADO</span></td>
										<td style="vertical-align: middle;">
											<ul class="list-group">
												<li v-for="(forma, indexf) in recebimento.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
													<span class="lblforma">{{forma.descricao}}</span>
													<span class="lblforma">{{mtdformatavalordecimal(forma.valor, 2)}}</span>
												</li>
											</ul>
										</td>
										<td>
											<button v-if="parseInt(recebimento.situacao) === 0" type="button" class="btn btn-danger btn-sm" title="Cancelar"
											@click.prevent="mtdcancelarmovimento(lancamentosmov.id, recebimento.idmovimento)"><i class="fa fa-ban"></i></button>											
										</td>
										<td v-if="parseInt(recebimento.situacao) === 0" class="text-center">
											<button type="button" class="btn btn-primary btn-sm btn-purple" title="Imprimir Recebimento"
											@click.prevent="mtdimprimirmovimentocaixa(lancamentosmov.id, recebimento.idmovimento, 1)"><i class="fa fa-print"></i></button>
										</td>
										<td v-else style='vertical-align: middle;' title="Cancelado" width='30px'><i class="fa fa-ban" style="color: #dc3545; font-size: 24px;"></i></td>																									
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lformasrecebimentos.length > 0 && resumoformas" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">RESUMO DAS FORMAS PGTO. RECEBIMENTOS</h6>
								</div>
							</div>															
							<div v-if="lformasrecebimentos.length > 0 && resumoformas" class="col-12 table-responsive" style="padding-bottom: 15px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="30">Id.</th>
										<th>Forma de pagamento</th>
										<th>Valor</th>
										<th width="250" v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">Pefil Fluxo</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(forma, i) in lformasrecebimentos" v-bind:key="i">
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(forma.id, 3)}}</td>
										<td style='vertical-align: middle;'>{{forma.descricao}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valor, 2)}}</td>									
										<td v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0"><button type="button" @click.prevent="mtdalterarperfilfluxo(forma, i, 1)" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Alterar perfil"><i class="fa fa-edit"></i></button> {{forma.descperfilfluxo}}</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lrecebimentos.length > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Recebimentos <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalrecebimentos, 2) }}</span></a>                                                                                                     
								</ul>
							</div>		
							
							<!-- RECEBIMENTOS FILIAIS   -->

							<div v-if="lstresumorecebimentofil.length > 0 && resumoformas" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">RESUMO DOS RECEBIMENTOS DAS FILIAIS</h6>
								</div>
							</div>															
							<div v-if="lstresumorecebimentofil.length > 0 && resumoformas" class="col-12 table-responsive" style="padding-bottom: 15px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th>Filial</th>
										<th>Valor</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(filial, i) in lstresumorecebimentofil" v-bind:key="i">
										<td style='vertical-align: middle; text-align: left;'>{{filial.filial}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(filial.totalbaixa, 2)}}</td>
									</tr>
									</tbody>
								</table>
							</div>

							<div v-if="lstresumorecebimentofil.length > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Recebimentos entre filiais <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalrecebimentosfil, 2) }}</span></a>                                                                                                     
								</ul>
							</div>	


					

							<!-- Entradas -->
							<div v-if="lentradas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">ENTRADAS</h6>
								</div>
							</div>						
							<div v-if="lentradas.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="100">Id. Mov.</th>
										<th>Descrição</th>
										<th>Dt/Hr. lançto</th>
										<th>Valor</th>
										<th>Forma</th>
										<th width="250" v-if="parseInt(lancamentosmov.situacaopdv) === 1  && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 1">Pefil Fluxo</th>
										<th width="35"></th>
										<th width="35"></th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(movimento, indiceme) in lentradas" v-bind:key="indiceme">
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(movimento.idmovimento, 5)}}</td>
										<td style='vertical-align: middle;'>{{movimento.desclancamento}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{movimento.dthrlancamento}}</td>
										<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(movimento.valor, 2)}}</td>
										<td style='vertical-align: middle;'>{{movimento.descforma}}</td>
										<td v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">
											<button type="button" @click.prevent="mtdalterarperfilfluxo(movimento, indiceme, 3)" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Alterar perfil"><i class="fa fa-edit"></i></button> {{movimento.descperfilfluxo}}
										</td>
										<td>
											<button v-if="parseInt(movimento.situacao) === 0" type="button"  v-bind:disabled="parseInt(lancamentosmov.situacaopdv) === 1" class="btn btn-danger btn-sm" title="Cancelar"
											@click.prevent="mtdcancelarmovimento(lancamentosmov.id, movimento.idmovimento)"><i class="fa fa-ban"></i></button>											
										</td>
										<td v-if="parseInt(movimento.situacao) === 0" class="text-center">
											<button type="button" class="btn btn-primary btn-sm btn-purple" title="Imprimir Entrada"
											@click.prevent="mtdimprimirmovimentocaixa(lancamentosmov.id, movimento.idmovimento, 1)"><i class="fa fa-print"></i></button>
										</td>
                                        <td v-else style='vertical-align: middle;' title="Cancelado" width='30px'><i class="fa fa-ban" style="color: #dc3545; font-size: 24px;"></i></td>
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lentradas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Entradas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalentradas, 2) }}</span></a>                                                                                                     
								</ul>
							</div>							
							<!-- Saídas -->
							<div v-if="lsaidas.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;">SAÍDAS</h6>
								</div>
							</div>						
							<div v-if="lsaidas.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 5px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="100">Id. Mov.</th>
										<th>Descrição</th>
										<th>Grupo</th>
										<th>Dt/Hr. lançto</th>
										<th>Valor</th>
										<th>Forma</th>
										<th width="250" v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">Pefil Fluxo</th>
										<th width="35"></th>
										<th width="35"></th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(movimento, indicems) in lsaidas" v-bind:key="indicems">
										<td style="vertical-align: middle; text-align: right;">{{mtdformatarzeros(movimento.idmovimento, 5)}}</td>
										<td style="vertical-align: middle;">{{movimento.desclancamento}}</td>
										<td style="vertical-align: middle;">{{movimento.descgruposaida}}</td>
										<td style="vertical-align: middle; text-align: right;">{{movimento.dthrlancamento}}</td>
										<td style="vertical-align: middle; text-align: right;">{{mtdformatavalordecimal(parseFloat(movimento.valor), 2)}}</td>
										<td style="vertical-align: middle;">{{movimento.descforma}}</td>
										<td v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0">
											<button type="button" @click.prevent="mtdalterarperfilfluxo(movimento, indicems, 4)" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Alterar perfil"><i class="fa fa-edit"></i></button> {{movimento.descperfilfluxo}}
										</td>
										<td>
											<button v-if="parseInt(movimento.situacao) === 0" type="button" class="btn btn-danger btn-sm" title="Cancelar"
											@click.prevent="mtdcancelarmovimento(lancamentosmov.id, movimento.idmovimento)"><i class="fa fa-ban"></i></button>											
										</td>																				
										<td v-if="parseInt(movimento.situacao) === 0" class="text-center">
											<button type="button" class="btn btn-primary btn-sm btn-purple" title="Imprimir Saída"
											@click.prevent="mtdimprimirmovimentocaixa(lancamentosmov.id, movimento.idmovimento, 1)"><i class="fa fa-print"></i></button>
										</td>
										<td v-else style='vertical-align: middle;' title="Cancelado" width='30px'><i class="fa fa-ban" style="color: #dc3545; font-size: 24px;"></i></td>															
									</tr>
									</tbody>
								</table>
							</div>
							<div v-if="lsaidas.length > 0" class="col-md-12" style="padding-bottom: 15px;">
								<ul class="list-group">
									<a class="list-group-item lstdettot">Total Saídas <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalsaidas, 2) }}</span></a>                                                                                                     
								</ul>
							</div>							
							<!-- Fechamento -->
							<div v-if="lfechamento.length > 0" class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<div class="row" style="padding-top: 5px; padding-bottom: 5px;">
										<div class="col-md-4">
										</div>
										<div class="col-md-4 text-center">
											<h6 style="margin: 5px;color: #666;">FECHAMENTO</h6>											
										</div>
										<div class="col-md-4 text-right">
											<template v-if="opeditarfechamento">
											<button v-if="!veditarfechamento"  type="button" @click.prevent="mtdeditarfechamento()" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Editar fechamento"><i class="fa fa-edit"></i></button>
											<button v-else type="button" @click.prevent="mtdcancelaredicaofechamento()" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Cancelar edição do fechamento"><i class="fa fa-close"></i></button>
											<button v-if="veditarfechamento"  type="button" @click.prevent="mtdquestionaredicaofechamento()" class="btn btn-primary btn-sm btn-opcrud ajt-btn" title="Salvar edição do fechamento"><i class="fa fa-check"></i></button>																				
											</template>
										</div>																				
									</div>									
								</div>
							</div>															
							<div v-if="lfechamento.length > 0" class="col-sm-12 table-responsive" style="padding-bottom: 15px;">
								<table class="table table-striped table-bordered table-hover table-sm responsive"
									style="margin-bottom: 0px;">
									<thead>
									<tr>
										<th width="30">Id.</th>
										<th>Forma de pagamento</th>
										<th>Vl. registrado</th>
										<th>Vl. fechamento</th>
										<th>Diferença</th>
									</tr>
									</thead>
									<tbody>
									<template v-if="!veditarfechamento">
										<tr v-for="(forma, indicef) in lfechamento[0].formas" v-bind:key="indicef">
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(forma.idforma, 3)}}</td>
											<td style='vertical-align: middle;'>{{forma.descricao}}</td>
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valorregistrado, 2)}}</td>									
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valor, 2)}}</td>
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(forma.valor) - parseFloat(forma.valorregistrado), 2)}}</td>									
										</tr>
									</template>
									<template v-else>
										<tr v-for="(forma, indicef) in lstformasedicaofechamento" v-bind:key="indicef">
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatarzeros(forma.idforma, 3)}}</td>
											<td style='vertical-align: middle;'>{{forma.descricao}}</td>
																				
											

											<td v-if="$store.state.usuario.id == 1">
												<money type="text" class="form-control form-control-sm"
													v-model="forma.valorregistrado" v-bind="money"
													data-bv-group=".group" style="text-align:right;" @blur.native="mtdrecalculaedicaofechamento()">
												</money>											
											</td>

											<td v-else style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(forma.valorregistrado, 2)}}</td>											


											<td>
												<money type="text" class="form-control form-control-sm"
													v-model="forma.valor" v-bind="money"
													data-bv-group=".group" style="text-align:right;" @blur.native="mtdrecalculaedicaofechamento()">
												</money>											
											</td>
											<td style='vertical-align: middle; text-align: right;'>{{mtdformatavalordecimal(parseFloat(forma.valor) - parseFloat(forma.valorregistrado), 2)}}</td>									
										</tr>										
									</template>		
									</tbody>
								</table>
							</div>
							<div v-if="lfechamento.length > 0" class="col-md-12">
								<div v-if="!veditarfechamento" class="row">
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total registrado <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ltotalregistrado, 2) }}</span></a>                                                                                                     
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total fechamento<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalfechamento, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total Diferença <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotaldiferenca, 2) }}</span></a>
										</ul>
									</div>			
								</div>					
								<div v-else class="row">
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total registrado <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ltotalregistradoedicaofechamento, 2) }}</span></a>                                                                                                     
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total fechamento<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotalfechamentoedicaofechamento, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total Diferença <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ltotaldiferencaedicaofechamento, 2) }}</span></a>
										</ul>
									</div>			
								</div>								
							</div>
						</div>	
					</div>       
					<div class="modal-footer">
						<button @click.prevent="mtdimprimemovimentos()" type="button" class="btn btn-primary btn-green btn-sm" style="width: 150px;" title=""><i class="fa fa-print"></i> Imprimir</button>
						<button v-if="parseInt(lancamentosmov.situacaopdv) === 1 && parseInt(lancamentosmov.processadofc) === 0 && parseInt(lancamentosmov.lancamentosindividuaisfluxo) === 0" @click.prevent="mtdquestionafc()" type="button" class="btn btn-primary btn-green btn-sm" style="width: 150px;" title="Este procedimento lança os valores com perfis definidos diretamente no Fluxo do Caixa(FC)"><i class="fa fa-check"></i> Processar FC</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Sair</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Modal para identificação do consumidor -->
        <div class="modal fade" id="mdidentificaconsumidor" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-user"></i> Identificar consumidor</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-md-12">
								<label for="eddoccli">CNPJ/CPF do Cliente/Consumidor:</label>
								<input type="text" v-model="docclitmp"
									class="form-control form-control-sm" id="eddoccli" 
									v-mask="['###.###.###-##', '##.###.###/####-##']">								
							</div>
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmaidentidadeconsumidor()"><i class="fa fa-check"></i> Confirmar</button>						
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para devolução/troca -->
        <div class="modal fade" id="mddevolucaotroca" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-refresh"></i> Devolução/Troca</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidprodutodev">Produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidprodutodev" v-model="vcoddigdev" maxlength="20" v-on:blur="mtdlocalizarprodutodev(vcoddigdev)" v-on:keyup.13="mtdlocalizarprodutodev(vcoddigdev)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarprodutodev()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-8 col-lg-9">
								<label for="eddescricaoprodutodev">Descrição do produto:</label>
								<input type="text" class="form-control form-control-sm" id="eddescricaoprodutodev" v-model="vdescricaoprodutodev" maxlength="100" style="font-weight: bold;" disabled>	
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edundprodutodev">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edundprodutodev" v-model="vundprodutodev" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edqtditemdev">Quantidade:</label>
								<money type="text" class="form-control form-control-sm" id="edqtditemdev" v-model="vqtditemdev" v-bind="calculatotaldev" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvlunitariodev">Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitariodev" v-model="vvlunitariodev" v-bind="[calculatotaldev, money]" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>																					
							<div class="col-sm-12 col-md-3 col-lg-3">
								<label for="edtotaldev">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edtotaldev" v-model="vvtotaldev" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="ednrvenda">Nr. Venda:</label>
								<input type="text" class="form-control form-control-sm" id="ednrvenda" v-model="vnrvenda" maxlength="100" v-mask="'###########'" style="font-weight: bold;">	
							</div>							
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
						<button type="button" class="btn btn-primary btn-sm" id="btconfirmadevtroca" style="width: 100px;" @click.prevent="mtdconfirmaitemdevolucao()"><i class="fa fa-check"></i> Confirmar</button>						
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
		<!-- Modal para edição do perfil do fluxo -->
        <div class="modal fade" id="mdlalterarperfilfluxofinal">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" style="font-size: 14px;">Alteração de perfil do fluxo...</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="lblselect2">Perfil do fluxo:</span>
                            <select id="cbperfilfluxofinal" v-model="aidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarperfilfluxo()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>
		
        <!-- Modal para reimpressão do pedido -->
        <div class="modal fade" id="mdreimpressaopedido" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-print"></i> Reimpressão de venda</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-md-12">
								<label for="edultimopedido">Nr. da venda:</label>
								<input type="number" v-model="vidultimopedido"
									class="form-control form-control-sm" id="edultimopedido">								
							</div>
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
						<div class="row">
							<div class="col-12 col-md-6" style="padding: 5px;">
								<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimprimirultimavenda()"><i class="fa fa-print"></i> Imprimir</button>						
							</div>
							<div class="col-12 col-md-6" style="padding: 5px;">
								<button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdimprimirguiaseparacao()"><i class="fa fa-wpforms"></i> Separação</button>						
							</div>
							<div class="col-12 col-md-6" style="padding: 5px;">
								<button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdimprimircarne()"><i class="fa fa-file-o"></i> Carnê</button>						
							</div>		
							<div class="col-12 col-md-6" style="padding: 5px;">
								<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdgeraretiquetatroca()"><i class="fa fa-tag"></i>Etq. troca</button>						
							</div>						
							<div class="col-12 text-center" style="padding: 5px; margin-top: 0px;">
                        		<button type="button" class="btn btn-secondary btn-sm btn-block" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
							</div>
						</div>
                    </div>                    
                </div>
            </div>
        </div>
		
        <!-- Modal do scannercode -->        
        <div class="modal static" id="mdlscannercode"  >
            <div class="modal-dialog modal-lg static">
                <div class="modal-content">         
                    <div id="#dvcamera">
                        <v-quagga v-if="mostrandomodal==true" :onDetected="mtdprocessacodbar" :readerSize="readerSize" 
                            :readerTypes="
                            ['code_128_reader',
                            'ean_reader', 
                            'ean_8_reader']">
                        </v-quagga>
                    </div>
                </div>
            </div>
        </div>	
		
		<!-- Modal impressão etiqueta de troca -->
		<div class="modal fade" id="mdetiquetatroca">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4  class="modal-title"><i class="fa fa-tag"></i> Selecione os produtos para etiqueta de troca</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="container">
							<div class="row">
								<div class="table-responsive">
									<table class="table table-bordered table-sm table-hover" style="margin-top: 15px">
										<thead class="thead-dark">
											<tr>
												<th @click.prevent="marcartodositens()">#</th>
												<th>Codigo</th>
												<th>Descrição</th>								
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in lstitensvendamarc" v-bind:key="index" style="font-size: 16px;">
												
												<td @click.prevent="marcaritemetiqueta(index)">
													<i v-if="parseInt(item.marcado)===0" style="cursor: pointer" class="fa fa-square-o"></i>
													<i v-else style="cursor: pointer" class="fa fa-check-square-o"></i>
												</td>

												<td>{{ item.idproduto }}</td>
												<td>{{ item.descproduto }}</td> 
											</tr>
										</tbody>                                        
									</table>
								</div>  
							</div>
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnsalvaritens" @click.prevent="mtdgeraretiquetastroca()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>

		<!-- Modal para reimpressão do pedido -->
		<div class="modal fade" id="mdbuscacomanda" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"> Buscar comanda</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-md-12">
								<label for="edultimopedido">Nr. da comanda:</label>
								<input type="number" v-model="vidcomanda"
									class="form-control form-control-sm" id="edcomanda">								
							</div>
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
						<div class="row">
							<div class="col-12" style="padding: 5px;">
								<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdconfirmabuscacomanda()"> Confirmar</button>						
							</div>
						</div>
                    </div>                    
                </div>
            </div>
        </div>
		<!-- Modal para edição da taxa -->
        <div class="modal fade" id="mdalterataxa">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 v-show="voptaxa===1" class="modal-title" style="font-size: 14px;">Alteração taxa de serviço</h6>
					<h6 v-show="voptaxa===2" class="modal-title" style="font-size: 14px;">Alteração taxa de entrega</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
							<label for="edvalortaxa">Valor da taxa:</label>
							<money type="text" class="form-control form-control-sm" id="edvalortaxa" v-model="vvalortaxaaltera" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmaalteracaotaxa()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>

		<!-- Modal para adicionar da taxa -->
        <div class="modal fade" id="mdcriartaxa">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                 
					<h6  class="modal-title" style="font-size: 14px;">Adicionar taxa</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
						<div class="col-md-12">
							<label for="cbtaxacriar">Taxa:</label>
								<select class="form-control form-control-sm" id="cbtaxacriar" v-model="vtaxacriar" >
									<option value="0">Serviço</option>
									<option value="1">Entrega</option>
								</select>
                        </div>
						<div class="col-md-12" v-show="parseInt(vtaxacriar) === 1">
								<span class="lblselect2">Entregador:</span>
								<select id="cbentregador" data-placeholder="Selecione um entregador" v-model="ventregador" data-allow-clear="true" style="width:100%;">
								</select>
                        </div>
                        <div class="col-md-12">
							<label for="edvalortaxa">Valor da taxa:</label>
							<money type="text" class="form-control form-control-sm" id="edvalortaxa" v-model="vvalortaxacriar" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmacriartaxa()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>
		<div class="modal fade" id="mdconsultaragendamentos">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-search"></i> Consulta de agendamentos pet</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Agendamento:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'######'" class="form-control form-control-sm" v-model="pidagendamentopet" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientepet" data-placeholder="Selecione um cliente" v-model="pidclientepet" data-allow-clear="true" style="width:100%;">
								</select>
							</div>										
							<div class="col-sm-12 col-md-2 col-lg-4">
								<span class="lblselect2">Pet:</span>
								<select id="cbpetpesq" data-placeholder="Selecione um pet" v-model="pidpet" data-allow-clear="true" style="width:100%;">
								</select>
							</div>												
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-1 col-lg-2">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()">
									<option value="0">Emissão</option>
									<option value="1">Agendamento</option>
								</select>
							</div>     
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                     
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesqpet">St. Agendamento:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="pstagendamentopet" @change="mtdlimpar_listagem()">
									<option value="0">Agendado</option>
									<option value="1">Remarcado</option>
									<option value="2">Cancelado</option>
									<option value="3">Todos</option>
								</select>
                            </div>  												
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="MtdExecutaPesquisaAgendamento()"><i class="fa fa-search"></i> Listar</button>
                            </div>
							<div id="dvlistagemagendamentos" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstagendamentoss"
                                        :rows="lstagendamentos"
                                        :columns="columnspet"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ mtdformatarzeros(item.row.idagendamento, 8) }} </span>
                                    </template>
                                    <template slot="slot_dtentrega" slot-scope="item">
                                        <span v-show="parseInt(item.row.entregapet) === 1" style="color: #6c757d; font-size: 12px;">{{ item.row.dtentrega }}</span>
                                    </template>                                                                    
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtemissao }}</span>
                                    </template>                                                                    
                                    <template slot="slot_dtagendamento" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtagendamento }}</span>
                                    </template>                                                                    
                                    <template slot="slot_stagendamento" slot-scope="item">
                                        <span v-if="parseInt(item.row.stagendamento) === 0"      class="badge badge-pill badge-primary bdg-agendado" style="">Agendado</span>
                                        <span v-else-if="parseInt(item.row.stagendamento) === 1" class="badge badge-pill badge-primary bdg-remarcado">Remarcado</span>
                                        <span v-else-if="parseInt(item.row.stagendamento) === 2" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
                                    <template slot="slot_stpagamento" slot-scope="item">
                                        <span v-if="parseInt(item.row.stpagamento) === 0"      class="badge badge-pill badge-primary bdg-aberto" style="">Aberto</span>
                                        <span v-else-if="parseInt(item.row.stpagamento) === 1" class="badge badge-pill badge-primary bdg-faturado">Faturado</span>
                                        <span v-else-if="parseInt(item.row.stpagamento) === 2" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
                                    <template slot="slot_totalgeral" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
                                    </template>
									<template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="MtdRetornoConsultaAgendamento(item.row.idagendamento)" style="width: 35px;">
											<i class="fa fa-hand-o-up"></i>
										</button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-4">
                                <v-pagination style="padding: 5px 10px 5px 10px;" class="border rounded"
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>            
                            </div>    
                            <div class="col-md-8">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstagendamentos.length}}</span>
                                    </li>
                                </ul>
                            </div>                            
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
	import ConsultarClientes from '../components/cmpconsultarclientes.vue'
	import BaixarTitulosReceber from '../components/cmpbaixartitulosreceber'
    import ConsultarPedidos from '../components/cmpconsultarpedidos.vue'
    import util from '../utilitarios/util.js'
	import DetalhesPedido from '../components/cmpdetalhespedido.vue'
	import VueQuagga from 'vue-quaggajs'	
	import AlertaCliente from '../components/cmpconteudoalertacliente.vue'		
	import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick-theme.css';
    import 'slick-carousel/slick/slick.js';
	import cadastrorapidocliente from '../components/cmpcadastrorapidocliente.vue'	

	//Luiz Trindade - Importação do componente do ifood
	import ListarPedidosIfood from '../components/cmplistarpedidosifood.vue'
	import io from 'socket.io-client'

    export default {
        name: 'cadinformacoescomplementares',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
			'consultaprodutos'  	: ConsultarProdutos,
			'consultaclientes'  	: ConsultarClientes,
			'baixartitulosreceber'  : BaixarTitulosReceber,
            'consultapedidos'   	: ConsultarPedidos,
			'detalhespedido'  		: DetalhesPedido,
			'alertacliente'			: AlertaCliente,
			'listarpedidosifood'	: ListarPedidosIfood,
			cadastrorapidocliente,
			VueQuagga
        },
        data: function() {
            return {
				utodasfiliais 		: this.$store.state.usuario.todasfiliais,
				planocliente		: 1,
                //variáveis do leitor de código de barras
                mostrandomodal      : false, 
                readerSize: {
                    width: 640,
                    height: 480
                },
                detecteds           : [],				
				//variável para detalhes do pedido
				vidpedidodet : '',
				/////////////////////				
				resumoformas		: false,
				pathimgview         : this.$store.state.configpaths.pathimagens,
				vlogovisualizar		: '',
				fechamentocego		: false,

				statusaxios			: '',
				
                vshowprtabela		: true,
				tipopropesquisa     : '0, 2',

                lstpdvs             : [],
                lancamentomenu      : [],
                lancamentousu       : [],
                lacamentobackup     : [],
                pfiltro             : 1,
                pconteudo           : '',
                pidfilial           : null,
                pidpdv              : null, 
                pidusuario          : null,
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				
				psituacao	 		: 2,                  
                pqtdregistros       : 10,
                pqtd_paginas        : 1,
                pagina_atual        : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud                  :  0,
                vid                     : '',
                vidpdv                  : null,
                vidforma                : null,
                vvalorabertura          : 0,
                vobservacoes            : '',
				vidperfilfluxo			: null,
				
				//variavel aba pet
				lstagendamentos			: [],
				pidagendamentopet		: '',
				pidclientepet			: null,
				pidpet					: null,
				pfiltropor				: 0,
				pstagendamentopet		: 0,
				nomeEntregador			: '',
				

				//variável do último pedido
				vidultimopedido			: '',

                //variável para habilitação dos campos
                ativadesativa           : true,

                //variáveis da venda
                vidplanoinicial     : null,
                vidfilial           : null,
				vidplano			: null,
				vtipoplano			: 0,
				vdescplano			: '',                
				vidtabela           : 1,
				vpercentrada		: 0,
				vpermitedesconto	: 0,				
				vgerarnfce			: true,
                vidpedido           : '',
                vidagendamentopet   : '',
				vidcliente			: '',
				vnomecliente		: '',
				vvlcreditodisponivel: 0,
				vdoccli				: '',
                vidvendedor			: null,
				vliberarfat			: 0,
				vexigirentrada      : 0, 
				vpercentradacli     : 0,


				//mostrar o cashback disponivel quando houver
				vltotalcashback		: 0,
				vlcashbackdisponivelvenda: 0,	
				sringaleatoria          : '',		
				vseltrocovirtual    : null,

				//variaveis cashback liquidez e trocovirtual	

				ativacashbackliquidez      : 0,
				fatorliquidez              : 0,
				trocovirtual               : 0,
				vidperfiltrocovirtualvenda : 0,
			    vidperfiltrocovirtualreceb : 0,   


				//variaveis balanca
				vativarbalanca		: 1,
				vlayoutbalanca		: 1,
				vdigitosbalanca	    : 6,
				vvalorbalanca 		: 0,
				vquantbalanca 		: 0,
				
                vnomevendedor       : '',
				vtipo				: 0,
                vdtemissao			: util.DataAtual(),                
				vtotalprodutos		: 0,
				vtotalservicos		: 0,
				videntificador		: '',
				vobjeto				: '',
				vmarcacao			: '',
				vnrserie			: '',
				vmarca				: '',
				vmodelo				: '',
				vresponsavel		: '',
				vfone				: '',
				vdefeitoapresentado	: '',
				vacessorios			: '',
				voutrasinformacoes	: '',
				vobservacoes		: '',
				vtotalgeral			: 0,
				vstpedido			: 0,
				vreservar			: 0,
				ventregaexterna		: 0,
				vorigem				: 1,
				lstitens			: [],
				lstservicos			: [],
                lstplanos			: [],


				//var
				metodochamado      : '', //nome do metodo chamado para mudar a variavel que eu estou assistindo


				//variaveis oculos
				vativainfooculos        : 0,
				vesfericoesquerdoperto  : 0,
				vcilindricoesquerdoperto: 0,
				veixoesquerdoperto      : 0,
				vadicaoesquerdoperto    : 0,

				vesfericodireitoperto   : 0,
				vcilindricodireitoperto : 0,
				veixodireitoperto       : 0,
				vadicaodireitoperto     : 0,

				vesfericoesquerdolonge  : 0,
				vcilindricoesquerdolonge: 0,
				veixoesquerdolonge      : 0,
				vadicaoesquerdolonge    : 0,

				vesfericodireitolonge   : 0,
				vcilindricodireitolonge : 0,
				veixodireitolonge       : 0,
				vadicaodireitolonge     : 0,

				vdptotal                : 0,

				//Variável de edição dos ítens do pedido
				vvltotal_old_edicao		: 0,//somente para a alteração
				alteraentra           	: false,
				vedicaodescpro			: true,
				vitem					: 0,
				vitemalteracao			: 0,
				vtitdesc              	: 'Descto.(%):',
				vopitem					: 0,							
				vidprodutoedicao    	: '',
				vcoddigedicao			: '',
				vdescricaoprodutoedicao : '',
				vundprodutoedicao		: '',
				vqtditemedicao			: 1,
				vvltabelaitemedicao		: 0,
				vvlunitarioedicao		: 0,
				vprvendaminimo			: 0,
				vdescacresedicao		: 0,
				vtipodescacresedicao	: 0,
				vvalordescacresedicao	: 0,
				vmanipulavaledicao		: 0,
                vvltotaledicao			: 0,
                videstoqueedicao		: null,
				vfracionadoedicao		: 0,
				vinfadprodedicao		: '',		
				vqtdminimodescedicao    : 0,
				vvldescontoqtdmin       : 0,
				vldescontopromocional   : 0,
				
				//variáveis de edição dos serviços
				vprecoservicoedicao			: [],
				vtitdescserv          		: 'Descto.(%)',				
				vidservicoedicao			: null,
				vidtecnicoedicao			: null,
				vqtdservicoedicao			: 1,
				vvlservicoedicao			: 0,
				vtipodescontoservicoedicao	: 0,
				vvalordescontoservicoedicao	: 0,
				vvltotalservicoedicao		: 0,

				//variaveis do lançamento rapido e comanda
				lstitensbotoes              : [],
				lstbotoes                   : [], 
				vidcomanda                  : 0, 
				vbotoesrapidos              : 0,
				lstcomandasvenda            : [],  
				vtottaxaservico             : 0, 
				vtottaxaentrega             : 0,
				voptaxa                     : 0,
				vvalortaxaaltera            : 0,   
				vtaxacriar                  : 0,
				ventregador                 : null,
				vvalortaxacriar             : 0,

				//variaveis de perfil
				pmanipularvaloritem : false,
				pdefinirestoque		: false,
				palterarvendedor	: false,

				//variáveis aplicação do desconto no total dos ítens
				vtotalsemdesconto	: 0,
				vtotalcomdesconto   : 0,
				vtipodesctotal		: 0,	
				vfatordescontototal	: 0,
                vresdesconto		: 0,


				//acrescimo
				vtotalsemacrescimo  : 0,
				vtipoacresctotal    : 0,
				vresacrescimo       : 0,
				vtotalcomacrescimo  : 0,
				vfatoracrescimototal: 0,
                
                desativaidpro       : false,

				//variáveis de definições da venda
				didcliente			: '',
				dnomecliente		: '',
				didvendedor			: null,
				dlstplanos			: [],
				didplano			: null,
				dobservacoes		: '',
				dvlcreditodisponivel: 0,
				dexigirentrada      : 0,
                dpercentrada        : 0,  
				dimgcliente         : this.$store.state.configpaths.pathimagens+'imagens/semimagem.png',

				//variaveis do fechamento da venda
				temtrocadev			: false,
				lstformasfaturar	: [],
				lsttitulosfaturar	: [],
				pedidofaturar		: [],
				vdtfatura			: util.DataAtual(),
				vidformapagamento	: null,
				vvlforma			: 0,
				vtipoforma			: 0,
				vespecieforma		: 0,
				vfiscalautomatico   : 0,
				vabatecredito		: 0,
				vnrvendaforma		: '',
				vqtdparcelascartao	: 1,
				vnsu				: '',
				vtotaltitulos		: 0,
				vtotalformas		: 0,
                vdiferenca			: 0,
                
				//variáveis da alteração do título
				tindiceparcela		: 0,
				tacodtit 			: '',
				tadtventit			: '',
				tavltit				: 0,
				taidtipocobranca	: null,
				tatipocobranca		: 0,// 0 - Normal 1 - Cheque
				tadescricaocob		: '',
				tanumerocheque		: '',
				taidbanco			: null,
				tadescbanco			: '',
				taagencia			: '',
				taconta				: '',
				tapraca				: '',
				taemitente			: '',
				tacnpjcpf			: '',						
				taidsituacaocheque	: null,
                tadescsituacaocheque: '',
				tajustarparcelas	: false,//recalcula as parcelas restantes
				tajustarcentavos 	: false,//ajusta os centavos para a ultima parcela
				tajustardatas		: false,//determina se as demais datas serão ajustadas para o mesmo dia

				//variáveis dos movimentos do caixa
				opmovcx				: 0,
				descmovcx           : '',
				idgruposaidapdv		: null,
				valormovcx          : 0,
				idformamovcx        : null,
				vidperfilfluxomovcx : null,

				//variáveis para o recebimento de clientes
				lsttitulos          : [],
				rdtbasebaixa        : util.DataAtual(true),
				rotinarecebimento   : false,	
				ridcliente			: '',
				rnomecliente		: '',
				ridpedido			: '',
				rdtultrecebimento   : '',
				rvalorultrecebimento: '',
				vidfilialrecebimento: null,
                //variaveis de somas totais
                vrVencidos          : 0,
                vrAvencer           : 0,
                vrJuros             : 0,
                vrMulta             : 0,
                vrTotal             : 0,
				vrTotcancelados     : 0,
                //variáveis para os totais dos selecionados
                vqtdtitsel          : 0,
                vTotalPagarSel      : 0,
                vTotalJurosSel      : 0,
                vTotalMultaSel      : 0,
				vTotalGeralSel      : 0,
                //baixa de titulo
				vidclientebaixa			 : 0,
                idnomeclientebaixa       : '',
                valdescontojuros         : 0,
                valdescontomulta         : 0,
                vvariaveisbaixar : {
                    vtottitbaixa         : 0,
                    vtotmultabaixa       : 0,
                    vtotjurosbaixa       : 0,
                    vtotpagarbaixa       : 0,
                    lstselecionadosbaixa : [],
                    vvalorrecebimento    : 0,
				},
				
				//variáveis do fechamento do caixa
				lstformasfechamento		 : [],
				vsomavaloresfechamento	 : 0,
				vsomavaloresregistrados	 : 0,
				vvldiferencafechamento	 : 0, 

				//variáveis para visualização dos lancamentos
				lancamentosmov			 : [],
				
				lentradas				 : [],
				ltotalentradas			 : 0,
				lrecebimentos			 : [],
				ltotalrecebimentos		 : 0,	
				lpedidos				 : [],
				lformasvendas			 : [],
				lformasrecebimentos		 : [],
				ltotaldescontos			 : 0,
				ltotalpedidos			 : 0,
				ltotalpedidoscancelados  : 0,
				lqtdpedidoscancelados	 : 0,
				lstresumorecebimentofil  : [],	
				ltotalrecebimentosfil    : 0,			
				lsaidas					 : [],
				ltotalsaidas			 : 0,
				lfechamento				 : [],
				lformas					 : [],
				ltotalregistrado		 : 0,
				ltotalfechamento		 : 0,
				ltotaldiferenca			 : 0,


				//variavel de identificação do consumidor
				docclitmp				 : '', 

				//variáveis devolução/troca
				vrotinadevolucao		 			: false,
				vcoddigdev 				 			: '',
				vidprodutodev			 			: '',
				vdescricaoprodutodev     			: '',
				vundprodutodev			 			: '',
				vqtditemdev			 	 			: 1,
				vfracionadodev			 			: 0,
				vvlunitariodev			 			: 0,
				vvtotaldev				 			: 0,
				vnrvenda				 			: '',	

				//variaveis para etiqueta de troca
				lstitensvendamarc    			    : [],
				
				//perfil do fluxo
				vidperfilfluxoforma   	 			: null,
				vdescperfilfluxoforma 	 			: '',  				
				
                //alteração perfil fluxo
                aindiceperfilfluxo      			: 0,
                aidperfilfluxo          			: 0,
                adescperfilfluxo        			: '',
				origemperfil						: 0,//0 - vendas, 1 - recebimentos

				//variáveis de correção do fechamento
				opeditarfechamento					: false,//verifica no perfil do usuário para aparecer o botão de ediçao
				veditarfechamento					: false,
				lstformasedicaofechamento 			: [],
				ltotalregistradoedicaofechamento 	: 0,
				ltotalfechamentoedicaofechamento 	: 0,
				ltotaldiferencaedicaofechamento  	: 0,	
				
				//variavel alerta cliente
				vidclientealerta					: 0,

				//Luiz Trindade - lstExternalCodesPdvCodes
				lstExternalCodesPdvCodes			: [],
				conexaoSIO							: null,
				qtdPedidosBadge						: 0,
				lstPedidosIfoodSocketIO				: [],
				lstPedidosIfoodAnterioresSocketIO	: [],
				lstOrderDetailsIO					: [],
				clientID       						: '',
				clientSecret   						: '',
				merchantId     						: '',

				//cadastrorapido
				vidfilialcadrapido                  : null,
				vdescfiliacadrapido                 : '',

                options: {
                    format          : 'DD/MM/YYYY',
                    useCurrent      : false,
                    locale          : 'pt-BR'
                },
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'LANÇAMENTOS PDV',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "PDV",
                        name: "descpdv",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Usuário",
                        name: "nomeusu",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Dt. Abertura",
                        name: "dtabertura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Situação",
                        name: "situacaopdv",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: 'slot_situacaopdv',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },                     
                    {
                        label: "Dt. Fechamento",
                        name: "dtfechamento",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                                       
                    {
                        label: "Fr. Abertura",
                        name: "descforma",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                                       
                    {
                        label: "Vl. Abertura",
                        name: "valorabertura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: 'slot_valorabertura',
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Fechamento",
                        name: "valorabertura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: false,
                        slot_name: 'slot_especie',
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
						row_classes: "def-col-forma-fechamento"
                    }                    
				],
				columnspet: [
					{
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Agendamento",
                        name: "idagendamento",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "id_f",
                        row_classes: "def-col-nragendamento",
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pet",
                        name: "nomepet",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt.Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt.Agendamento",
                        name: "dtagendamento",
                        sort: true,
                        slot_name: "slot_dtagendamento",
                        row_classes: "def-col-dtagendamento",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
						label: "St. Agendamento",
                        name: "stagendamento",
                        sort: true,
                        slot_name: "slot_stagendamento",
                        row_classes: "def-col-stagendamento",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },
					{
						label: "Total",
						name: "totalgeral",
						sort: true,
						slot_name: "slot_totalgeral",
						row_classes: "def-col-total",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left"
					},
                ],
                columnstitulos: [
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: false,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: false,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Restante",
                        name: "vlresta",
                        sort: false,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
                    {
                        label: "Atraso",
                        name: "atraso",
                        sort: false,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Juros",
                        name: "vljuros",
                        sort: false,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                                                              
                    {
                        label: "Multa",
                        name: "vlmulta",
                        sort: false,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    { 
                        label: "À receber",
                        name: "vlapagar",
                        sort: false,
                        slot_name: "slot_vlapagar",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "",
                        name: "idpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    }					                                        
                ],				
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
				},
                configtitulos: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    rows_selectable: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },				
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
			mtdtaxaacrescimo(){ // adiciona a taxa de acrescimo ao total da venda
				if(parseFloat(this.lancamentousu.plano.percentualacrescimo) > 0){
					let tot = parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);
					
					this.vtottaxaservico  = tot * parseFloat(this.lancamentousu.plano.percentualacrescimo) /100;
					this.vtotalgeral	  = parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtottaxaentrega) + parseFloat(this.vtottaxaservico);
				}
			},
			mtdverificaliberavend(){
				if(this.vidpedido){//verifica se o valor esta vazio 
					return util.opcaousuario('020Z.015Z.230Z', this.$store.state.perfilusuario)
				}else{
					return true;
				}
			},
			mtdopcaousuario(op){
				return util.opcaousuario(op, this.$store.state.perfilusuario)
			},
			mtdarmazenar(){
				let vself = this;
               $.confirm({
					title: 'Confirmação!',
					content: 'Deseja mesmo arameznar essa venda?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: 'Sim',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								vself.mtdarmazenavenda();
							}
								
						},
						nao: {
							text: 'Não',
							keys: ['n', 'N'],
							action: function () {
								
							}
						}
					}
				});
			},
			mtdarmazenavenda(){
				let vself = this;
				setTimeout(() => {
					//let loader 	= vself.$loading.show();
					vself.statusaxios		= 'Armazenando a venda a venda! Aguarde...';
					$('#mdstatusaxios').modal('show');
					let registrocrud = {
						'id'                		: this.vidpedido,
						'idfilial'          		: this.vidfilial,
						'idcliente'					: this.vidcliente,
						'doccli'					: this.vdoccli,
						'idvendedor'				: this.vidvendedor,
						'tipo'						: this.vtipo,
						'dtemissao'					: this.mtdformatadatagravar(this.vdtemissao),
						'idplano'					: this.vidplano,
						'totalprodutos'				: this.vtotalprodutos,
						'totalservicos'				: this.vtotalservicos,
						'identificador'				: this.videntificador,
						'objeto'					: this.vobjeto,
						'marcacao'					: this.vmarcacao,
						'nrserie'					: this.vnrserie,
						'marca'						: this.vmarca,
						'modelo'					: this.vmodelo,
						'responsavel'				: this.vresponsavel,
						'fone'						: this.vfone,
						'defeitoapresentado'		: this.vdefeitoapresentado,
						'acessorios'				: this.vacessorios,
						'outrasinformacoes'			: this.voutrasinformacoes,
						'observacoes'				: this.vobservacoes,
						'totalgeral'				: this.vtotalgeral,
						'totfrete'				    : this.vtottaxaentrega,
						'identregador'				: this.ventregador,
						'tottaxaservico'			: this.vtottaxaservico,
						'stpedido'					: 0,
						'dtfatura'					: '',
						'reservar'					: this.vreservar,
						'entregaexterna'			: this.ventregaexterna,
						'origem'					: this.vorigem,
						'itens'						: this.lstitens,
						'servicos'					: this.lstservicos,
						
				
						'esfericoesquerdoperto'	 	: this.vesfericoesquerdoperto,
						'cilindricoesquerdoperto'	: this.vcilindricoesquerdoperto,
						'eixoesquerdoperto'		 	: this.veixoesquerdoperto,
						'adicaoesquerdoperto'	 	: this.vadicaoesquerdoperto,

						'esfericodireitoperto'	 	: this.vesfericodireitoperto,
						'cilindricodireitoperto' 	: this.vcilindricodireitoperto,
						'eixodireitoperto'		 	: this.veixodireitoperto,
						'adicaodireitoperto'	 	: this.vadicaodireitoperto,

						'esfericoesquerdolonge'	 	: this.vesfericoesquerdolonge,
						'cilindricoesquerdolonge'	: this.vcilindricoesquerdolonge,
						'eixoesquerdolonge'		 	: this.veixoesquerdolonge,
						'adicaoesquerdolonge'	 	: this.vadicaoesquerdolonge,

						'esfericodireitolonge'	 	: this.vesfericodireitolonge,
						'cilindricodireitolonge' 	: this.vcilindricodireitolonge,
						'eixodireitolonge'		 	: this.veixodireitolonge,
						'adicaodireitolonge'	 	: this.vadicaodireitolonge,
						'ativainfooculos'           : this.vativainfooculos,
						'dptotal'                   : this.vdptotal,      

					};
					
					let parametros      = [
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           	valor : 'rotinacrud'},
						{parametro: 'opcrud',       	valor : 1},
						{parametro: 'registro',     	valor : JSON.stringify(registrocrud)},
						{parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        	valor : '020Z.010Z.010Z'},
						{parametro: 'straleatoria',     valor : util.GerarStringAleatoria()},
						{parametro: 'faturarsemsaldo',	valor : util.opcaousuario('020Z.010Z.090Z', this.$store.state.perfilusuario) === false ? 0 : 1},
						{parametro: 'idpdv',        	valor : this.lancamentousu.idpdv},
					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						//loader.hide();					
						if ($.isNumeric(response.data.inf)){
								setTimeout(function(){
								$('#mdstatusaxios').modal('hide');
								vself.$toastr.s('Venda nr: '+response.data.inf+'  armazenada com sucesso!', 'Informação')
							}, 500);
						
							vself.mtdlimparvenda(false, vself.mtdatribuirplano, true);
						}else{
							setTimeout(function(){
								$('#mdstatusaxios').modal('hide');
							}, 500);
							let tpret = response.data.inf.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
									//vself.$toastr.e('Erro ao tentar enviar a NFC-e. Favor entrar no módulo de GERENCIAMENTO DE NOTAS para verificação do problema.', 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						//loader.hide();
						setTimeout(function(){
							$('#mdstatusaxios').modal('hide');
						}, 500);
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});					
				}, 200);
			},
			mtdchamacadastrorapido(){
				if(!util.opcaousuario('002Z.003M.001M', this.$store.state.perfilusuario)){
					this.$toastr.i('Não permitido para o seu usuário', 'Atenção!');
					return;
				}
				this.vidfilialcadrapido    = this.lancamentousu.idfilial;
				this.vdescfiliacadrapido   = this.lancamentousu.fantasia;
				$('#mdCadastroRapidoCliente').modal('show');
			},
			mtdquestionaratzcliente(){
				let vself = this;
				if(parseInt(vself.lancamentousu.atzclientepdv) === 1){
					$.confirm({
						title: 'Confirmação!',
						content: 'Deseja atualizar o cadastro desse cliente?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: 'Sim',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									window.open(vself.$router.resolve({ name: 'cadclientes', query:  {idcliente: vself.didcliente} }).href, '_blank');
								}
									
							},
							nao: {
								text: 'Não',
								keys: ['n', 'N'],
								action: function () {
									
								}
							}
						}
					});
				}
				
			},
			mtdrotinafinalizafechamento(){
				//atualizar movimento

				let vself = this;
				let loader = vself.$loading.show();
				let temdif = 0;		

				if (parseFloat(vself.lancamentousu.fatordiferenca) > 0){
					for (let i = 0; i < vself.lstformasfechamento.length; i++) {										
						let vlf = parseFloat(vself.lstformasfechamento[i].valorfechamento) < 0 ? parseFloat(vself.lstformasfechamento[i].valorfechamento) * (-1): parseFloat(vself.lstformasfechamento[i].valorfechamento);
						let vlr = parseFloat(vself.lstformasfechamento[i].valorregistrado);
						let dif = vlr - vlf;
						dif  	= dif < 0 ? dif * (-1) : dif;
						if (parseInt((parseFloat(dif)) * 100) > parseInt(vself.lancamentousu.fatordiferenca * 100)){																				
							temdif = 1;
							break;
						}
					}
					//verifica no final em se tem diferença no montante
					vself.vvldiferencafechamento = vself.vvldiferencafechamento < 0 ? vself.vvldiferencafechamento * (-1) : vself.vvldiferencafechamento;									
					if (temdif === 0){
						if (parseInt((parseFloat(vself.vvldiferencafechamento)) * 100) > parseInt(parseFloat(vself.lancamentousu.fatordiferenca) * 100)){
							temdif = 1;
						}	
					}
				}
				let movimento = {
					'idlancamentopdv' 	: vself.lancamentousu.id,
					'desclancamento'	: 'FECHAMENTO DO CAIXA',
					'tpmovimento'		: 4,
					'idforma'			: 0,
					'valor'				: vself.vsomavaloresfechamento,
					'formas'			: vself.lstformasfechamento									
				};
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'movimentocaixa'},
					{parametro: 'movimento',    valor : JSON.stringify(movimento)},
					{parametro: 'temdif',    	valor : temdif},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        valor : '020Z.015Z.110Z'},//verificar o perfil depois
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						vself.$toastr.s('Caixa fechado com sucesso!', 'Informação!');
						$('#mdfechamento').modal('hide');
						//rotina para a impressão do documento
						vself.mtdimprimirmovimentocaixa(vself.lancamentousu.id, response.data, 1);//tpimp: 0 - A4, 1 - térmica
						vself.mtdfecharlancamentospdv();
						vself.mtdexecutapesquisa();
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
			MtdRetornoConsultaAgendamento(idagendamento) {
				var vself = this;
				let parametros = [
					{ parametro: 'idclientesac', 	valor: vself.$store.state.filialpadrao.idcliente },
					{ parametro: 'op', 				valor: 'consultagendamento' },
					{parametro: 'infcredito',   	valor : '1'},
					{ parametro: 'filtro', 			valor: idagendamento }
				];

				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadlancamentospdvs.php');
				retorno.then((response) => {
					let agendamentos = response.data.agendamentos;

					if (agendamentos.length > 0) {
						let agendamento = agendamentos[0];

						let itens = agendamento.itens;
						let servicos = agendamento.servicos;
						vself.processarLancamento(agendamento, itens, servicos); 
						$('#mdconsultaragendamentos').modal('hide');
					} else {
						console.log('Nenhum agendamento encontrado.');
					}
				}).catch((error) => {
					alert("Erro ao retornar agendamento: " + error); 
				});
			},
			MtdLimpaCamposAgendamento(){
				this.lstagendamentos   		= [];
				this.pidagendamentopet   	= '';
				this.pidclientepet   		= null;
				this.pidpet   				= null;
				this.pfiltropor   			= 0;
				this.pstagendamentopet   	= 0;
				this.pfiltroperiodo         = 1;
				this.pdtini       		    = util.DataAtual(true);
				this.pdtfim       		    = util.DataAtual(true);				
				this.pqtdregistros		    = 10;
				this.pqtd_paginas 		    = 1;
				this.pagina_atual 		    = 1;
			},
			MtdFiltroPesquisaPet(){
				let vself = this;
                let rfiltro = '';
				//filtros obrigatórios para exibir no lançamento
				rfiltro = ' and fil.codfil='+vself.vidfilial;
				rfiltro = rfiltro + ' and ag.liberarpdv=1';
				rfiltro = rfiltro + ' and ag.stpagamento=0';
				//
				if (vself.pidagendamentopet !== ''){
					rfiltro = rfiltro +' and ag.idagendamento='+vself.pidagendamentopet;
				}
                if (vself.pidclientepet){
					rfiltro = rfiltro +' and ag.idcliente='+vself.pidclientepet;
                }    
                if (vself.pidpet){
					rfiltro = rfiltro +' and p.idpet='+vself.pidpet;
                }    
				if (parseInt(vself.pstagendamentopet) < 3){
					rfiltro = rfiltro +' and ag.stagendamento='+vself.pstagendamentopet;
				}
				if(parseInt(vself.pfiltroperiodo) === 1){
					if (parseInt(vself.pfiltropor) === 0){
						rfiltro = rfiltro + ' and ag.dtemissao between "' + util.InverterData(vself.pdtini) + '" and "' + util.InverterData(vself.pdtfim) + '"';
					}else{
						rfiltro = rfiltro + ' and ag.dtagendamento between "' + util.InverterData(vself.pdtini) + '" and "' + util.InverterData(vself.pdtfim) + '"';
					}
				}      
                return rfiltro;
            },
            MtdExecutaPesquisaAgendamento(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}				
                let filtro          = vself.MtdFiltroPesquisaPet();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistrospet'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistrospet);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.MtdCarregaAgendamentos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
			MtdCarregaAgendamentos(ipagina){
				var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.MtdFiltroPesquisaPet();
                let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagempet'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    // {parametro: 'filial',       valor : vself.},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    vself.lstagendamentos 	= response.data.agendamentos;
                    vself.ptotalcusto 		= response.data.totalcusto;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstagendamentos 	= [];
                    loader.hide();
                });
            },
			processarLancamento(agendamento, itens, servicos) {
				let vself = this;
				if (itens && itens.length > 0) {
					for (let i = 0; i < itens.length; i++) {
						let item = itens[i];
						if (util.findValInArray(vself.lstitens, 'coddig', item.coddig)) {
							vself.$toastr.w('Produto já lançado na venda!', 'Atenção!');
							return;
						}

						let produto = {
							coddig:        item.coddig,
							idproduto:     item.idproduto,
							item:          item.item,
							descproduto:   item.descproduto,
							qtditem:       item.qtditem,
							vlunitario:    item.vlunitario,
							unditem:       item.unditem,
							vltotal:       item.vltotal,
							manipulaval:   0,
							descacres:     0,
							tipodescacres: item.tipodescacres,
							estoques:      item.estoques,
							valordescacres: item.valordescacres,
							idestoque:     item.idestoque,
							descestoque:   item.descestoque,
							infadprod:     '',
							qtdentregar:   item.qtdentregar,
							nrvenda:       '',
							adesivo         : '',
							descadesivo     : '',
							coradesivo      : ''

							
						};

						vself.lstitens.push(produto);
						vself.vtotalprodutos += parseFloat(item.vltotal); 
						vself.metodochamado = vself.metodochamado + ' processarLancamento';
					}
				}

				if (servicos && servicos.length > 0) {
					for (let i = 0; i < servicos.length; i++) {
						let servico = servicos[i];
						if (util.findValInArray(vself.lstservicos, 'idservico', servico.idservico)) {
							vself.$toastr.w('Serviço já lançado na venda!', 'Atenção!');
							return;
						}

						let novoServico = {
							idservico:      servico.idservico,
							descservico:    servico.descservico,
							qtdservico:     servico.qtdservico,
							vlservico:      servico.vlservico,
							tipodesconto:   servico.tipodesconto,
							valordesconto:  servico.valordesconto,
							vltotal:        servico.vltotal,
							idtecnico:      servico.idtecnico,
							nometecnico:    servico.nometecnico,
						};

						vself.lstservicos.push(novoServico);
						vself.vtotalservicos += parseFloat(servico.vltotal); 
					}
				}

				vself.vtotalgeral = vself.vtotalprodutos + vself.vtotalservicos;

				vself.vidpedido          	= '';
				vself.vidagendamentopet     = agendamento.idagendamento;
				vself.vidcliente			= agendamento.idcliente;
				vself.vnomecliente			= agendamento.nomecliente;
				vself.vvlcreditodisponivel 	= agendamento.vlcreditodisponivel;
                vself.vidvendedor			= agendamento.idvendedor;
                vself.vnomevendedor      	= agendamento.nomevendedor;
				vself.vdtemissao			= agendamento.dtemissao;
				vself.vtotalprodutos		= agendamento.totalprodutos;
				vself.vtotalservicos		= agendamento.totalservicos;
				vself.vtipo					= 2;
				// vself.vresponsavel		= agendamento.responsavel;
				// vself.vobservacoes		= agendamento.observacoes;
				vself.vtotalgeral			= agendamento.totalgeral;
				vself.vstpedido				= agendamento.stpagamento;
				// vself.lstitens			= agendamento.itens;
				// vself.lstservicos		= agendamento.servicos;			
				vself.vitem					= agendamento.itens.length === 0 ? 0 : agendamento.itens[agendamento.itens.length - 1].item;		
				vself.vidplano				= agendamento.idplano;
				vself.vtipoplano			= agendamento.tipoplano;
				vself.vdescplano			= agendamento.descplano;
                vself.vidtabela				= agendamento.idtabela;
				vself.vpercentrada			= agendamento.percentrada;
				vself.vpermitedesconto		= agendamento.permitedesconto;	

                vself.vdtfatura          	= util.DataAtual(true);
			},
			mtdselect2_def(){
                let vself = this;
				vself.mtdajustestela();
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';


				let sqlinipdv     = parseInt(vself.utodasfiliais) === 0 ? 'SELECT pdv.id, pdv.descricao FROM tbpdvs pdv LEFT JOIN tbfiliaisusuario  fu ON fu.idfilial = pdv.idfilial ' : 'SELECT pdv.id, pdv.descricao FROM tbpdvs pdv ';
                let sqlfimpdv     = parseInt(vself.utodasfiliais) === 0 ? ' where upper(pdv.descricao) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		      : ' where upper(pdv.descricao) like upper("%@@%")';
                
				$('#mdlscannercode').on('hide.bs.modal', function (e) {
                    vself.mostrandomodal = false
                });


				
                $('#mdconsultarproduto').on('hide.bs.modal', function (e) {
                    vself.mtdfecharconsulta();
                });	

				$('#mdedicaoitem').on('hide.bs.modal', function (e) {
					vself.mtdlimparedicaoitem();	
				});
				
				$('#mdconsultaragendamentos').on('hide.bs.modal', function (e) {
					$('#edidpedidopesq').focus();	
				}); 
								
				$('#mdfinalizarvenda').on('hide.bs.modal', function (e) {
					vself.temtrocadev      = false;
					vself.vseltrocovirtual = false;
				}); 
				
				$('#mdbuscacomanda').on('shown.bs.modal', function (e) {
					$('#edcomanda').focus();
                });

				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					$('#edqtditemedicao').focus();
                }); 
			
				$('#mdidentificaconsumidor').on('shown.bs.modal', function (e) {
					$('#eddoccli').focus();
                }); 								
				$('#mdaplicardesconto').on('shown.bs.modal', function (e) {
					$('#cbtipodesctotal').focus();
				});
				$('#mddefinircoesvenda').on('shown.bs.modal', function (e) {
					if (parseInt(vself.didcliente) === 1){
						$('#eddcliente').focus();
					}else{
						$('#cbplanodef').focus();
					}					
				}); 
				
				$('#mdmovimentoscaixa').on('shown.bs.modal', function (e) {
					$('#eddescmovcx').focus();
                });

				$('#mdreimpressaopedido').on('shown.bs.modal', function (e) {
					$('#edultimopedido').focus();
                });

				$('#mdfechamento').on('shown.bs.modal', function (e) {
					let loader      			= vself.$loading.show();
					let parametros  			= [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           	valor : 'listarmovimentos'},
						{parametro: 'idlancamentopdv', 	valor : vself.lancamentousu.id}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
					retorno.then(function (response) {
						vself.lstformasfechamento = response.data.formas;
						if (!vself.fechamentocego){
							for (let i = 0; i < vself.lstformasfechamento.length; i++) {								
								vself.lstformasfechamento[i].valorfechamento = vself.lstformasfechamento[i].valorregistrado;
							}
						}
						loader.hide();
						setTimeout(function(){
							$('#edvalorformafechamento').focus();
						}, 500);						
					}).catch(function (response) {
						vself.lstformasfechamento = [];
						loader.hide();
					});									
				}); 				
				
				$('#mdlistamovimentos').on('hide.bs.modal', function (e) {
					vself.mtdcancelaredicaofechamento();
					vself.lancamentosmov		 = [];
					vself.lentradas				 = [];
					vself.lrecebimentos			 = [];
					vself.lpedidos				 = [];
					vself.lformasvendas			 = [];
					vself.lformasrecebimentos	 = [];
					vself.lsaidas				 = [];
					vself.lstresumorecebimentofil= [];
					vself.ltotalrecebimentosfil  = 0; 
					vself.lfechamento			 = [];
					vself.lformas				 = [];
					vself.ltotaldescontos		 = 0;
					vself.ltotalregistrado		 = 0;
					vself.ltotalfechamento		 = 0;
					vself.ltotaldiferenca		 = 0;
				}); 

				$('#mddevolucaotroca').on('shown.bs.modal', function (e) {
					let payloadx = {
						idproduto    : null			
					};
					vself.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);  					
					vself.vrotinadevolucao		= true;
					vself.vcoddigdev 			= '';
					vself.vidprodutodev			= '';
					vself.vdescricaoprodutodev 	= '';
					vself.vqtditemdev			= 1;
					vself.vnrvenda				= '';
					$('#edidprodutodev').focus();
                }); 
				$('#mddevolucaotroca').on('hide.bs.modal', function (e) {
					let payloadx = {
						idproduto    : null			
					};
					vself.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx); 					
					vself.vcoddigedicao 		= '';
					vself.vidprodutoedicao   	= '';					
					vself.vcoddigdev 			= '';
					vself.vidprodutodev			= '';
					vself.vdescricaoprodutodev 	= '';					 					
					vself.vrotinadevolucao		= false;
					$('#edlidproduto').focus();
				}); 			
				
				$("#cbperfilfluxopdv").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxo = $("#cbperfilfluxopdv").val();
                });

				$("#cbperfilfluxomovcx").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidperfilfluxomovcx = $("#cbperfilfluxomovcx").val();
                });				
				
				$("#cbvendedordef").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbvendedores',
                                c1: 'id',
                                c2: 'nome'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.didvendedor = $("#cbvendedordef").val();
				});


				$("#cbvendedorfinalvenda").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbvendedores',
                                c1: 'id',
                                c2: 'nome'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidvendedorfinal = $("#cbvendedorfinalvenda").val();
				});

				$("#cbfilialrecebimento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbfiliais',
                                c1: 'codfil',
                                c2: 'fantasia'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidfilialrecebimento = $("#cbfilialrecebimento").val();
				});


				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
                });
                $("#cbpdvpesq").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbpdvs',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.pidpdv = $("#cbpdvpesq").val();
                });
                $("#cbusuariopesq").select2({
                    id: function (e) {return e.codusu},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbusuarios',
                                c1: 'codusu',
                                c2: 'nomeusu'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.pidusuario = $("#cbusuariopesq").val();
                });   
				
				
				$("#cbpdv").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqlinipdv,
								sqlfim	: sqlfimpdv,
								cpid	: 'id',
								cpdesc	: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                        vself.vidpdv = $("#cbpdv").val();
					if (parseInt(vself.opcrud) === 1 && vself.vidpdv !== null){
						let loader      = vself.$loading.show();
						let filtro      = ' and p.id='+vself.vidpdv;
						let parametros  = [
							{parametro: 'op',           valor : 'listagem'},
							{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',       valor : filtro},
							{parametro: 'limit',        valor : 1},
							{parametro: 'offset',       valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
						retorno.then(function (response) {
							loader.hide();							
							vself.vidperfilfluxo = parseInt(response.data[0].idperfilfluxoaberturas) === 0 ? null : response.data[0].idperfilfluxoaberturas;                
							if (vself.vidperfilfluxo !== null){                                    
								var defperfilfluxoaberturas  = new Option(response.data[0].descfluxoaberturas, vself.vidperfilfluxo, true, true);
								$('#cbperfilfluxopdv').append(defperfilfluxoaberturas).trigger('change');                
							}else{
								$("#cbperfilfluxopdv").val(null).trigger('change');
							}

						}).catch(function (response) {
							loader.hide();
						});						
					}else{
						vself.vidperfilfluxo = null;
						$("#cbperfilfluxopdv").val(null).trigger('change');
					}					
                });
                $("#cbforma").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidforma = $("#cbforma").val();
                });	      							
				$("#cbestoqueedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueedicao = $("#cbestoqueedicao").val();
                }); 
				$("#cbtecnico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicoedicao = $("#cbtecnico").val();
				});				
				$("#cbentregador").select2({
					id: function (e) { return e.id; },
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac: vself.$store.state.filialpadrao.idcliente,
								tb: 'tbentregadores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).on('select2:select', function (e) {
					const selectedData = e.params.data;
					vself.ventregador = selectedData.id; 
					vself.nomeEntregador = selectedData.text;
				});
				
				$("#cbpetpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbpetscliente',
								c1: 'idpet',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidpet = $("#cbpetpesq").val();
				});				
				$("#cbclientepet").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidclientepet = $("#cbclientepet").val();
				});
				$('#mdalterartitulo').on('shown.bs.modal', function (e) {
					$('#eddtventit').focus();
				});	                
				$("#cbformapagamento").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformapagamento = $("#cbformapagamento").val();
                    if (vself.vidformapagamento != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
							{parametro: 'idpdv',        valor : vself.lancamentousu.idpdv},
                            {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and f.id='+vself.vidformapagamento},                            
							{parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                        retorno.then(function (response) {
							vself.vtipoforma    		= parseFloat(response.data[0].tipo); 
							vself.vespecieforma 		= parseFloat(response.data[0].especie);
							vself.vabatecredito 		= parseInt(response.data[0].abatecredito); 
							vself.vfiscalautomatico	    = parseInt(response.data[0].fiscalautomatico);
							vself.vnrvendaforma         = ''; 
							vself.vqtdparcelascartao    = 1;
							vself.vnsu			        = '';
                            vself.vidperfilfluxoforma   = parseInt(response.data[0].idperfilfluxo) === 0 ? null : response.data[0].idperfilfluxo;                
                            vself.vdescperfilfluxoforma = response.data[0].descperfilfluxo;							
                            loader.hide();


							if (parseInt(vself.vabatecredito) === 1){//localiza o crédito quando houver
								let loader      = vself.$loading.show();
								let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.vidcliente;
								let parametros  = [
									{parametro: 'op',           	valor : 'listagem'},
									{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
									{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'filtro',       	valor : filtro},
									{parametro: 'limit',        	valor : 1},
									{parametro: 'offset',       	valor : 0},
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if (response.data.pedidos.length > 0){
										let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.lancamentomenu.fatorcreditoutilizar) * parseFloat(vself.vtotalgeral) / 100, 2, 'round');				
										let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
										if (parseInt(parseFloat(vlcreditodisp) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
											vself.vvlforma = vllimitecreditoabater;
										}else{
											vself.vvlforma = vlcreditodisp;
										}
										//vself.vvlforma = util.arredondaValores(parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado) * parseFloat(response.data.pedidos[0].fatorcreditoutilizar) / 100, 2, 'round');
										vself.vnrvendaforma = response.data.pedidos[0].id;
									}
								}).catch(function (response) {
									console.log(response);
									vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
									$('#cbformapagamento').focus();
									loader.hide();
								});
							}							
                        }).catch(function (response) {
                            loader.hide();
                        });
						
                    } else {//quando limpa seleção
						vself.vtipoforma    		= 0;
						vself.vespecieforma 		= 0;
						vself.vabatecredito 		= 0;
						vself.vfiscalautomatico 	= 0;
						vself.vnrvendaforma 		= '';
						vself.vqtdparcelascartao 	= 1;
						vself.vnsu				 	= '';
                        vself.vidperfilfluxoforma   = 0;                
                        vself.vdescperfilfluxoforma = '';  						
                    }											
                });  
                
				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.taidtipocobranca != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.taidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.tatipocobranca = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.tatipocobranca = 0;
                    }					
				});

				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidbanco = $("#cbbanco").val();
				});

				$("#cbgruposaidapdv").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupossaidaspdv',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idgruposaidapdv = $("#cbgruposaidapdv").val();
				});

				$("#cbsituacaocheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidsituacaocheque = $("#cbsituacaocheque").val();
				});
				
                $("#cbformamovcx").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.idformamovcx = $("#cbformamovcx").val();
                });	
				
                $("#cbperfilfluxofinal").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aidperfilfluxo = $("#cbperfilfluxofinal").val();
                });				
            
				$("#mdlalterarperfilfluxofinal").on('show.bs.modal', function(){
					$('#cbperfilfluxofinal').select2('open');
				}); 			
			},
			mtdadicionartaxa(){
					if(this.lstcomandasvenda.length === 0 && this.lstitens.length === 0){
						this.$toastr.w('Para adicionar uma taxa, primeiro é necessário importar uma comanda ou produto', 'Atenção');
					}else{
						this.vvalortaxacriar 	= 0;
						this.vtaxacriar 		= 0;
						$("#cbentregador").val(null).trigger('change');
						$('#mdcriartaxa').modal('show');
					}
				 	this.vvalortaxacriar 	= 0;
					this.vtaxacriar 		= 0;
					$("#cbentregador").val(null).trigger('change');
					$('#mdcriartaxa').modal('show');	
			},
			mtdconfirmacriartaxa(){
				let totalizar = false
				switch (parseInt(this.vtaxacriar)) {
					case 0://taxa de serviço
						if(parseFloat(this.vtottaxaservico) > 0){
							this.$toastr.w('Taxa já adicionada à venda!', 'Atenção');
						}else{
							this.vtottaxaservico = this.vvalortaxacriar;
							totalizar = true;
						}
					break;
					case 1://taxa de entrega
						if(parseFloat(this.vtottaxaentrega) > 0){
							this.$toastr.w('Taxa já adicionada à venda!', 'Atenção');
						}else{
							this.vtottaxaentrega = this.vvalortaxacriar;
							totalizar = true;
						}
					break;
					
				}
				if(totalizar){
					this.vtotalgeral	  = parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtottaxaentrega) + parseFloat(this.vtottaxaservico);
				}

			},
			mtdAdicionarAgendamento(){
				this.MtdLimpaCamposAgendamento();
				$('#mdconsultaragendamentos').modal('show');
			},
			mtdverificasistemafood(){
                if(parseInt(this.$store.state.usuario.tpsistema)===2){//food
                    return true;
                }else{
                    return false;
                }
            },
			mtdverificasistemapet(){
                if(parseInt(this.$store.state.usuario.tpsistema)===3){//pet
                    return true;
                }else{
                    return false;
                }
            },
			mtdconfirmaalteracaotaxa(){
				let vself = this;
				if(parseFloat(vself.vvalortaxaaltera) === 0){//
					vself.$toastr.w('Não é permitido zerar a taxa !', 'Atenção')
				}else{
					if(vself.voptaxa === 1){//taxa de serviço
						vself.vtottaxaservico = vself.vvalortaxaaltera;
					}else{//taxa de entrega
						vself.vtottaxaentrega = vself.vvalortaxaaltera;
					}
					//zera a alteração
					vself.vvalortaxaaltera = 0;
					//totaliza
					this.vtotalgeral	  = parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtottaxaentrega) + parseFloat(this.vtottaxaservico);
					$('#mdalterataxa').modal('hide');
				}
			},
			mtdalterartaxa(optaxa){
				this.voptaxa = optaxa;
				
				if(parseInt(optaxa) === 1){
					this.vvalortaxaaltera = this.vtottaxaservico  
				}else{
					this.vvalortaxaaltera = this.vtottaxaentrega  
				}

				$('#mdalterataxa').modal('show');
			},
			mtdexcluirtaxa(optaxa){
				let vself = this;
				$.confirm({
                    title: 'Confirmação!',
                    content: optaxa === 1 ? 'Confirma excluir taxa de serviço?' : 'Confirma excluir taxa de entrega?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: 'Sim',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
								switch (optaxa) {
									case 1:
										vself.vtottaxaservico = 0;
										break;
									case 2:
										vself.vtottaxaentrega = 0;
										break;
				
								}
								vself.vtotalgeral	  = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos) + parseFloat(vself.vtottaxaentrega) + parseFloat(vself.vtottaxaservico);
                            },
                        },
                        nao: {
                            text: 'Não',
                            keys: ['n', 'N'],
                            action: function () {
								
                            }
                        }
                    }
                });

				
			},
			mtdimprimemovimentos(){ 
				let dtinirelpdv = '2012-01-01 00:00:00'               
				let dtfimrelpdv =  util.InverterData(util.DataAtual(true))+' 23:59:59'
			
				window.open(this.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&oprelatorio=11'+
							'&filial='+'EMISSÃO PDV ABERTURA: '+this.lancamentosmov.id+
							'&idfilial='+encodeURIComponent(JSON.stringify([]))+
							'&idpdv='+0+
							'&idabertura='+this.lancamentosmov.id +
							'&idgruposaidapdv='+0+
							'&dtini='+dtinirelpdv+
							'&aberturas='+1+
							'&vendas='+1+
							'&recebimentos='+1+
							'&entradas='+1+
							'&saidas='+1+
							'&fechamentos='+1+
							'&resumirvendas='+0+
							'&excel='+1+
							'&dtfim='+dtfimrelpdv+
							'&usuario='+this.$store.state.usuario.nome, '_blank');
					
			},
			mtdbuscarcomanda(){
				this.vidcomanda = 0;
				$("#mdbuscacomanda").modal("show");
			},
			mtdprocessacomandas(lstcomandas){
				var vself           = this;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'liberacomandaspdv'},
                    {parametro: 'lstcomandas',  valor  : JSON.stringify(lstcomandas)},
					{parametro: 'idfilial',     valor  : vself.lancamentousu.idfilial}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadmesascomandas.php');
                retorno.then(function (response) {
					if($.isNumeric(response.data)){
					
						vself.$toastr.s('Comandas liberadas com sucesso', 'Sucesso!');

					}else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {

                });
			},
			mtdprocessaitenscomanda(items, txservico, txentrega, tptxservico, tptxentrega){
				let vself =this;

				if (util.findValInArray(vself.lstcomandasvenda, 'idcomanda', vself.vidcomanda)){
					this.$toastr.w('Comanda já importada!', 'Atenção!');
					return;
				} 

				for (let index = 0; index < items.length; index++) {
					this.mtdmostraritens();	

					this.vitem++;
					let itemtmp = {
						idproduto		: items[index].idproduto,
						descproduto		: items[index].descricao,
						coddig			: items[index].idproduto,
						item			: this.vitem,
						qtditem			: parseFloat(items[index].qtd),
						unditem			: items[index].und,
						vlunitario		: parseFloat(items[index].valor),
						descacres		: 0,//vdescacresedicao,
						tipodescacres	: parseInt(items[index].tpdesconto),
						valordescacres	: parseFloat(items[index].desconto),
						manipulaval		: 0,
						vltotal			: parseFloat(items[index].total),
						idestoque		: this.lancamentousu.idestoque,
						descestoque		: this.lancamentousu.descestoque,
						infadprod		: '',
						qtdentregar		: items[index].qtd,
						nrvenda			: ''
					};
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(items[index].total);
										

					this.lstitens.push(itemtmp);
				
					// this.desativaidpro = false;
					// this.vcoddigedicao = '';
					// setTimeout(function(){
					// 	util.irfinaldiv('#dv-lst-itens');                                    
					// }, 300);      
				
				}

				let icomanda = {
					idcomanda : vself.vidcomanda
				}

				vself.lstcomandasvenda.push(icomanda);

				if(parseInt(tptxservico)===1){///percentual
					vself.vtottaxaservico = (vself.vtotalprodutos * txservico) /100;
				}else{//valor
					vself.vtottaxaservico = vself.vtottaxaservico + txservico;
				}

				if(parseInt(tptxentrega)===1){///percentual
					vself.vtottaxaentrega = (vself.vtotalprodutos * txentrega) /100;
				}else{//valor
					vself.vtottaxaentrega = vself.vtottaxaentrega + txentrega;
				}				

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtottaxaentrega) + parseFloat(this.vtottaxaservico);
			
				this.$toastr.s('Comandas importadas com sucesso', 'Sucesso!');
			},
			mtdconfirmabuscacomanda(){
				var vself           = this;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'pegaitenscomanda'},
                    {parametro: 'idcomanda',    valor  : vself.vidcomanda},
					{parametro: 'idfilial',     valor  : vself.lancamentousu.idfilial}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
					if($.isNumeric(response.data.ret)){
						vself.mtdprocessaitenscomanda(response.data.itenscomandas, response.data.txservico, response.data.txentrega, response.data.tptxservico, response.data.tptxentrega)
						$("#mdbuscacomanda").modal("hide");
						
					}else{
                        let tpret = response.data.ret.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                break;
                        }
						$('#edcomanda').focus();
                    }
                }).catch(function (response) {

                });
			},
			mtdalterarqtd(aumentar, qtd, indiceitem){              
				if (aumentar) {
					this.lstitensbotoes[indiceitem].qtd   += parseFloat(qtd); 
					this.lstitensbotoes[indiceitem].total  = util.arredondaValores(parseFloat(this.lstitensbotoes[indiceitem].qtd) * parseFloat(this.lstitensbotoes[indiceitem].valor), 3, 'round'); 
					
				}else{
					if (parseFloat(this.lstitensbotoes[indiceitem].qtd) > 1){
						this.lstitensbotoes[indiceitem].qtd       -= parseFloat(qtd);
						this.lstitensbotoes[indiceitem].total      = util.arredondaValores(parseFloat(this.lstitensbotoes[indiceitem].qtd) * parseFloat(this.lstitensbotoes[indiceitem].valor), 3, 'round');                   
					}else{
						return;
					}
				}    
			
            },
			mtdincluirproduto(item, indice){
				this.mtdlocalizarproduto(item.qtd+'*'+item.idproduto)
				if(parseInt(this.lstitensbotoes[indice].qtd) > 1){
					this.mtdalterarqtd(false, this.lstitensbotoes[indice].qtd - 1, indice)
				}	
			},
			mtdselecionabotao(i){
				this.lstitensbotoes = [];
				for (let index = 0; index < this.lstbotoes.length; index++) {
					if(index !== i){
						this.lstbotoes[index].ativo = 0; 
					}else{
						this.lstbotoes[index].ativo = 1; 
						this.lstitensbotoes = this.lstbotoes[index].itensbotoes
					}
				}
				this.mtdajustestela();
			},
			mtdverificadescontoquantidade(){
				if(parseFloat(this.vqtdminimodescedicao) > 0){
					let indiceitem   = util.getArrayIndexForKey(this.lstitens, 'item', this.vitemalteracao)
					var qtditem_old  = this.mtdpegaqtditemvenda(this.lstitens[indiceitem].idproduto)
					var qtdreal      = qtditem_old + this.vqtditemedicao - this.lstitens[indiceitem].qtditem

					if(qtdreal >= this.vqtdminimodescedicao){
						this.vtipodescacresedicao = 1;
						this.vvalordescacresedicao = this.vvldescontoqtdmin * parseFloat(this.vqtditemedicao);
				    }else{
						this.vvalordescacresedicao = 0;
					}
				}
			},
			mtdtiradescontoqtd(idproduto, valor, exceto){
				for (let index = 0; index < this.lstitens.length; index++) {
					if(exceto === null){
						if(this.lstitens[index].idproduto === idproduto){
							this.lstitens[index].tipodescacres  = 1;
							this.lstitens[index].valordescacres = this.lstitens[index].valordescacres - (valor * parseFloat(this.lstitens[index].qtditem));
							this.lstitens[index].descacres      = 0;//this.lstitens[index].descacres - (valor * parseFloat(this.lstitens[index].qtditem));
							this.lstitens[index].vltotal        = parseFloat(this.lstitens[index].vltotal) + valor * parseFloat(this.lstitens[index].qtditem)
						}
					}else{
						if(exceto !== index){
							if(this.lstitens[index].idproduto === idproduto){
								this.lstitens[index].tipodescacres  = 1;
								this.lstitens[index].valordescacres = this.lstitens[index].valordescacres - (valor * parseFloat(this.lstitens[index].qtditem));
								this.lstitens[index].descacres      = 0//this.lstitens[index].descacres - (valor * parseFloat(this.lstitens[index].qtditem));
								this.lstitens[index].vltotal        = parseFloat(this.lstitens[index].vltotal) + valor * parseFloat(this.lstitens[index].qtditem)
							}
						}
					}
				}
			},
			mtdrecalculartudo(mandarmsg){
				this.vtotalprodutos = 0;
				for(let i = 0; i < this.lstitens.length; i++){
					this.vtotalprodutos = this.vtotalprodutos + this.lstitens[i].vltotal;
				}
				this.vtotalgeral =  this.vtotalprodutos + this.vtotalservicos;

				if(mandarmsg){
					 this.$toastr.i('Desconto aplicado, mas um ou mais itens atingiram o preço minimo, seu desconto pode ser dado individualmente!', 'Atenção!');
				}
				this.mtdtaxaacrescimo();
			},
			mtdpegaqtditemvenda(idproduto){
				if(this.lstitens.length > 0){
					var qtd = 0;
					for (let i = 0; i < this.lstitens.length; i++) {
						if(this.lstitens[i].idproduto === idproduto){
							qtd = qtd + this.lstitens[i].qtditem;
						}
					}
					return qtd;
				}else{
					return 0;
				}
			},
			mtdatzdescontosqtd(idproduto, vldescontoqtd, exceto){
				for (let index = 0; index < this.lstitens.length; index++) {

					if(exceto===null){
						if(this.lstitens[index].idproduto === idproduto){
							this.lstitens[index].tipodescacres  = 1;
							this.lstitens[index].valordescacres = vldescontoqtd * parseFloat(this.lstitens[index].qtditem);
							this.lstitens[index].descacres      = 0//vldescontoqtd * parseFloat(this.lstitens[index].qtditem);
							this.lstitens[index].vltotal        = parseFloat(this.lstitens[index].vltotal) - parseFloat(this.lstitens[index].valordescacres)
						}

					}else{
						if(index !== exceto){
							if(this.lstitens[index].idproduto === idproduto){
								this.lstitens[index].tipodescacres  = 1;
								this.lstitens[index].valordescacres = vldescontoqtd * parseFloat(this.lstitens[index].qtditem);
								this.lstitens[index].descacres      = 0//vldescontoqtd * parseFloat(this.lstitens[index].qtditem);
								this.lstitens[index].vltotal        = parseFloat(this.lstitens[index].vltotal) - parseFloat(this.lstitens[index].valordescacres)
							}
						}
					}
				
				}
			},
			mtdpegadadosdesctabela(op, tabelas, idtabela){
				for (var i = 0; i < tabelas.length; i++) {
					if (parseInt(tabelas[i]['idtabela']) === parseInt(idtabela) ){
						if(op===1){
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseInt(tabelas[i]['qtdminima']);
						}else{
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseFloat(tabelas[i]['desconto']);
						}
					}    
				}
			},
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);								
			},
			mtdclasseitem(classes){
				let vself = this;
				if (classes.length > 0){
					let indc = util.getArrayIndexForKey(classes, 'idfilial', vself.vidfilial);
					if (indc > -1){
						return classes[indc];
					}else{
						return [];
					}
				}else{
					return [];
				}
			},	
			processaprodutos(items){
				let vself =this;
				for (let index = 0; index < items.length; index++) {
					this.mtdmostraritens();	
					//removido para lançamento do mesmo item repetidamente			
					// if (util.findValInArray(this.lstitens, 'idproduto', this.vidprodutoedicao)){
					//     this.$toastr.w('Produto já lançado na venda!', 'Atenção!');
					//     this.desativaidpro = false;
					//     return;
					// }       
					
					let ret = util.itemcomimposto(this.mtdclasseitem(items[index].prod.classes), items[index].prod.prtabela, items[index].qtd, 0, 0);

					let qtdmin = vself.mtdpegadadosdesctabela(1, items[index].prod.tabelas, vself.vidtabela)
					let vldesc = vself.mtdpegadadosdesctabela(2, items[index].prod.tabelas, vself.vidtabela)

					var recalcular       = false; //rotina para calcular o item por quantidade

					var vdescacresedicao = 0;

					if((qtdmin > 0)||(vldesc > 0)){

						var qtditemvenda = vself.mtdpegaqtditemvenda(items[index].id)

						if((qtditemvenda + parseFloat(items[index].qtd)) >= qtdmin){
							vdescacresedicao  = vldesc * parseFloat(items[index].qtd);

							if(qtditemvenda + parseFloat(items[index].qtd) === qtdmin){
								recalcular = true
							}else{
								recalcular = false
							}
						}

					}

					this.vitem++;
					let itemtmp = {
						idproduto		: items[index].id,
						descproduto		: items[index].prod.descricao,
						coddig			: items[index].id,
						item			: this.vitem,
						qtditem			: parseFloat(items[index].qtd),
						unditem			: items[index].prod.und,
						vlunitario		: parseFloat(items[index].prod.prtabela),
						descacres		: 0,//vdescacresedicao,
						tipodescacres	: 1,
						valordescacres	: vdescacresedicao,
						manipulaval		: 0,
						vltotal			: parseFloat(ret.vltotalitem) - parseFloat(vdescacresedicao),
						idestoque		: this.lancamentousu.idestoque,
						descestoque		: this.lancamentousu.descestoque,
						infadprod		: '',
						qtdentregar		: items[index].qtd,
						nrvenda			: ''
					};
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(ret.vltotalitem);
					this.metodochamado  = this.metodochamado + ' processaprodutos '+index;
					this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);
					if(recalcular){
						this.mtdatzdescontosqtd(items[index].id, vldesc, null)
					}
					this.lstitens.push(itemtmp);
				
					// this.desativaidpro = false;
					// this.vcoddigedicao = '';
					// setTimeout(function(){
					// 	util.irfinaldiv('#dv-lst-itens');                                    
					// }, 300);      
				
				}
			},
			mtdverificatrocovirtual(){/// verifica se vai habilitar o swc de troco virtual
				var tv = false
				if(parseInt(this.trocovirtual)===1){
					if((!this.temtrocadev) && (parseFloat(this.vtotalgeral) > 0) && (parseFloat(this.vdiferenca) > 0)){
						tv = true
					}
				}
				return tv;
			},
			mtdgeraretiquetastroca(){
				let vself = this;
				if(this.lstitensvendamarc.length===0){
					vself.$toastr.w('Selecione os itens', 'Atenção!');
					return
				}
				var itens       = '';
				var idpedido    = this.lstitensvendamarc[0].idpedido;
				var qtdmarcado  = 0;
				var itemmarcado = '';

				for (let index = 0; index < this.lstitensvendamarc.length; index++) { ///  verifica se há somente um item marcado
					if(parseInt(this.lstitensvendamarc[index].marcado)===1){
						++qtdmarcado
						itemmarcado = this.lstitensvendamarc[index].item;
					}
				}

				if(qtdmarcado===1){
					itens = 'and i.item='+itemmarcado
				}else{
					itens = 'and i.item IN ('
					for (let index = 0; index < this.lstitensvendamarc.length; index++) {
						if(parseInt(this.lstitensvendamarc[index].marcado)===1){
							if(index !== (qtdmarcado - 1)){
								itens = itens+''+ this.lstitensvendamarc[index].item+', ';
							}else{
								itens = itens+''+ this.lstitensvendamarc[index].item+' ';
							}
						}
					}
					itens = itens + ')'
				}


				$.confirm({
                    title: 'Confirmação!',
                    content: 'Tipo de impressão',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: 'A4',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
								window.open(vself.$store.state.configpaths.pathcontrole+'rtcadlancamentospdvs.php?op=geraretiquetatroca'+
								'&itens=' +itens+
								'&idpedido=' +idpedido+
								'&tp=' +1+
								'&idclientesac='+vself.$store.state.filialpadrao.idcliente,
								'_blank');
                            },
                        },
                        nao: {
                            text: 'Cupom',
                            keys: ['n', 'N'],
                            action: function () {
								window.open(vself.$store.state.configpaths.pathcontrole+'rtcadlancamentospdvs.php?op=geraretiquetatroca'+
								'&itens=' +itens+
								'&idpedido=' +idpedido+
								'&tp=' +2+
								'&idclientesac='+vself.$store.state.filialpadrao.idcliente,
								'_blank');
                            }
                        }
                    }
                });

			
			},
			marcartodositens(){
				var qtdmarcado = 0;
				var qtddesmarcado =0;
				for (let index = 0; index < this.lstitensvendamarc.length; index++) {
					if(parseInt(this.lstitensvendamarc[index].marcado)===0){
						++qtddesmarcado;
					}else{
						++qtdmarcado;
					}
				}

				if(qtddesmarcado === this.lstitensvendamarc.length){ // se todos estiverem desmarcados ele vai marcar todos
					for (let index = 0; index < this.lstitensvendamarc.length; index++) {
						 this.lstitensvendamarc[index].marcado = 1	
					}
				}else if(qtdmarcado === this.lstitensvendamarc.length){ //se todos estiverem marcados ele vai desmarcar todos
					for (let index = 0; index < this.lstitensvendamarc.length; index++) {
						 this.lstitensvendamarc[index].marcado = 0	
					}
				}else{
					for (let index = 0; index < this.lstitensvendamarc.length; index++) { // se alguns estiverem marcados ele vai marcar todos
						 this.lstitensvendamarc[index].marcado = 1	
					}
				}
				
			},
			marcaritemetiqueta(index){
				if(parseInt(this.lstitensvendamarc[index].marcado)===0){
					this.lstitensvendamarc[index].marcado = 1
				}else{
					this.lstitensvendamarc[index].marcado = 0
				}
			},
			mtdpegaitensvenda(){
				var vself           = this;
				vself.lstitensvendamarc = [];
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'pegaitensvenda'},
                    {parametro: 'idpedido',     valor  : vself.vidultimopedido}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
					if($.isNumeric(response.data.msg)){

						vself.lstitensvendamarc = response.data.itens
						$('#mdetiquetatroca').modal('show');

					}else{
                        let tpret = response.data.msg.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.msg.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.msg.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {

                });
			},
			mtdgeraretiquetatroca(){
				this.mtdpegaitensvenda()
			},
            mtdprocessacodbar(data){
                var codpro = data.codeResult.code

                this.mtdlocalizarproduto(parseInt(codpro))
                this.mtdescondescanner();
            },
            mtdscannearcode(){
                $("#mdlscannercode").modal('show');
                this.mostrandomodal = true
            },
            mtdescondescanner(){
                $("#mdlscannercode").modal('hide');
                this.mostrandomodal = false
            },			
			mtdajustestela(){
				$("#dv-lst-itens").height(window.innerHeight - 300);								
				$("#dv-lst-servicos").height($("#dv-lst-itens").height() - $("#dv-opcoes-servicos").height() + 34);					

				$("#dv-lista-itens-slick").height($("#dv-lst-itens").height() - 87);												

				if (window.innerWidth < 768){						
					$("#dv-lst-servicos").height(300);				
				}else{
					$("#img-cliente-pdv").height($("#dv-lst-itens").height() - $("#dv-menu").height() + 8);
				}

				$(window).resize(function(){
					$("#dv-lst-itens").height(window.innerHeight - 300);
					$("#img-cliente-pdv").height($("#dv-lst-itens").height() - 28);

					$("#dv-lista-itens-slick").height($("#dv-lst-itens").height() - 87);

					if (window.innerWidth < 768){
						$("#dv-lst-servicos").height(300);				
					}else{
						$("#dv-lst-servicos").height($("#dv-lst-itens").height() - $("#dv-opcoes-servicos").height() + 34);										
					}
				});				
			},		
			mtdquantidade(op){
				
				if (parseInt(op) === 1){
					this.vqtditemedicao++;
				}else{
					if (parseFloat(this.vqtditemedicao) > 1){
						this.vqtditemedicao--;
					}
				}
				this.mtdverificadescontoquantidade();
			},
			mtdmenuoutras(){
				$('#mdmenupdv').modal('show');
			},
			mtdatzvariaveisperfil(){
				this.pmanipularvaloritem = false;//util.opcaousuario('020Z.010Z.070Z', this.$store.state.perfilusuario) === false ? true : false;
				this.pdefinirestoque 	 = true;//util.opcaousuario('020Z.010Z.080Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterarvendedor	 = true;//util.opcaousuario('020Z.010Z.120Z', this.$store.state.perfilusuario);
			},               
			mtdformatavalordecimal(valor, digitos){
				try {
					return util.formatavalordecimais(valor, digitos);
				}
				catch (e) {
					return 0;
				}
			},
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },
			mtdmostrarmenu(lancamento){				
				this.lancamentomenu = lancamento;
				$('#mdmenulancamento').modal('show');
			},
            mtdfiltropesquisa(){
                let rfiltro = '';
                rfiltro = this.pconteudo === '' ? '' : ' and l.id='+this.pconteudo;
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' and p.idfilial='+this.pidfilial;
                }
                if (this.pidpdv !== null){
                    rfiltro = rfiltro + ' and l.idpdv='+this.pidpdv;
                }
                if (this.pidusuario !== null){
                    rfiltro = rfiltro + ' and l.idusuario='+this.pidusuario;
                }                
                if (parseInt(this.psituacao) < 2){
                    rfiltro = rfiltro + ' and l.situacaopdv='+this.psituacao;
				}                  
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and l.dtabertura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
				}                              
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}				
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregapdvs(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregapdvs(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				let filtro      = vself.mtdfiltropesquisa();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : vself.pqtdregistros},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
				retorno.then(function (response) {
					vself.lstpdvs = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstpdvs = [];
					loader.hide();
				});
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vidpdv             = null;
                this.vidforma           = null;
                this.vvalorabertura     = 0;
                this.vobservacoes       = '';
			

                $("#cbpdv").val(null).trigger('change');
                $("#cbforma").val(null).trigger('change');
				$("#cbperfilfluxopdv").val(null).trigger('change');

			},
            mtdconsultarcliente(){
				this.didcliente 	= '';
				this.dnomecliente 	= '';
				this.dvlcreditodisponivel = 0;
				this.dimgcliente    = this.pathimgview+'imagens/semimagem.png';

				this.ridcliente 	= '';
				this.rnomecliente 	= '';
				this.rdtultrecebimento		= '';
				this.rvalorultrecebimento 	= '';

				this.dlstplanos		= [];
				let payload = {
					abrirtela    : true			
				};
				this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);
				let payloadx = {
					idcliente    : null			
				};
				this.$store.commit('CLIENTE_RETORNO_CHANGE',payloadx);                
			},				
            mtdlocalizarcliente(idcliente){
				if (idcliente !== '' && idcliente !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'infcredito',       valor : '0'},						
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and c.ativo=0 and c.id='+idcliente},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let cliente = response.data[0];	

							if (!vself.rotinarecebimento){
								//if (parseInt(cliente.atraso) > parseInt(cliente.qtddiastolatraso)){
								if (parseInt(cliente.atraso) > parseInt(cliente.qtddiasbloqvenda)){
									vself.didcliente 	= '';
									vself.dnomecliente 	= cliente.nome;
									vself.vclienteematraso = true;
									vself.dvlcreditodisponivel	= cliente.vlcreditodisponivel;
									vself.$toastr.w('Cliente com débitos em atraso. Favor entrar em contato com o setor responsável!', 'Informação!');
									setTimeout(() => {
										$('#eddcliente').focus();
									}, 300);									
									return;
								}								
								vself.didcliente  			    = cliente.id;
								vself.dnomecliente 				= cliente.nome;
								vself.dexigirentrada            = cliente.exigirentrada;
								vself.dpercentrada				= cliente.percentrada;
								vself.dimgcliente               = vself.pathimgview+cliente.imagemcliente
								vself.didplano 					= null;
								vself.dvlcreditodisponivel		= cliente.vlcreditodisponivel;
								vself.valertarcliente			= parseInt(cliente.alertarcliente) === 0 ? false : true;
								vself.mtdlocalizarplanos();
								vself.$nextTick(function () {
									$('#cbplanodef').focus();
									vself.mtdquestionaratzcliente();
								});
							}else{
								if(parseInt(cliente.atraso) > parseInt(cliente.qtddiasbloqvenda)){
									vself.vclienteematraso = true;
								}


								vself.ridcliente  			    = cliente.id;
								vself.rnomecliente 				= cliente.nome;
								vself.rdtultrecebimento			= cliente.dtultrecebimento;
								vself.rvalorultrecebimento 		= cliente.valorultrecebimento;								
								vself.valertarcliente			= parseInt(cliente.alertarcliente) === 0 ? false : true;
								vself.$nextTick(function () {
									$('#edridpedido').focus();
								});								
							}
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.didcliente 	= '';
							vself.dnomecliente 	= '';
							vself.didplano 		= null;
							vself.dexigirentrada= 0;
							vself.dpercentrada  = 0;
							vself.dlstplanos	= [];
							vself.dvlcreditodisponivel = 0;
							vself.valertarcliente			= false;

							vself.ridcliente  			    = cliente.id;
							vself.rnomecliente 				= cliente.nome;	
							vself.rdtultrecebimento			= cliente.dtultrecebimento;
							vself.rvalorultrecebimento 		= cliente.valorultrecebimento;															
							if (!vself.rotinarecebimento){														
								$('#eddcliente').focus();
							}else{
								$('#edrcliente').focus();
							}
						}
					}).catch(function (response) {
						vself.dlstplanos = [];
						loader.hide();
					});
				}else{
					this.didcliente 	= '';
					this.dnomecliente 	= '';
					this.didplano 		= null;
					this.dlstplanos		= [];
					this.dvlcreditodisponivel = 0;
					this.valertarcliente= false;
					this.dexigirentrada = 0;
				    this.dpercentrada   = 0;

					this.ridcliente  	= '';
					this.rnomecliente 	= '';						
					this.rdtultrecebimento		= '';
					this.rvalorultrecebimento 	= '';													
				}
            },			
			mtdlocalizarplanos(){
				let vself = this;
				if (vself.vidfilial !== null && vself.didcliente !== ''){	
					vself.didplano  = null;				
					//let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',           valor : 'planospedido'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idfilial',     valor : vself.lancamentousu.idfilial},
						{parametro: 'idcliente',    valor : vself.didcliente}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						//loader.hide();
						vself.dlstplanos  = response.data;
						vself.didplano    = vself.vidplano;
					}).catch(function (response) {
						vself.dlstplanos  = [];
						//loader.hide();
					});				
				}else{
					vself.didplano    = null;
					vself.dlstplanos  = [];					
				}
			},
			mtdselect2_servico_def(){
				let vself = this;
				$("#cbservico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbservicos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidservicoedicao = $("#cbservico").val();
					if (vself.vidservicoedicao !== null){
						let loader      = vself.$loading.show();
						let filtro      = ' and id='+vself.vidservicoedicao;
						let parametros  = [
							{parametro: 'op',           valor : 'listagem'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',       valor : filtro},
							{parametro: 'limit',        valor : 1},
							{parametro: 'offset',       valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadservicos.php');
						retorno.then(function (response) {
							loader.hide();
							let servico = [];
							servico     = response.data[0];
							vself.vprecoservicoedicao = [];
							vself.vprecoservicoedicao = util.mtdcarregaprecoservicofilial(servico.precos, vself.vidfilial);
							vself.vvlservicoedicao 	  = vself.vprecoservicoedicao.vlservico;						
						}).catch(function (response) {
							loader.hide();
						});	
					}				
				});
			},	
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
		
            },
            mtdnovo(){
				if (!util.opcaousuario('020Z.015Z.010Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'INCLUSÃO LANÇAMENTO DO PDV';
					this.itensbc.item1.ativo = true;
					this.itensbc.item2.ativo = true;
					this.ativadesativa = false;
					this.mtdpreparacrud(1);
				}
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstpdvs = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
				if (parseInt(vself.opcrud) < 3) {
					if (parseInt(vself.vtodasfiliais) === 0) {
					}
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdregistro();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and l.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                $('#mdmenulancamento').modal('hide');
				if (!util.opcaousuario('020Z.015Z.020Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'ALTERAÇÃO DE LANÇAMENTO DO PDV';
					this.itensbc.item1.ativo = true;
					this.itensbc.item2.ativo = true;
					this.ativadesativa = false;
					this.mtdpreparacrud(2);
					this.mtdlocalizaregistro(item.id);
				}
            },
            mtdexcluir(item){
                $('#mdmenulancamento').modal('hide');                
				if (!util.opcaousuario('020Z.015Z.030Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'EXCLUSÃO DE LANÇAMENTO DO PDV';
					this.itensbc.item1.ativo = true;
					this.itensbc.item2.ativo = true;
					this.ativadesativa = true;
					this.mtdpreparacrud(3);
					this.mtdlocalizaregistro(item.id);
				}
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vidpdv              = registro.idpdv;
                this.vidforma            = registro.idforma;
                this.vvalorabertura      = registro.valorabertura;
                this.vobservacoes        = registro.observacoes;

                var defpdv  = new Option(registro.descpdv, registro.idpdv, true, true);
                $('#cbpdv').append(defpdv).trigger('change');                

                var defforma  = new Option(registro.descforma, registro.idforma, true, true);
				$('#cbforma').append(defforma).trigger('change');                                
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
				let registrocrud = [];
				if (parseInt(vself.opcrud) === 1){
					registrocrud = {
						'id'                : vself.vid,
						'idpdv'             : vself.vidpdv,
						'idforma'           : vself.vidforma,
						'valorabertura'     : vself.vvalorabertura,
						'observacoes'       : vself.vobservacoes,
						'idusuario'         : vself.$store.state.usuario.id
					};
				}else{
					registrocrud = {
						'id'                : vself.vid,
						'idpdv'             : vself.vidpdv,
						'idforma'           : vself.vidforma,
						'valorabertura'     : vself.vvalorabertura,
						'observacoes'       : vself.vobservacoes,
						'idusuario'         : vself.$store.state.usuario.id
					};
				}
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'straleatoria', valor : vself.sringaleatoria},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '020Z.015Z.010Z' : parseInt(this.opcrud) === 2 ? '020Z.015Z.020Z' : '020Z.015Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapdvs(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'O':
                                vself.$toastr.i('Um PDV Off-line não pode ser manipulado On-line!', 'Atenção!');
								break;							
                            case 'C':
                                vself.$toastr.i('Já existe um caixa aberto para o PDV informado. Impossível abrir outro até que o mesmo esteja fechado!', 'Atenção!');
								break;
                            case 'L':
                                vself.$toastr.w('Existem lançamentos já registrados para esse PDV. Impossível realizar esta operação!', 'Atenção!');
                                break;															
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdfecharlancamentospdv(){
				if(this.conexaoSIO){
					console.log("desconectando socket.io");
					this.conexaoSIO.disconnect();
				}
				this.mtdlimparvenda(false, this.mtdatribuirplano);
				this.lancamentousu = [];				
                $('#dvlancamentospdv').hide();
                $('#dvrotinascrud').fadeIn(700); 
            },
            mtdlancamentospdv(lancamento){			
				$('#mdmenulancamento').modal('hide');				
				if (!util.opcaousuario('020Z.015Z.040Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					if (parseInt(lancamento.offline) === 1){
						this.$toastr.i('Um PDV Off-line não pode ser manipulado On-line!', 'Atenção!');
						return;
					}
					if (parseInt(lancamento.situacaopdv) === 1){
						this.$toastr.w('Caixa fechado! Impossível realizar lançamentos.', 'Atenção!');
						return;
					}				
					if (!util.opcaousuario('020Z.015Z.045Z', this.$store.state.perfilusuario) && parseInt(lancamento.idusuario) !== parseInt(this.$store.state.usuario.id)){
						this.$toastr.w('Perfil de usuário não está liberado para lançamentos em caixas de usuários diferentes!', 'Atenção!');
						return;							
					}	
					this.lancamentousu      		= JSON.parse(JSON.stringify(lancamento));
					this.vlogovisualizar			= this.pathimgview+this.lancamentousu.logo;
					this.vidplanoinicial    		= lancamento.plano.id;
					this.vgerarnfce					= parseInt(lancamento.padraonfce) === 0 ? false : true;
					this.vidfilial          		= this.lancamentousu.idfilial;
					this.vidplano           		= this.lancamentousu.plano.id;
					this.vtipoplano					= this.lancamentousu.plano.tipo;
					this.vpermitedesconto			= this.lancamentousu.plano.permitedesconto;
					this.vpercentrada				= this.lancamentousu.plano.percentrada;
					this.vdescplano         		= this.lancamentousu.plano.descricao;
					this.vidtabela          		= this.lancamentousu.plano.idtabela;
					this.vidpedido          		= '';
					this.vliberarfat				= 0;
					this.vidcliente					= this.lancamentousu.idcliente;
					this.vnomecliente				= this.lancamentousu.nomecliente;
					this.vvlcreditodisponivel 		= 0;
					this.vdoccli					= '';
					this.vidvendedor				= this.lancamentousu.idvendedor;
					this.vnomevendedor      		= this.lancamentousu.nomevendedor;
					this.vlayoutbalanca				= this.lancamentousu.layoutbalanca;
					this.vdigitosbalanca			= this.lancamentousu.digitosbalanca;
					this.vativarbalanca				= this.lancamentousu.ativarbalanca;
					this.ativacashbackliquidez  	= this.lancamentousu.ativacashbackliquidez;   
					this.fatorliquidez              = this.lancamentousu.fatorliquidez;  
					this.trocovirtual               = this.lancamentousu.trocovirtual;  
					this.vidperfiltrocovirtualvenda = this.lancamentousu.idperfiltrocovirtualvenda;
					this.vidperfiltrocovirtualreceb = this.lancamentousu.idperfiltrocovirtualreceb;  
					this.lstbotoes                  = this.lancamentousu.botoes;
					

					//verificar se ele é botoes rapidos ativos 
					if(this.lstbotoes.length > 0){
						this.vbotoesrapidos = 1;
						
						setTimeout(() => {
							$('#slickbtns').slick({
								infinite: true,
								slidesToShow: 3,
								slidesToScroll: 3
							});
						}, 500);
						this.mtdselecionabotao(1);						
					}else{
						this.vbotoesrapidos = 0;
					}
					

					this.mtdselect2_servico_def();
				
					
					$('#dvitensvenda').show();
					$('#dvservicosvenda').hide();
					$('#dvrotinascrud').hide();                
					$('#dvlancamentospdv').fadeIn(700);

					setTimeout(() => {
						this.mtdajustestela();
					}, 500);					
										
					$('#edlidproduto').focus();         
					// ABRE CONEXÃO COM O SOCKET IO
					this.mtdconectasocketio();       					
				}				
            },
            mtdlimparvenda(perfil, callback){
				let continua = true;
				if (this.vidpedido !== ''){
					perfil = false;
				}
				if (perfil){
					if (!util.opcaousuario('020Z.015Z.060Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
						continua = false;
					}else {				
						continua = true;
					}
				}else{
					continua = true;
				}					  
				if (continua){		
					this.vitem				= 0;//contador dos ítens         				
					//variáveis da venda
					this.vgerarnfce			= parseInt(this.lancamentousu.padraonfce) === 0 ? false : true;
					this.vidplano           = this.lancamentousu.plano.id;
					this.vtipoplano			= this.lancamentousu.plano.tipo;
					this.vdescplano         = this.lancamentousu.plano.descricao;
					this.vidtabela          = this.lancamentousu.plano.idtabela;
					this.vpercentrada		= this.lancamentousu.plano.percentrada;
					this.vpermitedesconto	= this.lancamentousu.plano.permitedesconto;
					this.vidpedido          = '';
					this.vliberarfat		= 0;
					this.vidcliente			= this.lancamentousu.idcliente;
					this.vnomecliente		= this.lancamentousu.nomecliente;
					this.valertarcliente	= false;
					this.vvlcreditodisponivel = 0;
					this.vdoccli			= '';
					this.vidvendedor		= this.lancamentousu.idvendedor;
					this.vnomevendedor      = this.lancamentousu.nomevendedor;								
					this.vtipo				= 0;
					this.vdtemissao			= util.DataAtual();				
					this.vlogovisualizar	= this.pathimgview+this.lancamentousu.logo;				
					this.vtotalprodutos		= 0;
					this.vtotalservicos		= 0;
					this.videntificador		= '';
					this.vobjeto			= '';
					this.vmarcacao			= '';
					this.vnrserie			= '';
					this.vmarca				= '';
					this.vmodelo			= '';
					this.vresponsavel		= '';
					this.vfone				= '';
					this.vdefeitoapresentado= '';
					this.vacessorios		= '';
					this.voutrasinformacoes	= '';
					this.vobservacoes		= '';
					this.vtotalgeral		= 0;
					this.vstpedido			= 0;
					this.vdtfatura			= '';
					this.vreservar			= 0;
					this.ventregaexterna	= 0;
					this.vorigem			= 1;
					this.lstitens			= [];
					this.lstservicos		= [];
					this.lstplanos			= [];
					this.sringaleatoria     = '';
					this.lstcomandasvenda   = [];
					this.vtottaxaentrega    = 0;
					this.vtottaxaservico    = 0;

					//oculos 
					this.vativainfooculos          = 0;
					this.vesfericoesquerdoperto    = 0;
					this.vcilindricoesquerdoperto  = 0;
					this.veixoesquerdoperto        = 0;
					this.vadicaoesquerdoperto      = 0;

					this.vesfericodireitoperto     = 0;
					this.vcilindricodireitoperto   = 0;
					this.veixodireitoperto         = 0;
					this.vadicaodireitoperto       = 0; 
	
					this.vesfericoesquerdolonge    = 0;
					this.vcilindricoesquerdolonge  = 0;
					this.veixoesquerdolonge        = 0;
					this.vadicaoesquerdolonge      = 0;

					this.vesfericodireitolonge     = 0
					this.vcilindricodireitolonge   = 0;
					this.veixodireitolonge         = 0;
					this.vadicaodireitolonge       = 0;

					this.vdptotal                  = 0;
					
					//variáveis aplicação do desconto no total dos ítens
					this.vtotalsemdesconto	= 0;
					this.vtotalcomdesconto  = 0;
					this.vtipodesctotal		= 0;	
					this.vfatordescontototal= 0;
					this.vresdesconto		= 0;

					this.vtotalsemacrescimo  = 0;
					this.vtipoacresctotal    = 0;
					this.vresacrescimo       = 0;
					this.vtotalcomacrescimo  = 0;
					this.vfatoracrescimototal= 0;
					
					this.vidagendamentopet = '';



					this.dimgcliente         = this.pathimgview+'imagens/semimagem.png'

					this.mtdlimparedicaoitem();
					this.mtdmostraritens();

					//Luiz Trindade - Resetar o id de pedido do ifood
					localStorage.setItem("ifoodOrderId", "");

					$('#edlidproduto').focus();
					callback(this.vidplanoinicial, true);
				}
            },
			mtdlimparedicaoitem(){
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vvlunitarioedicao			= 0;
				this.vprvendaminimo				= 0;
				this.vdescacresedicao			= 0;
				this.vtipodescacresedicao		= 0;
				this.vvalordescacresedicao		= 0;
				this.vmanipulavaledicao			= 0;
				this.vvltotaledicao				= 0;
				this.vfracionadoedicao			= 0;
				this.vldescontopromocional      = 0;
			},            
            mtdlocalizarproduto(coddig){ 
                let vself            = this;
				if (vself.vidpedido === ''){	
					let prodbal			 = false;
					vself.desativaidpro  = true; 
					vself.vqtditemedicao = 1;                           
					if (vself.vrotinadevolucao){
						coddig = '';
					}				

					if (coddig !== '' && coddig !== null){  
						//verificar rotina pra desativer rotina da balança	
						if (parseInt(vself.vativarbalanca) === 1){
							if (util.valBalanca(coddig)) {
								prodbal			 = true;
								if (util.ver_ean(coddig, 'EAN/UCC-13')) {
									if (vself.vlayoutbalanca === 0) {
										//Quando a configuração estiver setada para PREÇO
										vself.vvalorbalanca      = parseFloat(coddig.substring(vself.vdigitosbalanca + 1, 12)) / 100;
									}else{
										//Quando a configuração estiver setada para QUANTIDADE
										vself.vquantbalanca      = parseFloat(coddig.substring(vself.vdigitosbalanca + 1, 12)) / 1000;
									}

									coddig = vself.vquantbalanca.toString() + '*' + parseInt(coddig.substring(1, vself.vdigitosbalanca + 1));
								}else{
									vself.$toastr.w('Leitura do código de barras inválida!', 'Atenção!');							
									setTimeout(() => {
										$('#edlidproduto').focus();									
									}, 200); 
									return;
								}						
							}
						}

						let pos = coddig.toString().indexOf('*');
						if (pos > 0){
							let strqtd = coddig.substr(0, pos);
							strqtd = strqtd.replace(',', '.');
							if (!$.isNumeric(strqtd)){
								vself.desativaidpro  = false;   
								vself.$toastr.w('Quantidade inválida!', 'Atenção!');
								$('#edlidproduto').focus();
								return;
							}else{
								coddig = coddig.substr(pos + 1, coddig.length);
								vself.vqtditemedicao = parseFloat(strqtd);
							}
						}
						let loader          = vself.$loading.show();
						let parametros      = [
							{parametro: 'op',               valor : 'listagem'},
							{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
							{parametro: 'coddig',           valor : coddig},
							{parametro: 'limit',            valor : 1},
							{parametro: 'offset',           valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
						retorno.then(function (response) {
							loader.hide();	
							console.log("init");					
							if (response.data.length > 0){
								let produto = response.data[0];	
								
								if (parseInt(produto.fracionado) === 0){
									if (!Number.isInteger(vself.vqtditemedicao)){
										vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
										vself.desativaidpro  = false; 
										setTimeout(() => {
											$('#edlidproduto').focus();									
										}, 200);  									
										return;
									}
								}											
								vself.vidprodutoedicao			= produto.id;
								vself.vdescricaoprodutoedicao 	= produto.descricao;
								vself.vundprodutoedicao			= produto.und;
								vself.vfracionadoedicao			= produto.fracionado;
								vself.vvltabelaitemedicao		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);
								vself.vvlunitarioedicao			= parseFloat(vself.vvltabelaitemedicao).toFixed(2);
								vself.vqtdminimodescedicao      = vself.mtdpegadadosdesctabela(1, produto.tabelas, vself.vidtabela)
								vself.vvldescontoqtdmin         = vself.mtdpegadadosdesctabela(2, produto.tabelas, vself.vidtabela)
								vself.vprvendaminimo			= produto.prvendaminimo;


								let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);

							    //carrega o desconto promocional

								if (parseFloat(produto.tabelas[it].vldescpromocional) > 0){
									vself.vldescontopromocional = parseFloat(produto.tabelas[it].vldescpromocional);						
								}


								//Quantidade balanca
								if(prodbal) {
									if(vself.vlayoutbalanca === 0) {
										vself.vqtditemedicao   = util.arredondaValores(parseFloat(vself.vvalorbalanca / vself.vvlunitarioedicao), 4, 'round');
									}
								}

								vself.vvltotaledicao            = parseFloat(vself.vvlunitarioedicao) * parseFloat(vself.vqtditemedicao);
								
								if (produto.imagens.length > 0){
									vself.vlogovisualizar	= vself.pathimgview+produto.imagens[0].patharquivo;
								}else{
									vself.vlogovisualizar	= vself.pathimgview+vself.lancamentousu.logo;
								}
								if (!util.opcaousuario('020Z.015Z.051Z', vself.$store.state.perfilusuario)){
									if (parseFloat(vself.vvltotaledicao ) <= 0){
										vself.$toastr.w('Produto sem preço. Verifique e tente novamente!', 'Atenção!');
										vself.desativaidpro  = false; 
										setTimeout(() => {
											$('#edlidproduto').focus();									
										}, 200);  									
										return;
									}
								}
								if (util.findValInArray(vself.lstitens, 'coddig', coddig) && parseInt(vself.vqtdminimodescedicao) > 0){ // VERIFICA SE PRODUTO JÁ FOI ADICIONADO
									vself.$toastr.i('Produto com desconto por quantidade já inserido na venda! Utilize o botão "Alterar Item" para editar a quantidade e aplicar o desconto.', 'Informação!');
									$('#edlidproduto').focus();
									vself.vcoddigedicao = '';
									vself.desativaidpro = false;
									return
								}
								vself.mtdincluiritem(coddig);							
								vself.$nextTick(function () {                                
									$('#edlidproduto').focus();
								});
							}else{
								vself.desativaidpro = false;
								vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
								vself.mtdlimparedicaoitem();
								vself.$nextTick(function () {                                
									$('#edlidproduto').focus();
								});
							}
						}).catch(function (response) {
							vself.desativaidpro = false;
							loader.hide();
						});
					}else{
						vself.desativaidpro = false;
						vself.mtdlimparedicaoitem();
					}
				}
            },
            mtdlocalizarprodutodev(coddig){
				var vself       = this;	
				if (vself.vrotinadevolucao){
					if (coddig !== '' && coddig !== null){					
						let loader      = vself.$loading.show();
						let parametros  = [
							{parametro: 'op',               valor : 'listagem'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
							{parametro: 'coddig',           valor : coddig},
							{parametro: 'limit',            valor : 1},
							{parametro: 'offset',           valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
						retorno.then(function (response) {
							loader.hide();						
							if (response.data.length > 0){
								let produto = response.data[0];							
								vself.vidprodutodev			= produto.id;
								vself.vdescricaoprodutodev 	= produto.descricao;
								vself.vundprodutodev		= produto.und;
								vself.vfracionadodev		= produto.fracionado;
								vself.vvlunitariodev		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);							
								vself.$nextTick(function () {
									$('#edqtditemdev').focus();
								});
							}else{
								vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
								vself.vidprodutodev 		= '';
								vself.vdescricaoprodutodev  = '';
								vself.vundprodutodev		= '';
								vself.vundprodutodev		= '';
								vself.vfracionadodev		= 0;
								vself.vvlunitariodev		= 0;														
								$('#edidprodutodev').focus();
							}
						}).catch(function (response) {
							loader.hide();
						});
					}else{
						vself.vidprodutodev 		= '';
						vself.vdescricaoprodutodev  = '';
						vself.vundprodutodev		= '';
						vself.vundprodutodev		= '';
						vself.vfracionadodev		= 0;
						vself.vvlunitariodev		= 0;														
					}
				}	
            },			
            mtdconsultarproduto(){
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                let payloadx = {
                    idproduto    : null			
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
			}, 
            mtdconsultarprodutodev(){
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
                let payloadx = {
                    idproduto    : null			
                };
                this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
			}, 			           
			mtdhabilitaedicaodescpro(){
				this.vedicaodescpro = false;
				setTimeout(function(){
            		$('#eddescricaoprodutoedicao').focus();
        		}, 300); 				
            },
			mtddesabilitaedicaodescpro(){
				this.vedicaodescpro = true;
			},                        
            mtdincluiritem(coddig){
				if (!util.opcaousuario('020Z.015Z.051Z', this.$store.state.perfilusuario)){
					if (parseFloat(this.vvlunitarioedicao) <= 0){
						this.$toastr.w('Produto sem preço no cadastro. Verifique e tente novamente!', 'Atenção!');
						this.desativaidpro = false;
						return;
					}
				}
				this.mtdmostraritens();	 

				var vldescacres = 0;


				// ATENÇÃO
				var recalcular = false; //rotina para calcular o item por quantidade
				if((this.vqtdminimodescedicao > 0)&&(this.vvldescontoqtdmin > 0)){

					var qtditemvenda = this.mtdpegaqtditemvenda(this.vidprodutoedicao)

					if((qtditemvenda + parseFloat(this.vqtditemedicao)) >= this.vqtdminimodescedicao){
						vldescacres     = this.vvldescontoqtdmin * parseFloat(this.vqtditemedicao);
						this.vvalordescacresedicao = vldescacres;

						if(qtditemvenda + parseFloat(this.vqtditemedicao) === this.vqtdminimodescedicao) {
							recalcular = true
						}else{
							recalcular = false
						}	
					}
				}

				//rotina para calcular desconto promocional
				if(parseFloat(this.vldescontopromocional) > 0){
					let vldescontoUnitario = parseFloat(this.vldescontopromocional) * parseFloat(this.vvlunitarioedicao) / 100
					vldescacres = vldescontoUnitario * parseFloat(this.vqtditemedicao);
					this.vvalordescacresedicao = vldescacres;
				}

                this.vitem++;
                let itemtmp = {
                    idproduto		: this.vidprodutoedicao,
                    descproduto		: this.vdescricaoprodutoedicao,
                    coddig			: coddig,
                    item			: this.vitem,
                    qtditem			: parseFloat(this.vqtditemedicao),
                    unditem			: this.vundprodutoedicao,
                    vlunitario		: parseFloat(this.vvlunitarioedicao),
					prvendaminimo	: parseFloat(this.vprvendaminimo),
                    descacres		: 0,
                    tipodescacres	: 1,
                    valordescacres	: parseFloat(this.vvalordescacresedicao),
                    manipulaval		: this.vmanipulavaledicao,
                    vltotal			: parseFloat(this.vvltotaledicao) - parseFloat(vldescacres),
                    idestoque		: this.lancamentousu.idestoque,
					descestoque		: this.lancamentousu.descestoque,
					infadprod		: '',
					qtdentregar		: parseFloat(this.vqtditemedicao),
					nrvenda			: '',
					adesivo         : '',
					descadesivo     : '',
					coradesivo      : ''
                };
                this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.vvltotaledicao);
                this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);
				if(recalcular){
					this.mtdatzdescontosqtd(this.vidprodutoedicao, this.vvldescontoqtdmin, null)
				}
                this.lstitens.push(itemtmp);
			
				this.vqtdminimodescedicao = 0
				this.vvldescontoqtdmin    = 0

                this.desativaidpro        = false;
                this.vcoddigedicao        = '';
				this.mtdrecalculartudo(false);
				
                setTimeout(function(){
                    util.irfinaldiv('#dv-lst-itens');                                    
                }, 300);                
            },            
            mtdalteraritem(item){
				if (this.vidpedido === ''){				
					let vself = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', 	valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : item.coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];	
							vself.vvltotal_old_edicao		= item.vltotal;//variável para estornar o valor anterior

							vself.alteraentra  				= true;																			
							vself.vitemalteracao			= item.item;
							vself.vedicaodescpro			= true;
							vself.vidprodutoedicao    		= item.idproduto;
							vself.vcoddigedicao				= item.coddig;
							vself.vdescricaoprodutoedicao 	= item.descproduto;
							vself.vundprodutoedicao			= item.unditem;
							vself.vqtditemedicao			= item.qtditem;
							vself.vvltabelaitemedicao		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);
							vself.vvlunitarioedicao			= item.vlunitario;
							vself.vprvendaminimo			= item.prvendaminimo;
							vself.vdescacresedicao			= item.descacres;
							vself.vtipodescacresedicao		= item.tipodescacres;
							vself.vvalordescacresedicao		= item.valordescacres;
							vself.vmanipulavaledicao		= item.manipulaval;
							vself.vvltotaledicao			= item.vltotal;
							vself.vfracionadoedicao			= produto.fracionado;
							vself.vinfadprodedicao   		= item.infadprod;
							vself.vqtdminimodescedicao      = vself.mtdpegadadosdesctabela(1, produto.tabelas, vself.vidtabela)
							vself.vvldescontoqtdmin         = vself.mtdpegadadosdesctabela(2, produto.tabelas, vself.vidtabela)

							vself.videstoqueedicao			= item.idestoque;
							var defestoque  				= new Option(item.descestoque, item.idestoque, true, true);
							$('#cbestoqueedicao').append(defestoque).trigger('change');

							$('#mdedicaoitem').modal('show');		
						}else{
							vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
						}
					}).catch(function (response) {
						vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
						loader.hide();						
					});
				}
            },
			mtdexcluiritem(item){
				let vself = this;
				if (this.vidpedido === ''){
					if (!util.opcaousuario('020Z.015Z.055Z', vself.$store.state.perfilusuario)){
						vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
						return;
					}				
					let indiceitem 		= util.getArrayIndexForKey(vself.lstitens, 'item', item);
					let codpro  = vself.lstitens[indiceitem].idproduto
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : codpro},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];

                            let qtdmin = vself.mtdpegadadosdesctabela(1, produto.tabelas, vself.vidtabela)
					        let vldesc = vself.mtdpegadadosdesctabela(2, produto.tabelas, vself.vidtabela)

							let qtditem_old  = vself.mtdpegaqtditemvenda(vself.lstitens[indiceitem].idproduto)
							let qtdreal      = qtditem_old  - vself.lstitens[indiceitem].qtditem


							if(qtditem_old >=  qtdmin){// quer dizer que os itens tem um desconto por quantidade
								if(qtdreal < qtdmin){
									//vai retirar o desconto
									vself.mtdtiradescontoqtd(vself.lstitens[indiceitem].idproduto, vldesc, null)
									
								}
							}
							vself.vtottaxaentrega = 0;

							vself.lstitens.splice(indiceitem, 1);

							vself.mtdrecalculartudo(false);

							//vself.vtotalgeral	=  vself.vtotalprodutos + vself.vtotalservicos;
							if (!vself.mtdtemtrocadev()){
								if (parseFloat(vself.vtotalgeral) < 0){
									vself.vtotalgeral = 0;
								}
							}
						}else{
							
						}
					}).catch(function (response) {
						
						loader.hide();						
					});

				}
            },
			mtdgravaritem(){
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}
				if (!util.opcaousuario('020Z.015Z.051Z', this.$store.state.perfilusuario)){
					if (parseFloat(this.vvlunitarioedicao) <= 0){
						this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
						$('#edvlunitarioedicao').focus();
						return;
					}
				}
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
				if (this.videstoqueedicao === null){
					this.$toastr.w('Estoque deve ser informado!', 'Atenção!');
					$('#cbestoqueedicao').focus();
					return;
				}
				if (parseInt(this.vmanipulavaledicao) === 1){
					if (!util.opcaousuario('020Z.015Z.052Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Manipulação de valor do item não permitido para o usuário!', 'Informação!');
						return;
					}
				}
				// VERIFICA SE O VALOR DE DESCONTO BATE COM O VALOR DE DESCONTO DA TABELA, SE SIM, PERMITE GRAVAR,
				// SE NÃO, ENTRA NA LÓGICA DO DESCONTO -- Akira e Rodrigo
				if (parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) <= parseFloat(this.vvldescontoqtdmin) 
				&& parseInt(this.vtipodescacresedicao) === 1 && parseFloat(this.vqtditemedicao) >= parseFloat(this.vqtdminimodescedicao)){

				} else { 
					let fatd = 0;
					if (parseInt(this.vdescacresedicao) === 0){					
						if (parseInt(this.vtipodescacresedicao) === 0){
							fatd = this.vvalordescacresedicao;
						}else{
							fatd = parseFloat(this.vvalordescacresedicao) / (parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao)) * 100;
						}
	
						if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
							this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
							$('#edvaldescacresedicao').focus();					
							return;
						}
	
						let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;
	
						if (parseFloat(fatd) > parseFloat(descto_comparar)){
							this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
							$('#cbtipodesctotal').focus();					
							return;
						}
						
						if (parseFloat(this.vprvendaminimo) > 0){
							let vldesconto = 0;
							if (parseInt(this.vtipodescacresedicao) === 0){
								vldesconto = parseFloat(this.vvalordescacresedicao) * parseFloat(this.vvlunitarioedicao) / 100;														
							}else{
								vldesconto = parseFloat(this.vqtditemedicao) > 0 ? parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) : 0;	
							}
							vldesconto		= util.arredondaValores(vldesconto, 2, 'round');
	
							if ((parseFloat(this.vvlunitarioedicao) - parseFloat(vldesconto)) < parseFloat(this.vprvendaminimo)){
								this.$toastr.w('Impossível vender o item com o valor abaixo do mínimo!', 'Atenção!');
								$('#edvlunitarioedicao').focus();
								return;
							}
						}					
					}
					
					//desabilita botão gravar para evitar clique duplo
					$('#btnsalvaritem').prop('disabled', true);
				}
                this.vtotalprodutos = this.vtotalprodutos - parseFloat(this.vvltotal_old_edicao);
				this.metodochamado  = this.metodochamado + ' mtdgravaritem';


                //verificar a quantidade do item 
					
			

                let indiceitem 						= util.getArrayIndexForKey(this.lstitens, 'item', this.vitemalteracao)
                let lsttmp 							= this.lstitens;

				var qtditem_old  = this.mtdpegaqtditemvenda(lsttmp[indiceitem].idproduto)
				var qtdreal      = qtditem_old + this.vqtditemedicao - lsttmp[indiceitem].qtditem
				var op = 0;


				if(parseFloat(this.vqtdminimodescedicao) > 0){
					if(qtdreal >= this.vqtdminimodescedicao){
						if(qtditem_old <  this.vqtdminimodescedicao){
							op = 1
						}
					}else{
						if(qtditem_old >=  this.vqtdminimodescedicao){
							op = 2
						}
					}
				}


                this.lstitens							= [];

				
                lsttmp[indiceitem].descproduto			= this.vdescricaoprodutoedicao;
                lsttmp[indiceitem].qtditem				= this.vqtditemedicao;
                lsttmp[indiceitem].unditem				= this.vundprodutoedicao;
                lsttmp[indiceitem].vlunitario			= this.vvlunitarioedicao;
                lsttmp[indiceitem].descacres			= this.vdescacresedicao;
                lsttmp[indiceitem].tipodescacres		= this.vtipodescacresedicao;
                lsttmp[indiceitem].valordescacres		= this.vvalordescacresedicao; // CAMPO QUE EXIBE O DESCONTO NO MODA
                lsttmp[indiceitem].vvldescontoqtdmin	= this.vvldescontoqtdmin;
                lsttmp[indiceitem].manipulaval			= this.vmanipulavaledicao;
                lsttmp[indiceitem].vltotal				= this.vvltotaledicao;
                lsttmp[indiceitem].idestoque			= this.videstoqueedicao;
				lsttmp[indiceitem].descestoque			= $('#cbestoqueedicao').select2('data')[0]['text'];	
				lsttmp[indiceitem].infadprod			= this.vinfadprodedicao;
				lsttmp[indiceitem].qtdentregar			= this.vqtditemedicao;				

                this.vtotalprodutos 					= this.vtotalprodutos + parseFloat(this.vvltotaledicao);

                this.lstitens 							= lsttmp;
                this.vvltotal_old_edicao				= 0;                
                this.vtotalgeral						=  this.vtotalprodutos + this.vtotalservicos;	
				switch (op) {
					case 1:
						this.mtdatzdescontosqtd(lsttmp[indiceitem].idproduto, this.vvldescontoqtdmin, indiceitem)
					break;
					case 2:
					    this.mtdtiradescontoqtd(lsttmp[indiceitem].idproduto, this.vvldescontoqtdmin, indiceitem)
					break;
				}

			    this.mtdrecalculartudo(false);			

				$('#mdedicaoitem').modal('hide');
				setTimeout(() => {
					$('#btnsalvaritem').prop('disabled', false);
				}, 500);				
            },
			mtdaplicardesconto(){
				if (this.vidpedido === ''){
					if (this.lstitens.length === 0){
						this.$toastr.i('Não há ítens para lançamento do desconto!', 'Informação!');
					}else{
						if (parseInt(this.vpermitedesconto) === 0){
							this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
							return;
						}						
						this.vtipodesctotal		 = 0;
						this.vfatordescontototal = 0;
						this.vtotalsemdesconto   = 0;
						this.vresdesconto		 = 0;
						for (let item of this.lstitens) {
							this.vtotalsemdesconto = this.vtotalsemdesconto + (item.vlunitario * item.qtditem);
						}
						this.vtotalcomdesconto	 = this.vtotalsemdesconto;
						$('#mdaplicardesconto').modal('show');
					}
				}
			},
			mtdaplicaracrescimo(){
				if (this.vidpedido === ''){
					if (this.lstitens.length === 0){
						this.$toastr.i('Não há ítens para lançamento do desconto!', 'Informação!');
					}else{
						if (parseInt(this.vpermitedesconto) === 0){
							this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
							return;
						}				
						this.vtotalsemacrescimo   = 0;		
						this.vtipoacresctotal	  = 0;
						this.vfatordescontototal  = 0;
						this.vfatoracrescimototal = 0;
						this.vresacrescimo		  = 0;
						for (let item of this.lstitens) {
							this.vtotalsemacrescimo = this.vtotalsemacrescimo + (item.vlunitario * item.qtditem);
						}
						this.vtotalcomacrescimo	 = this.vtotalsemacrescimo;
						$('#mdaplicaracrescimo').modal('show');
					}
				}
			},
			mtdconfirmaaplicacaoacrescimo(){
				let fatoraplicar 		= 0;
				
				if (parseInt(this.vtipoacresctotal)){
					fatoraplicar = this.vresacrescimo;					
				}else{
					fatoraplicar = this.vfatoracrescimototal;
				}

				if (fatoraplicar < 0){
					this.$toastr.w('Acréscimo inválido!', 'Informação!');
					$('#edfatordescontototal').focus();
					return;
				}

				for (var i = 0; i < this.lstitens.length; i++) {
					let vldesconto 			= (this.lstitens[i].vlunitario * this.lstitens[i].qtditem) * fatoraplicar / 100;

					vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');

					if (vldesconto >= 0.01){
						this.lstitens[i].descacres		= 1;
						this.lstitens[i].tipodescacres	= 1;
						this.lstitens[i].valordescacres	= vldesconto;
						this.lstitens[i].vltotal		= util.arredondaValores((this.lstitens[i].vlunitario * this.lstitens[i].qtditem) + vldesconto, 2, 'round');
					}else{
						this.lstitens[i].valordescacres	= 0;
						this.lstitens[i].vltotal		= util.arredondaValores(this.lstitens[i].vlunitario * this.lstitens[i].qtditem, 2, 'round');
					}
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);
				    	
				}
				this.vtotalprodutos 	= util.arredondaValores(this.vtotalprodutos, 2, 'round');
				this.vtotalgeral		= this.vtotalgeral + this.vtotalprodutos;	


				this.mtdrecalculartudo(false)		
				$('#mdaplicaracrescimo').modal('hide');

			},
        	mtdconfirmaaplicacaodesconto(){				
				let fatoraplicar 		= 0;

				/// Cara.. essa rotina é muito dificil mas eu vou comentar aqui para me ajudarno futuro e para vcs DEVs - GUGa

				/*Este metodo serve para aplicar um desconto geral na listagem*/

				if (parseInt(this.vtipodesctotal)){ //
					fatoraplicar = parseFloat(this.vresdesconto);					
				}else{
					fatoraplicar = parseFloat(this.vfatordescontototal);
				}
				
				let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

				if (parseFloat(fatoraplicar) > parseFloat(descto_comparar)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
					$('#cbtipodesctotal').focus();					
					return;
				}

				if (parseFloat(fatoraplicar) < 0){
					this.$toastr.w('Desconto inválido!', 'Informação!');
					$('#edfatordescontototal').focus();
					return;
				}

				if (fatoraplicar > 0){
					for (let item of this.lstitens) {
						if (((parseFloat(item.vlunitario) * parseFloat(item.qtditem)) * parseFloat(fatoraplicar) / 100) < 0.01){
							this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
											'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
							return;
						}
					}
				}
				$('#btnconfirmadesconto').prop('disabled', true);
				this.vtotalgeral		= parseFloat(this.vtotalgeral) - parseFloat(this.vtotalprodutos);				
				this.vtotalprodutos		= 0;
				let descacumulado 		= 0;
				let mandarmsg           = false; 
				
				for (var i = 0; i < this.lstitens.length; i++) {
					let dardesc = true;
					//verfica o preco de venda mínimo
					if (parseFloat(this.lstitens[i].prvendaminimo) > 0){
						let vldescpm = 0;
						vldescpm = parseFloat(this.lstitens[i].vlunitario) - (parseFloat(this.lstitens[i].vlunitario) *  parseFloat(fatoraplicar) / 100);

						if (parseFloat(this.lstitens[i].prvendaminimo) > parseFloat(vldescpm)){					
							dardesc   =  false;
							mandarmsg = true;
						}								
					}

					let vldesconto 			= (this.lstitens[i].vlunitario * this.lstitens[i].qtditem) * fatoraplicar / 100;
					
					if (vldesconto < 0.01){
						descacumulado = parseFloat(vldesconto);
					}else{
						descacumulado = 0;
					}

					vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
					if(dardesc){
						if (vldesconto >= 0.01){
							this.lstitens[i].descacres		= 0;
							this.lstitens[i].tipodescacres	= 1;
							this.lstitens[i].valordescacres	= parseFloat(vldesconto) + parseFloat(descacumulado);
							descacumulado = 0;
							this.lstitens[i].vltotal		= util.arredondaValores((parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) - parseFloat(vldesconto), 2, 'round');
						}else{
							this.lstitens[i].valordescacres	= 0;
							this.lstitens[i].vltotal		= util.arredondaValores(parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem), 2, 'round');
						}
						//Totaliza os produtos 
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);	
					}
					
				}

				this.vtotalprodutos 	= util.arredondaValores(parseFloat(this.vtotalprodutos), 2, 'round');

				this.vtotalgeral		= parseFloat(this.vtotalgeral) + parseFloat(this.vtotalprodutos);	
				/////////////////////////////////////////////////////////////////////////////////////////


				//ajuste de valor para resolver dizimas e etc
				let vlajuste = 0;
				let ajustar  = 0;
				if (parseFloat(this.vtotalcomdesconto) > parseFloat(this.vtotalprodutos)){
					vlajuste = parseFloat(this.vtotalcomdesconto) - parseFloat(this.vtotalprodutos);
					ajustar  = 1;//ajuste para menos
				}else{
					vlajuste = parseFloat(this.vtotalprodutos) - parseFloat(this.vtotalcomdesconto);
					ajustar  = 0;//ajuste para mais
				}
				if (vlajuste > 0 && vlajuste < 0.01){
					vlajuste = 0.01;
				}
				if (vlajuste > 0){
					for (var x = 0; x < this.lstitens.length; x++) {
						if (parseFloat(this.lstitens[x].vltotal) > vlajuste){


							let valorDescontoAjuste = 0;
							//ve o tipo de desconto no item 
							if(parseInt(this.lstitens[x].tipodescacres) === 1){// em valor
								valorDescontoAjuste = parseFloat(this.lstitens[x].valordescacres);
							}else{// em percentual
								valorDescontoAjuste = parseFloat(this.lstitens[x].valordescacres) * parseFloat(this.lstitens[x].qtditem) * parseFloat(this.lstitens[x].vlunitario) / 100   
							    
								this.lstitens[x].tipodescacres = 1; //muda o tipo pra valor, para facilitar a nossa vida. 
							}


							if (ajustar === 0){//ajuste para mais
								this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(valorDescontoAjuste) + parseFloat(vlajuste), 2, 'round');
							}else{//ajuste
								this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(valorDescontoAjuste) - parseFloat(vlajuste), 2, 'round');
							}							
							if (this.lstitens[x].valordescacres < 0){
								this.lstitens[x].valordescacres = 0;
							}
							this.lstitens[x].vltotal		= (parseFloat(this.lstitens[x].vlunitario) * parseFloat(this.lstitens[x].qtditem)) - parseFloat(this.lstitens[x].valordescacres);							
							break;
						}
					}
					if (parseInt(ajustar) === 0){
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    - parseFloat(vlajuste);
					}else{
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    + parseFloat(vlajuste);						
					}					
				}	
				this.mtdrecalculartudo(mandarmsg);		
				$('#mdaplicardesconto').modal('hide');
				setTimeout(() => {
					$('#btnconfirmadesconto').prop('disabled', false);
				}, 500);
			},



			mtdconsultapedidoimportar(){
				if (!util.opcaousuario('020Z.015Z.050Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					if (this.lstitens.length > 0 || this.lstservicos.length > 0){
						this.$toastr.w('Venda iniciada, impossível importar pedido!', 'Atenção!');
						return;
					}
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PEDIDO_CHANGE',payload);
					let payloadx = {
						idpedido    : null			
					};
					this.$store.commit('PEDIDO_RETORNO_CHANGE',payloadx);   
				}
			},
			mtdrecalcularprecos(){
				let vself 		= this;
				let lstitenstmp = [];
				for (let item of vself.lstitens) {
					let itemtmp = {
						idproduto		: item.idproduto,
						item			: item.item
					};
					lstitenstmp.push(itemtmp);
				}
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',           valor : 'precosplano'},
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idfilial',     valor : vself.vidfilial},
					{parametro: 'idtabela',     valor : vself.vidtabela},
					{parametro: 'itens',    	valor : JSON.stringify(lstitenstmp)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					$('#mdselecionarplano').modal('hide');			
					console.log("inidep");		
					vself.vtotalgeral	 =  vself.vtotalgeral - vself.vtotalprodutos;
					vself.vtotalprodutos = 0;

					let lstitenscopia = [];
					lstitenscopia     = vself.lstitens;					
					let lstitensret   = response.data;
					let vldesc        = 0
					for (let item of lstitensret) {
						let indi = util.getArrayIndexForKey(lstitenscopia, 'item', item.item);
					    vldesc = 0
						if (parseInt(lstitenscopia[indi].manipulaval) === 0){
							

							if(parseFloat(item.qtdminima) > 0){
								let qtditemvendaold  =	vself.mtdpegaqtditemvenda(lstitenscopia[indi].idproduto)
								if(qtditemvendaold >= item.qtdminima){
									vldesc = parseFloat(item.desconto) * parseFloat(lstitenscopia[indi].qtditem)
								}
							}

							lstitenscopia[indi].vlunitario 		= item.vlunitario;
							lstitenscopia[indi].descacres		= 0;
							lstitenscopia[indi].tipodescacres	= 1;
							lstitenscopia[indi].valordescacres	= vldesc;
							lstitenscopia[indi].manipulaval		= 0;
							lstitenscopia[indi].vltotal			= parseFloat(item.vlunitario) * parseFloat(lstitenscopia[indi].qtditem) - vldesc;
						
						}
						vself.vtotalprodutos = vself.vtotalprodutos + lstitenscopia[indi].vltotal;
						vself.metodochamado  = vself.metodochamado + ' mtdrecalcularprecos';
					}

					vself.lstitens	    = [];
					vself.lstitens	    = lstitenscopia;

					vself.vtotalgeral	=  vself.vtotalgeral + vself.vtotalprodutos;		
					vself.mtdtaxaacrescimo();
					loader.hide();
				}).catch(function (response) {
					$('#mdselecionarplano').modal('hide');
					vself.$toastr.e('Erro ao tentar carregar os preços do plano de pagamento. Descrição do erro: '+response.message, 'Erro!');
					loader.hide();
				});
			},			
            mtdatribuirplano(id, calcularprecos){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
					{parametro: 'idpdv',        valor : vself.lancamentousu.idpdv}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanospagamento.php');
                retorno.then(function (response) {
                    loader.hide();
                    let plano                               	   = response.data[0];
                    vself.vidplano                          	   = plano.id;
					vself.vtipoplano                        	   = plano.tipo;
					vself.vdescplano                        	   = plano.descricao;
					vself.vidtabela	                        	   = plano.idtabela;
					vself.vpercentrada		                	   = plano.percentrada;
					vself.vpermitedesconto	                	   = plano.permitedesconto;

                    vself.lancamentousu.idforma             	   = plano.idforma;
                    vself.lancamentousu.descforma           	   = plano.descforma;
                    vself.lancamentousu.tipoforma           	   = plano.tipoforma;

                    vself.lancamentousu.plano.id            	   = plano.id;
                    vself.lancamentousu.plano.descricao     	   = plano.descricao;
                    vself.lancamentousu.plano.idforma       	   = plano.idforma;
                    vself.lancamentousu.plano.descforma     	   = plano.descforma;
                    vself.lancamentousu.plano.idtabela      	   = plano.idtabela;
                    vself.lancamentousu.plano.desctabela    	   = plano.desctabela;
                    vself.lancamentousu.plano.tipo          	   = plano.tipo;
                    vself.lancamentousu.plano.tipoforma     	   = plano.tipoforma;
					vself.lancamentousu.plano.prazosplanos  	   = plano.prazosplanos;
					vself.lancamentousu.plano.percentualacrescimo  = plano.percentualacrescimo;

					vself.lancamentousu.fiscalautomatico           = parseInt(plano.fiscalautomatico);
	

					//16/12/2022 - Carrega o perfil do fluxo do plano
					vself.lancamentousu.idperfilfluxo		       = plano.idperfilfluxo;
					vself.lancamentousu.descperfilfluxo		       = plano.descperfilfluxo;
					if (vself.lstitens.length > 0 && calcularprecos){
						vself.mtdrecalcularprecos();
					}

					if((vself.lstitens.length > 0) && (parseFloat(plano.percentualacrescimo) > 0)){
						vself.mtdtaxaacrescimo();
					}

                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdlocalizapedido(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'infcredito',   valor : '1'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
					loader.hide();				
					if (parseInt(response.data.pedidos[0].liberarfat) === 0){					
						if (parseInt(response.data.pedidos[0].atraso) > parseInt(response.data.pedidos[0].qtddiasbloqvenda)){
							vself.$toastr.w('Cliente com débitos em atraso. Favor entrar em contato com o setor responsável!', 'Informação!');
							return;
						}
					}
					vself.mtdigualarpedido(response.data.pedidos[0], vself.mtdatribuirplano);
                    $('#edlidproduto').focus();
                }).catch(function (response) {
                    loader.hide();
                });
			},
			mtddefinicoesvenda(){
				if (this.vidpedido === ''){				
					if (!util.opcaousuario('020Z.015Z.070Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {				
						//variáveis de definições da venda
						this.didcliente			  = this.vidcliente;
						this.dnomecliente		  = this.vnomecliente;
						this.dexigirentrada		  = this.vexigirentrada;
						this.dpercentrada		  = this.vpercentradacli;


					
						this.didplano			  = this.vidplano;
						this.dvlcreditodisponivel = this.vvlcreditodisponivel;
						this.dobservacoes		  = this.vobservacoes;	
						this.dlstplanos			  = [];
						
						this.mtdlocalizarplanos();

						var defvendedor  = new Option(this.vnomevendedor, this.vidvendedor, true, true);
						$('#cbvendedordef').append(defvendedor).trigger('change');				

						$('#mddefinircoesvenda').modal('show');
					}
				}	
			},
			mtdconfirmaratribuicoesvenda(){
				if (this.didcliente === ''){
					this.$toastr.w('Cliente deve ser informado', 'Informação!');
					$('#eddcliente').focus();					
					return;
				}
				if (this.didplano === null){
					this.$toastr.w('Plano de pagamento deve ser informado', 'Informação!');
					$('#cbplanodef').focus();					
					return;
				}
				if (this.didvendedor === null){
					this.$toastr.w('Vendedor deve ser informado', 'Informação!');
					$('#cbvendedordef').focus();					
					return;
				}
				let indp 					= util.getArrayIndexForKey(this.dlstplanos, 'id', this.didplano);
				this.vidcliente				= this.didcliente;
				this.vnomecliente			= this.dnomecliente;
				this.vexigirentrada         = this.dexigirentrada;
				this.vpercentradacli        = this.dpercentrada;
				this.vvlcreditodisponivel 	= this.dvlcreditodisponivel;				
				this.vidplano			    = this.didplano;
				this.vtipoplano			    = this.dlstplanos[indp].tipo;
				this.vdescplano			    = this.dlstplanos[indp].descricao;
				this.vidvendedor		    = this.didvendedor;
				this.vnomevendedor	    	= $('#cbvendedordef').select2('data')[0]['text'];
				this.vidtabela		    	= this.dlstplanos[indp].idtabela;
				this.vpercentrada		    = this.dlstplanos[indp].percentrada;
				this.vpermitedesconto	    = this.dlstplanos[indp].permitedesconto;
				this.vobservacoes 		    = this.dobservacoes;
				$('#mddefinircoesvenda').modal('hide');
				this.mtdatribuirplano(this.didplano, true);
			},
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},                        
            mtdigualarpedido(registro, callback){			
                this.vidpedido          = registro.id;
				this.vidcliente			= registro.idcliente;
				this.vnomecliente		= registro.nomecliente;
				this.vvlcreditodisponivel = registro.vlcreditodisponivel;
                this.vidvendedor		= registro.idvendedor;
                this.vnomevendedor      = registro.nomevendedor;
				this.vtipo				= registro.tipo;
				this.vdtemissao			= registro.dtemissao;
				this.vtotalprodutos		= registro.totalprodutos;
				this.vtotalservicos		= registro.totalservicos;
				this.videntificador		= registro.identificador;
				this.vobjeto			= registro.objeto;
				this.vmarcacao			= registro.marcacao;
				this.vnrserie			= registro.nrserie;
				this.vmarca				= registro.marca;
				this.vmodelo			= registro.modelo;
				this.vresponsavel		= registro.responsavel;
				this.vfone				= registro.fone;
				this.vdefeitoapresentado= registro.defeitoapresentado;
				this.vacessorios		= registro.acessorios;
				this.voutrasinformacoes	= registro.outrasinformacoes;
				this.vobservacoes		= registro.observacoes;
				this.vtotalgeral		= registro.totalgeral;
				this.vstpedido			= registro.stpedido;
				this.vreservar			= registro.reservar;
				this.ventregaexterna	= registro.entregaexterna;
				this.vorigem			= registro.origem;
				this.lstitens			= registro.itens;
				this.lstservicos		= registro.servicos;			
				this.vitem				= registro.itens.length === 0 ? 0 : registro.itens[registro.itens.length - 1].item;		
				this.vidplano			= registro.idplano;
				this.vtipoplano			= registro.tipoplano;
				this.vdescplano			= registro.descplano;
                this.vidtabela			= registro.idtabela;
				this.vpercentrada		= registro.percentrada;
				this.vpermitedesconto	= registro.permitedesconto;
				this.vliberarfat		= registro.liberarfat;				
				///oculos
				this.vativainfooculos          = registro.ativainfooculos;
				this.vesfericoesquerdoperto    = registro.esfericoesquerdoperto;
				this.vcilindricoesquerdoperto  = registro.cilindricoesquerdoperto;
				this.veixoesquerdoperto        = registro.eixoesquerdoperto;
				this.vadicaoesquerdoperto      = registro.adicaoesquerdoperto;

				this.vesfericodireitoperto     = registro.esfericodireitoperto;
				this.vcilindricodireitoperto   = registro.cilindricodireitoperto;
				this.veixodireitoperto         = registro.eixodireitoperto;
				this.vadicaodireitoperto       = registro.adicaodireitoperto;
 
				this.vesfericoesquerdolonge    = registro.esfericoesquerdolonge;
				this.vcilindricoesquerdolonge  = registro.cilindricoesquerdolonge;
				this.veixoesquerdolonge        = registro.eixoesquerdolonge;
				this.vadicaoesquerdolonge      = registro.adicaoesquerdolonge;

				this.vesfericodireitolonge     = registro.esfericodireitolonge;
				this.vcilindricodireitolonge   = registro.cilindricodireitolonge;
				this.veixodireitolonge         = registro.eixodireitolonge;
				this.vadicaodireitolonge       = registro.adicaodireitolonge;

				this.vdptotal                  = registro.dptotal
                

                this.vdtfatura          	   = util.DataAtual(true);
                
                callback(registro.idplano, false);

            },
			mtdgerartitulos(lstbase, valor){
				this.lsttitulosfaturar = [];

				let vlparcela = valor / lstbase.length;

				for (var i = 0; i < lstbase.length; i++) {
					let titulo = {
						codtit 				: this.mtdformatarzeros(i + 1, 2) + '-'+lstbase.length,
						dtventit			: util.somaDias(this.mtdformatadatagravar(this.vdtfatura), parseInt(lstbase[i]['prazo'])),
						vltit				: vlparcela,
						idtipocobranca		: lstbase[i]['idtipocob'],
						tipocobranca		: lstbase[i]['tipocobranca'],// 0 - Normal 1 - Cheque
						descricaocob		: lstbase[i]['descricaocob'],
						numerocheque		: '',
						idbanco				: null,
						descbanco			: '',
						agencia				: '',
						conta				: '',
						praca				: '',
						emitente			: '',
						cnpjcpf				: '',						
						idsituacaocheque	: null,
						descsituacaocheque	: ''
					}
					this.lsttitulosfaturar.push(titulo);
				}
				this.vtotaltitulos = valor;
			},
			mtdvisualizarcashback(){
				let vself = this;
				vself.vltotalcashback 			= 0;
				vself.vlcashbackdisponivelvenda = 0;
				if(parseInt(vself.lancamentousu.ativacashback) === 1){
					let loader      = vself.$loading.show();
					// let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.vidcliente;
					// let parametros  = [
					// 	{parametro: 'op',           	valor : 'listagem'},
					// 	{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					// 	{parametro: 'idclientesac', 	valor : vself.$store.state.filialpadrao.idcliente},
					// 	{parametro: 'filtro',       	valor : filtro},
					// 	{parametro: 'limit',        	valor : 1},
					// 	{parametro: 'offset',       	valor : 0},
					// ];
					let parametros  = [
						{parametro: 'op',           	valor : 'consultacb'},
						{parametro: 'idcliente', 		valor : vself.vidcliente},
						{parametro: 'idclientesac', 	valor : vself.$store.state.filialpadrao.idcliente}
					];				
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						loader.hide();
						if (response.data.length > 0){
							
							vself.vltotalcashback 			= parseFloat(response.data[0].vlcredito) - parseFloat(response.data[0].vlcreditoutilizado)
							
							if(parseInt(vself.lancamentousu.ativacashback) === 1){
								if( parseFloat(vself.lancamentousu.resgateminimocb) > 0){
									if(parseFloat(vself.vtotalgeral) >=  parseFloat(vself.lancamentousu.resgateminimocb)){
										vself.vlcashbackdisponivelvenda = util.arredondaValores( parseFloat(vself.lancamentousu.fatorcreditoutilizar) * parseFloat(vself.vtotalgeral) / 100, 2, 'round');
									}else{
										vself.vlcashbackdisponivelvenda = 0;
									}
								}else{
									vself.vlcashbackdisponivelvenda = util.arredondaValores( parseFloat(vself.lancamentousu.fatorcreditoutilizar) * parseFloat(vself.vtotalgeral) / 100, 2, 'round');
								}
								if (vself.vlcashbackdisponivelvenda > vself.vltotalcashback){
									vself.vlcashbackdisponivelvenda = vself.vltotalcashback;
								}
							}else{
								vself.vltotalcashback           = 0;
								vself.vlcashbackdisponivelvenda = 0;
							}
						}
					}).catch(function (response) {
						console.log(response);
						vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
						$('#cbformapagamento').focus();
						loader.hide();
					});	
				}				
			},			            
            mtdfinalizarvenda(){
                let vself = this;
                if (vself.lstitens.length > 0 || vself.lstservicos.length > 0){                    
                    $("#cbformapagamento").val(null).trigger('change');
                    vself.vdtfatura			= util.DataAtual();					
					vself.temtrocadev 		= vself.mtdtemtrocadev();
                    vself.vvlforma			= 0;
                    vself.lstformasfaturar 	= [];
                    vself.lsttitulosfaturar = [];
					vself.sringaleatoria    = util.GerarStringAleatoria();
					vself.vgerarnfce		= parseInt(vself.lancamentousu.padraonfce) === 0 ? false : true;

					var defvendedor  = new Option(vself.vnomevendedor, vself.vidvendedor, true, true);
					$('#cbvendedorfinalvenda').append(defvendedor).trigger('change');					

					//if (!vself.temtrocadev){
					if (vself.vtotalgeral > 0){	
						//inclui a forma de pagamento cadastrada no plano
						let forma = {
							idforma 	   : vself.lancamentousu.idforma,
							descforma	   : vself.lancamentousu.descforma,
							vlforma		   : vself.vtotalgeral,
							tipo		   : vself.lancamentousu.tipoforma,
							idperfilfluxo  : vself.lancamentousu.idperfilfluxo,
							descperfilfluxo: vself.lancamentousu.descperfilfluxo														
						};
						vself.lstformasfaturar.push(forma);
						/////////////////////////////////////////////////

						if (parseInt(vself.lancamentousu.fiscalautomatico) === 1){
							vself.$toastr.w('Forma de pagamento definida para emissão AUTOMÁTICA de NFC-e!', 'Informação!');
							vself.vgerarnfce = true;							
						}

						//se o plano for a prazo, gera as parcelas
						if (parseInt(vself.lancamentousu.plano.tipo) === 1){
							vself.mtdgerartitulos(vself.lancamentousu.plano.prazosplanos, vself.vtotalgeral);				
						}
					}

					vself.mtdvisualizarcashback();

                    vself.mtdsomarformas();
					
					$("#btnfinalizarvenda").attr("disabled", false);
                    $('#mdfinalizarvenda').modal('show');										
                }else{
					this.$toastr.w('Não há itens para finalização da venda!', 'Atenção!');
					$('#edlidproduto').focus();
                }
			},
			mtdtemespecie(){
				let existe = false;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.especie) === 1) {
						existe = true;
						break;
					}
				}
				return existe;
			},
			mtdrotinasfinaisvenda(){
				let vself 		= this;

				if (parseInt(vself.planocliente) < 2 && vself.vgerarnfce){
					vself.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla funcionalidade de <strong>Emissão de NFC-e</strong>! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									});
					vself.vgerarnfce = false;
					return;
				}

				let vlcredito 	= 0;
				vself.sringaleatoria = util.GerarStringAleatoria();

				if (vself.vidvendedorfinal === null){
					this.$toastr.w('Vendedor deve ser informado', 'Informação!');
					$('#cbvendedorfinalvenda').select2('open');					
					return;
				}

				if (vself.temtrocadev  && parseFloat(vself.vdiferenca) > 0 && !vself.mtdtemespecie()){					
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Existe um saldo a ser devolvido. Deseja gerar um crédito para esta venda?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vlcredito = vself.vdiferenca;
									vself.mtdconfirmarfinalizacaovenda(vlcredito);
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () { 
									vself.sringaleatoria = '';                                   
                                }
                            }
                        }
                    });					
				}else{
					vself.mtdconfirmarfinalizacaovenda(0);
				}
			},
			mtdconfirmarfinalizacaovenda(vlcredito){
				let vself  	       = this;
				let vlaprazo       = 0;
				let vlentrada      = 0;
				let temaprazo      = false;
				let temformapadrao = false;
				
				for (let forma of this.lstformasfaturar) {
					//verifica se a forma padrão do plano está presente
					if(parseInt(forma.idforma) === parseInt(vself.lancamentousu.idforma)){
						temformapadrao = true;
					}
					
					if (parseInt(forma.tipo) === 1){ //
						temaprazo = true;
						vlaprazo  = vlaprazo + parseFloat(forma.vlforma);
					}else{
						vlentrada = vlentrada + parseFloat(forma.vlforma);
					}
				}
				if(!temformapadrao){
					if(util.opcaousuario('020Z.010Z.290Z', this.$store.state.perfilusuario)){
						this.$toastr.w('A forma padrão do plano de pagamento: '+ vself.lancamentousu.descforma +' está ausente, é obrigatório informá-la!', 'Atenção!');
						return;
					}
				}
				if (parseInt(this.vliberarfat) === 0){
					if (temaprazo){
						if (parseFloat(vlaprazo) > parseFloat(this.vvlcreditodisponivel)){	
							this.$toastr.w('Limite de crédito disponível está inferior ao valor da venda a prazo. Favor Entrar em contato com o setor financeiro!', 'Atenção!');
							return;
						}					
					}
				}

				if (this.vtotalgeral > 0){	
					if (this.lstformasfaturar.length === 0){
						this.$toastr.w('Informe as formas de pagamento!', 'Atenção!');
						return;
					}				
				}
				if (parseFloat(this.vtotalformas).toFixed(2) !== parseFloat(this.vtotalgeral).toFixed(2)){
					if (parseFloat(this.vtotalformas) < parseFloat(this.vtotalgeral)){
						this.$toastr.w('A soma das formas de pagamento é inferior ao valor da venda. Verifique e tente novamente!', 'Atenção!');
						return;
					}
				}
				if (!vself.temtrocadev && parseFloat(this.vdiferenca) > 0){
					if (!this.mtdtemespecie()){
						this.$toastr.w('Para troco deve existir uma forma de pagamento em espécie. Verifique e tente novamente!', 'Atenção!');
						return;						
					}
				}

				if (parseInt(this.lancamentousu.plano.tipo) === 1){
					if (parseFloat(this.vpercentrada) > 0){
						let vlentradaplano = parseFloat(this.vtotalgeral) * parseFloat(this.vpercentrada) / 100;
						if (parseFloat(vlentrada).toFixed(2) < parseFloat(vlentradaplano).toFixed(2)){	
							this.$toastr.w('Valor da entrada é inferior ao permitdo pelo plano! Valor mínimo deve ser: R$ '+this.mtdformatavalordecimal(vlentradaplano, 2)+'.', 'Atenção!');
							return;
						}
					}

					if (parseFloat(this.vpercentradacli) > 0){
						let vlentradacli = parseFloat(this.vtotalgeral) * parseFloat(this.vpercentradacli) / 100;
						if (parseFloat(vlentrada) < parseFloat(vlentradacli)){	
							this.$toastr.w('Valor da entrada é inferior ao permitdo para o cliente! Valor mínimo deve ser: R$ '+this.mtdformatavalordecimal(vlentradacli, 2)+'.', 'Atenção!');
							return;
						} 
					}

					if (this.lsttitulosfaturar.length === 0){
						this.$toastr.w('Para um plano à prazo, as parcelas devem ser informadas!', 'Atenção!');
						return;
					}					
					if (this.mtdpendenciasparcela()){//se estiver faltando algum campo do cheque ser preenchido
						this.$toastr.w('Algum(ns) título(s) definido(s) como cheque não apresenta(m) todas as informações preenchidas. Verifique e tente novamente!', 'Atenção!');
						return;					
					}
					if (!this.mtdverificasomaparcelas()){//verifica se a soma dos títulos é diferente da forma a prazo
						this.$toastr.w('A soma dos títulos não confere com o valor da forma à prazo. Verifique os valores das parcelas!', 'Atenção!');
						return;					
					}				
				}

				if (this.vgerarnfce === true){
					if (this.lstservicos.length > 0){
						this.$toastr.w('Impossível emitir NFC-e com serviços na venda!', 'Atenção!');
						return;							
					}
				}				
				$("#btnfinalizarvenda").attr("disabled", true);
				this.vidvendedor = this.vidvendedorfinal;

				let hora   	= util.DataAtual(true, true);
				hora 		= hora.substring(11, 19);
				setTimeout(() => {
					//let loader 	= vself.$loading.show();
					vself.statusaxios		= 'Finalizando a venda! Aguarde...';
					$('#mdstatusaxios').modal('show');
					let registrocrud = {
						'id'                		: this.vidpedido,
						'idagendamento'             : this.vidagendamentopet,
						'idfilial'          		: this.vidfilial,
						'idcliente'					: this.vidcliente,
						'doccli'					: this.vdoccli,
						'idvendedor'				: this.vidvendedor,
						'tipo'						: this.vtipo ,
						'dtemissao'					: this.mtdformatadatagravar(this.vdtemissao),
						'idplano'					: this.vidplano,
						'totalprodutos'				: this.vtotalprodutos,
						'totalservicos'				: this.vtotalservicos,
						'identificador'				: this.videntificador,
						'objeto'					: this.vobjeto,
						'marcacao'					: this.vmarcacao,
						'nrserie'					: this.vnrserie,
						'marca'						: this.vmarca,
						'modelo'					: this.vmodelo,
						'responsavel'				: this.vresponsavel,
						'fone'						: this.vfone,
						'defeitoapresentado'		: this.vdefeitoapresentado,
						'acessorios'				: this.vacessorios,
						'outrasinformacoes'			: this.voutrasinformacoes,
						'observacoes'				: this.vobservacoes,
						'totalgeral'				: this.vtotalgeral,
						'totfrete'				    : this.vtottaxaentrega,
						'identregador'				: this.ventregador,
						'tottaxaservico'			: this.vtottaxaservico,
						'stpedido'					: this.vstpedido,
						'dtfatura'					: this.vdtfatura,
						'reservar'					: this.vreservar,
						'entregaexterna'			: this.ventregaexterna,
						'origem'					: this.vorigem,
						'itens'						: this.lstitens,
						'servicos'					: this.lstservicos,
						'idlancamentopdv'			: this.lancamentousu.id,
						'idperfiltrocovirtualvenda'	: this.vidperfiltrocovirtualvenda,
						'idperfiltrocovirtualreceb'	: this.vidperfiltrocovirtualreceb,
						'dtfatura'     				: this.mtdformatadatagravar(util.DataAtual(true, false))+' '+hora,
						'vltroco'					: this.vdiferenca,
						'formas'     				: this.lstformasfaturar,
						'titulos'     				: this.lsttitulosfaturar,
						'trocovirtual'      		: this.vseltrocovirtual === true ? 1 : 0,
						'vlcredito'					: vlcredito,
						'temtroca'					: this.temtrocadev === true ? 1 : 0,

						'esfericoesquerdoperto'	 	: this.vesfericoesquerdoperto,
						'cilindricoesquerdoperto'	: this.vcilindricoesquerdoperto,
						'eixoesquerdoperto'		 	: this.veixoesquerdoperto,
						'adicaoesquerdoperto'	 	: this.vadicaoesquerdoperto,

						'esfericodireitoperto'	 	: this.vesfericodireitoperto,
						'cilindricodireitoperto' 	: this.vcilindricodireitoperto,
						'eixodireitoperto'		 	: this.veixodireitoperto,
						'adicaodireitoperto'	 	: this.vadicaodireitoperto,

						'esfericoesquerdolonge'	 	: this.vesfericoesquerdolonge,
						'cilindricoesquerdolonge'	: this.vcilindricoesquerdolonge,
						'eixoesquerdolonge'		 	: this.veixoesquerdolonge,
						'adicaoesquerdolonge'	 	: this.vadicaoesquerdolonge,

						'esfericodireitolonge'	 	: this.vesfericodireitolonge,
						'cilindricodireitolonge' 	: this.vcilindricodireitolonge,
						'eixodireitolonge'		 	: this.veixodireitolonge,
						'adicaodireitolonge'	 	: this.vadicaodireitolonge,
						'ativainfooculos'           : this.vativainfooculos,
						'dptotal'                   : this.vdptotal,   


						//Luiz Trindade - Inclusão do id do pedido do ifood
						'ifoodOrderId'				: localStorage.getItem("ifoodOrderId"),
					};
					let opcrud = 0;
				
					if(this.vidpedido === '' ){
						opcrud = 1
					}else{
						opcrud = 2
					}
					
					let parametros      = [
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           	valor : 'rotinacrud'},
						{parametro: 'opcrud',       	valor : opcrud},
						{parametro: 'registro',     	valor : JSON.stringify(registrocrud)},
						{parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        	valor : '020Z.010Z.010Z'},
						{parametro: 'straleatoria',     valor : vself.sringaleatoria},
						{parametro: 'faturarsemsaldo',	valor : util.opcaousuario('020Z.010Z.090Z', this.$store.state.perfilusuario) === false ? 0 : 1},
						{parametro: 'idpdv',        	valor : this.lancamentousu.idpdv},
					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						//loader.hide();					
						if ($.isNumeric(response.data.inf)){
							let gnf = vself.vgerarnfce;
							$('#mdfinalizarvenda').modal('hide');
							vself.vidultimopedido = response.data.inf;
							if(vself.lstcomandasvenda.length > 0){
								vself.mtdprocessacomandas(vself.lstcomandasvenda)
							}
						
							vself.mtdlimparvenda(false, vself.mtdatribuirplano, true);
		
							if (!gnf){							
								setTimeout(function(){
									$('#mdstatusaxios').modal('hide');
									$('#edlidproduto').focus();
								}, 500);						
								vself.$toastr.s('Venda registrada com sucesso!', 'Informação!');
								vself.mtdimprimirpedido(response.data.inf, 1);

								//Luiz Trindade - Resetar id de pedido do ifood
								localStorage.setItem("ifoodOrderId", "");
							}else{
								vself.statusaxios = 'Enviando NFC-e! Aguarde...';
								let pedido = response.data.pedido;
								vself.mtdgerarenviarnfce(pedido, '65');
							}
						}else{
							setTimeout(function(){
								$("#btnfinalizarvenda").attr("disabled", false);
								$('#mdstatusaxios').modal('hide');
								$('#edlidproduto').focus();
							}, 500);
							let tpret = response.data.inf.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
									break;
								case 'E': default:
									//vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
									vself.$toastr.e('Erro ao tentar enviar a NFC-e. Favor entrar no módulo de GERENCIAMENTO DE NOTAS para verificação do problema.', 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						//loader.hide();
						setTimeout(function(){
							$("#btnfinalizarvenda").attr("disabled", false);
							$('#mdstatusaxios').modal('hide');
							$('#edlidproduto').focus();
						}, 500);
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});					
				}, 200);
			},
			mtdgerarenviarnfce(pedido, modelo){
				let vself  			= this;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'gerarenviarnf'},
					{parametro: 'pedido',     	valor : JSON.stringify(pedido)},
					{parametro: 'modelo',     	valor : modelo},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        valor : '020Z.010Z.065Z'}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					$('#mdstatusaxios').modal('hide');
					if ($.isNumeric(response.data)){
						vself.$toastr.s('NFC-e enviada com sucesso!', 'Informação!');
						$('#edlidproduto').focus();
						vself.mtdimprimirdanfe(response.data);
					}else{
						setTimeout(function(){
							$('#mdstatusaxios').modal('hide');
							$('#edlidproduto').focus();
						}, 500);
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					setTimeout(function(){
						$('#mdstatusaxios').modal('hide');
						$('#edlidproduto').focus();
					}, 500);
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});			
			},			
			mtdsomarformas(){
				let sf 		= 0;
				let totalg 	= util.arredondaValores(parseFloat(this.vtotalgeral), 2, 'round');
				for (let forma of this.lstformasfaturar) {
					sf = sf + forma.vlforma;
				}
				this.vtotalformas = util.arredondaValores(parseFloat(sf), 2, 'round');
				if (parseInt(parseFloat(this.vtotalformas) * 100) < parseInt(parseFloat(totalg * 100))){
					this.vvlforma 	= totalg - this.vtotalformas;
					this.vdiferenca = 0;
				}else{
					let vtotf = parseInt(parseFloat(this.vtotalformas) * 100);
					let vtot  = parseInt(parseFloat(totalg * 100));

					//this.vdiferenca = this.vtotalformas - this.vtotalgeral;
					this.vdiferenca = (parseFloat(vtotf) / 100) - (parseFloat(vtot) / 100);
				}
			},
			mtdincluirforma(){
				var vself       = this;
				if (vself.vidformapagamento === null){
					vself.$toastr.w('Forma de pagamento deve ser informada!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}
				if (vself.vvlforma <= 0){
					vself.$toastr.w('Valor da forma de pagamento inválido!', 'Informação!');
					$('#edvlforma').focus();
					return;					
				}
				if (parseInt(vself.vtipoplano) === 0 && parseInt(vself.vtipoforma) === 1){
					vself.$toastr.w('Forma de pagamento A PRAZO não é permitida para um plano de pagamento A VISTA!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}
				if (parseInt(vself.vabatecredito) === 1 && vself.vnrvendaforma === ''){
					vself.$toastr.w('Informe o número da venda para o resgate!', 'Informação!');
					$('#ednrvendaforma').focus();
					return;					
				}

				if (parseInt(vself.vabatecredito) === 1){
					let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.lancamentousu.fatorcreditoutilizar) * parseFloat(vself.vtotalgeral) / 100, 2, 'round');				
					if (parseInt(parseFloat(vself.vvlforma) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
						vself.$toastr.w('O valor permitido para uso do crédito/cashback não pode ultrapassar '+util.formatavalordecimais(vllimitecreditoabater, 2)+' ('+vself.lancamentousu.fatorcreditoutilizar+'%). Verifique e tente novamente!', 'Informação!');
						return;						
					}
				}

				if (parseInt(vself.vtipoforma) === 3 && vself.vqtdparcelascartao <= 0){
					vself.$toastr.w('Quantidade de parcelas do cartão inválida!', 'Informação!');
					$('#edqtdparcelascartao').focus();
					return;					
				}
				if (parseInt(vself.vtipoforma) === 3 && vself.vnsu === ''){
					vself.$toastr.w('NSU deve ser informado!', 'Informação!');
					$('#ednsu').focus();
					return;
				}									
				let vlformatmp = 0;
				if (vself.temtrocadev){
					if (vself.temtrocadev && vself.vdiferenca > 0){
						vlformatmp = vself.vvlforma * (-1);
					}else{
						vlformatmp = vself.vvlforma;						
					}
				}else{
					vlformatmp = vself.vvlforma;
				}
				if (vself.mtdtemespecie() && parseInt(vself.vespecieforma) === 1){
					vself.$toastr.w('Já existe uma forma em espécie lançada na venda!', 'Informação!');
					return;
				}
				if (parseInt(vself.vfiscalautomatico) === 1){
					vself.$toastr.w('Forma de pagamento definida para emissão AUTOMÁTICA de NFC-e!', 'Informação!');
					vself.vgerarnfce = true;
				}
				if (vself.vnrvendaforma === ''){//caso não seja resgate
					let forma = {
						idforma 	     : vself.vidformapagamento,
						descforma	     : $('#cbformapagamento').select2('data')[0]['text'],
						vlforma		     : vlformatmp,
						tipo		     : vself.vtipoforma,
						especie		     : vself.vespecieforma,
						nrvenda		     : vself.vnrvendaforma,
						qtdparcelascartao: parseInt(vself.vtipoforma) === 3 ? vself.vqtdparcelascartao : 0,
						nsu			     : parseInt(vself.vtipoforma) === 3 ? vself.vnsu : '',
						idperfilfluxo    : vself.vidperfilfluxoforma,
						descperfilfluxo  : vself.vdescperfilfluxoforma												
					};				
					if (!util.findValInArray(vself.lstformasfaturar, 'idforma', vself.vidformapagamento)){
						vself.lstformasfaturar.push(forma);
						
						if (parseInt(forma.tipo) === 1 && vself.lancamentousu.plano.prazosplanos.length > 0){
							vself.lsttitulosfaturar = [];
							vself.mtdgerartitulos(vself.lancamentousu.plano.prazosplanos, forma.vlforma);
						}

						$("#cbformapagamento").val(null).trigger('change');
						vself.vvlforma			= 0;
					}else{
						vself.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
					}
					vself.mtdsomarformas();
					$('#cbformapagamento').focus();
				}else{//resgate
					let loader      = vself.$loading.show();
					let filtro      = ' and p.stpedido=1 and p.id='+vself.vnrvendaforma;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if (response.data.pedidos.length > 0){
							if (parseInt(response.data.pedidos[0].creditoindividual) === 1){//caso o crédito for individual
								if (parseInt(response.data.pedidos[0].idcliente) !== parseInt(vself.vidcliente)){//verifica se o cliente é o titular do crédito. caso não for não libera
									vself.$toastr.i('O crédito em questão só pode ser utilizado pelo cliente titular!', 'Informação!');
									return;
								}
							}
							let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
							if (vself.vvlforma > vlcreditodisp){
								vself.$toastr.i('Valor do crédito desta venda não é suficiente ou não está disponível para resgate!', 'Informação!');
								$('#cbformapagamento').select2('open');
								return;
							}else{
								let forma = {
									idforma 	     : vself.vidformapagamento,
									descforma	     : $('#cbformapagamento').select2('data')[0]['text'],
									vlforma		     : vlformatmp,
									tipo		     : vself.vtipoforma,
									especie		     : vself.vespecieforma,
									nrvenda		     : vself.vnrvendaforma,
									qtdparcelascartao: parseInt(vself.vtipoforma) === 3 ? vself.vqtdparcelascartao : 0,
									nsu				 : parseInt(vself.vtipoforma) === 3 ? vself.vnsu : '',
									idperfilfluxo    : vself.vidperfilfluxoforma,
									descperfilfluxo  : vself.vdescperfilfluxoforma															
								};				
								if (!util.findValInArray(vself.lstformasfaturar, 'idforma', vself.vidformapagamento)){
									vself.lstformasfaturar.push(forma);
									
									if (parseInt(forma.tipo) === 1 && vself.lancamentousu.plano.prazosplanos.length > 0){
										vself.lsttitulosfaturar = [];
										vself.mtdgerartitulos(vself.lancamentousu.plano.prazosplanos, forma.vlforma);
									}

									$("#cbformapagamento").val(null).trigger('change');
									vself.vvlforma			= 0;
								}else{
									vself.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
								}
								vself.mtdsomarformas();
								$('#cbformapagamento').focus();
							}
						}else{
							vself.$toastr.w('Venda não encontrada/cancelada no sistema. Verifique corretamente se a venda permite que o crédito seja resgatado e tente novamente!', 'Informação!');
							$('#ednrvendaforma').focus();
						}
					}).catch(function (response) {
						console.log(response);
						vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
						$('#cbformapagamento').focus();
						loader.hide();
					});
				}
			},	
			mtddeletarforma(index){
				if (parseInt(this.lstformasfaturar[index].tipo) === 1){
					this.lsttitulosfaturar = [];
				}
				this.lstformasfaturar.splice(index, 1); 
				this.mtdsomarformas();
            },
			mtdalterartitulo(titulo, i){
				// if (!util.opcaousuario('020Z.010Z.110Z', this.$store.state.perfilusuario)){
				// 	this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				// 	return;
				// }
				this.tindiceparcela			= i;
				this.tajustarparcelas		= false;
				this.tajustarcentavos		= false;
				this.tajustardatas			= false;

				this.tacodtit 				= titulo.codtit;
				this.tadtventit				= titulo.dtventit;
				this.tavltit				= titulo.vltit;
				this.taidtipocobranca		= titulo.idtipocobranca;
				this.tatipocobranca			= titulo.tipocobranca;
				this.tadescricaocob			= titulo.descricaocob;
				this.tanumerocheque			= titulo.numerocheque;
				this.taidbanco				= titulo.idbanco;
				this.tadescbanco			= titulo.descbanco;
				this.taagencia				= titulo.agencia;
				this.taconta				= titulo.conta;
				this.tapraca				= titulo.praca;
				this.taemitente				= titulo.emitente;
				this.tacnpjcpf				= titulo.cnpjcpf;						
				this.taidsituacaocheque		= titulo.idsituacaocheque;
				this.tadescsituacaocheque	= titulo.descsituacaocheque;				


				var deftipocobranca  = new Option(this.tadescricaocob, this.taidtipocobranca, true, true);
				$('#cbtipocobranca').append(deftipocobranca).trigger('change');

				if (this.taidbanco !== null){
					var defbanco  = new Option(this.tadescbanco, this.taidbanco, true, true);
					$('#cbbanco').append(defbanco).trigger('change');
				}else{
					$("#cbbanco").val(null).trigger('change');
				}
				
				if (this.taidsituacaocheque !== null){
					var defsituacaoch  = new Option(this.tadescsituacaocheque, this.taidsituacaocheque, true, true);
					$('#cbsituacaocheque').append(defsituacaoch).trigger('change');
				}else{
					$("#cbsituacaocheque").val(null).trigger('change');
				}

				$('#mdalterartitulo').modal('show');
			},
			mtconfirmaralteracaotitulo(){
				if (this.tadtventit === ''){
					this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
					$('#eddtventit').focus();
					return;
				}
				if (parseFloat(this.tavltit) <= 0){
					this.$toastr.w('Valor do título inválido!', 'Atenção!');
					$('#edvltit').focus();
					return;
				}
				if (this.taidtipocobranca === null){
					this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
					$('#cbtipocobranca').focus();
					return;
				}				
				if (parseInt(this.tatipocobranca) === 1){
					if (this.tanumerocheque === ''){
						this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
						$('#ednumerocheque').focus();
						return;
					}
					if (this.taidbanco === null){
						this.$toastr.w('Banco deve ser informado!', 'Atenção!');
						$('#cbbanco').focus();
						return;
					}
					if (this.taagencia === ''){
						this.$toastr.w('Agência deve ser informada!', 'Atenção!');
						$('#edagencia').focus();
						return;
					}
					if (this.taconta === ''){
						this.$toastr.w('Conta deve ser informada!', 'Atenção!');
						$('#edconta').focus();
						return;
					}
					if (this.tapraca === ''){
						this.$toastr.w('Praça deve ser informada!', 'Atenção!');
						$('#edpraca').focus();
						return;
					}
					if (this.taemitente === ''){
						this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
						$('#edemitente').focus();
						return;
					}
					if (this.tacnpjcpf === ''){
						this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
						$('#edcnpjcpf').focus();
						return;
					}
					if (this.taidsituacaocheque === null){
						this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
						$('#cbsituacaocheque').focus();
						return;
					}					
				}
				let indice = util.getArrayIndexForKey(this.lsttitulosfaturar, 'codtit', this.tacodtit);
				this.vtotaltitulos = this.vtotaltitulos - this.lsttitulosfaturar[indice].vltit;


				this.lsttitulosfaturar[indice].dtventit 			= this.tadtventit;
				this.lsttitulosfaturar[indice].dtventit				= this.tadtventit;
				this.lsttitulosfaturar[indice].vltit				= this.tavltit;
				this.lsttitulosfaturar[indice].idtipocobranca		= this.taidtipocobranca;
				this.lsttitulosfaturar[indice].tipocobranca			= this.tatipocobranca;
				this.lsttitulosfaturar[indice].descricaocob			= $('#cbtipocobranca').select2('data')[0]['text'];

				this.lsttitulosfaturar[indice].numerocheque			= parseInt(this.tatipocobranca) === 1 ? this.tanumerocheque 	: '';
				this.lsttitulosfaturar[indice].idbanco				= parseInt(this.tatipocobranca) === 1 ? this.taidbanco 			: null;
				this.lsttitulosfaturar[indice].descbanco			= parseInt(this.tatipocobranca) === 1 ? $('#cbbanco').select2('data')[0]['text'] : '';
				this.lsttitulosfaturar[indice].agencia				= parseInt(this.tatipocobranca) === 1 ? this.taagencia 			: '';
				this.lsttitulosfaturar[indice].conta				= parseInt(this.tatipocobranca) === 1 ? this.taconta 			: '';
				this.lsttitulosfaturar[indice].praca				= parseInt(this.tatipocobranca) === 1 ? this.tapraca 			: '';
				this.lsttitulosfaturar[indice].emitente				= parseInt(this.tatipocobranca) === 1 ? this.taemitente 		: '';
				this.lsttitulosfaturar[indice].cnpjcpf				= parseInt(this.tatipocobranca) === 1 ? this.tacnpjcpf 			: '';						
				this.lsttitulosfaturar[indice].idsituacaocheque		= parseInt(this.tatipocobranca) === 1 ? this.taidsituacaocheque : null;
				this.lsttitulosfaturar[indice].descsituacaocheque	= parseInt(this.tatipocobranca) === 1 ? $('#cbsituacaocheque').select2('data')[0]['text'] : '';				


				this.vtotaltitulos = this.vtotaltitulos + this.tavltit;

				//divide os valores das parcelas igualmente
				if (this.tajustarparcelas && this.lsttitulosfaturar.length > 0){
					let vlformacalc = 0;
					for (let i = 0; i < this.lstformasfaturar.length; i++) {
						if (parseInt(this.lstformasfaturar[i].tipo) === 1){
							vlformacalc = this.lstformasfaturar[i].vlforma;
							break;
						}
					}
					let vlrestante = vlformacalc - this.tavltit;
					let vlparcela  = vlrestante / (this.lsttitulosfaturar.length - 1);					

					if (this.lsttitulosfaturar.length > 1){
						this.vtotaltitulos = 0;
						for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
							if (i > 0){
								this.lsttitulosfaturar[i].vltit = vlparcela;
							}
							this.vtotaltitulos = this.vtotaltitulos + this.lsttitulosfaturar[i].vltit;
						}
					}					
				}

				//joga os centavos na ultima parcela
				if (this.tajustarcentavos && this.lsttitulosfaturar.length > 0){
					let vlformacalc = 0;
					for (let i = 0; i < this.lstformasfaturar.length; i++) {
						if (parseInt(this.lstformasfaturar[i].tipo) === 1){
							vlformacalc = this.lstformasfaturar[i].vlforma;
							break;
						}
					}
					let vlrestante = vlformacalc - this.tavltit;

					let vlparcela  = vlrestante / (this.lsttitulosfaturar.length - 1);

					let pint	   = Math.floor(vlparcela);
					let fracao	   = util.fracaonumero(vlparcela) * (this.lsttitulosfaturar.length - 1);					
					if (this.lsttitulosfaturar.length > 1){
						this.vtotaltitulos = 0;
						for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
							if (i > 0){
								if (i === this.lsttitulosfaturar.length - 1){
									this.lsttitulosfaturar[i].vltit = pint + fracao;
								}else{
									this.lsttitulosfaturar[i].vltit = pint;
								}
							}
							this.vtotaltitulos = this.vtotaltitulos + this.lsttitulosfaturar[i].vltit;
						}
					}
				}
				
				//ajusta o mesmo dia para as demais datas
				if (this.tajustardatas && this.lsttitulosfaturar.length > 0) {
					let dia = parseInt(this.tadtventit.substring(0, 2));
					for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
						if (i > 0) {
							let mes = parseInt(this.lsttitulosfaturar[i - 1].dtventit.substring(3, 5)); // Pega o mês anterior
							let ano = parseInt(this.lsttitulosfaturar[i - 1].dtventit.substring(6, 10)); // Pega o ano anterior

							// Incrementa o mês
							mes += 1;
							if (mes > 12) { // Se passar de dezembro, reseta para janeiro e incrementa o ano
								mes = 1;
								ano += 1;
							}

							// Ajusta o dia conforme o mês e ano
							let ultimodiames = new Date(ano, mes, 0).getDate(); // Último dia do mês
							if (dia > ultimodiames) {
								dia = ultimodiames; // Ajusta para o último dia do mês
							}

							let novadata = `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${ano}`;
							this.lsttitulosfaturar[i].dtventit = novadata;
						}
					}
				}		

				$('#mdalterartitulo').modal('hide');
			},
			mtdpendenciasparcela(){
				let ret = false;
				for (let titulo of this.lsttitulosfaturar) {
					if (parseInt(titulo.tipocobranca) === 1){
						if (titulo.numerocheque === ''){
							ret = true;
							break;
						}
						if (titulo.idbanco === null){
							ret = true;
							break;
						}
						if (titulo.agencia === ''){
							ret = true;
							break;
						}
						if (titulo.conta === ''){
							ret = true;
							break;
						}
						if (titulo.praca === ''){
							ret = true;
							break;
						}
						if (titulo.emitente === ''){
							ret = true;
							break;
						}
						if (titulo.cnpjcpf === ''){
							ret = true;
							break;
						}
						if (titulo.idsituacaocheque === null){
							ret = true;
							break;
						}																		
					}
				}
				return ret;
			},
			mtdverificasomaparcelas(){
				let vlaprazo = 0;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.tipo) === 1){
						vlaprazo = forma.vlforma;
						break;
					}
				}
				if (parseFloat(this.vtotaltitulos).toFixed(2) !== parseFloat(vlaprazo).toFixed(2)){
					return false;
				}else{
					return true;
				}
			},
			mtdmovimentocaixa(op){
				if (this.lstitens.length > 0 || this.lstservicos.length > 0){
					this.$toastr.i('Existe uma venda iniciada. Impossível realizar esta operação!', 'Informação!');
					return;
				}				
				let opachar = parseInt(op) === 0 ? '020Z.015Z.090Z' : '020Z.015Z.100Z';
				if (!util.opcaousuario(opachar, this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					this.opmovcx 			= op;
					this.descmovcx 			= '';
					this.valormovcx 		= 0;

					let vself 		= this;
					let loader      = vself.$loading.show();
					let filtro      = ' and p.id='+vself.lancamentousu.idpdv;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpdvs.php');
					retorno.then(function (response) {
						loader.hide();			
					}).catch(function (response) {
						loader.hide();
					});

					$("#cbformamovcx").val(null).trigger('change');
					$("#cbgruposaidapdv").val(null).trigger('change');
					$('#mdmovimentoscaixa').modal('show');
				}
			},
			mtdconfirmalancamentocaixa(){
				let vself = this;
				if (vself.descmovcx === ''){
					vself.$toastr.w('Descrição do movimento deve ser informada', 'Atenção!');
					$('#eddescmovcx').focus();
					return;
				}
				if (parseFloat(vself.valormovcx) <= 0){
					vself.$toastr.w('Valor do movimento deve ser informada', 'Atenção!');
					$('#edvalormovcx').focus();
					return;
				}
				if (vself.idformamovcx === null){
					vself.$toastr.w('Forma de pagamento deve ser informada', 'Atenção!');
					$('#cbformamovcx').focus();
					return;
				}								
				if (parseInt(vself.opcrud) < 3) {
					if (parseInt(vself.vtodasfiliais) === 0) {
					}
				}
				$.confirm({
					title: 'Confirmação!',
					content: parseInt(vself.opmovcx) === 0 ? 'Confirma ENTRADA no caixa?' : 'Confirma SAÍDA do caixa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader = vself.$loading.show();
								let movimento = {
									'idpdv'				: vself.lancamentousu.idpdv,
									'idlancamentopdv' 	: vself.lancamentousu.id,
									'desclancamento'	: vself.descmovcx,
									'idgruposaida'		: vself.idgruposaidapdv === null ? 0 : vself.idgruposaidapdv,
									'tpmovimento'		: vself.opmovcx,
									'idforma'			: vself.idformamovcx,
									'valor'				: vself.valormovcx
								};
								let parametros      = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           valor : 'movimentocaixa'},
									{parametro: 'movimento',    valor : JSON.stringify(movimento)},
									{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
									{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
									{parametro: 'codop',        valor : parseInt(vself.opmovcx) === 0 ? '020Z.015Z.090Z' : '020Z.015Z.100Z'},//verificar o perfil depois
								];
								let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
								retorno.then(function (response) {
									loader.hide();
									if ($.isNumeric(response.data)){
										vself.$toastr.s('Movimento realizado com sucesso!', 'Informação!');
										$('#mdmovimentoscaixa').modal('hide');
										//rotina para a impressão do documento
										vself.mtdimprimirmovimentocaixa(vself.lancamentousu.id, response.data, 1);//tpimp: 0 - A4, 1 - térmica
									}else{
										let tpret = response.data.substring(0,1);
										switch (tpret) {
											case 'I':
												vself.$toastr.w(response.data.substring(4), 'Atenção!');
												break;
											case 'E': default:
												vself.$toastr.e(response.data.substring(4), 'Erro!');
												break;
										}
									}
								}).catch(function (response) {
									loader.hide();
									vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
								});
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});			
			},
			mtdimprimirabertura(idlancamentopdv, tpimp) {
				$('#mdmenulancamento').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimiraberturapdv.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idl='+idlancamentopdv+'&tpimp='+tpimp, '_blank');
			},			
			mtdimprimirmovimentocaixa(idlancamentopdv, idmovimento, tpimp) {
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirmovlancamentopdv.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idl='+idlancamentopdv+'&idm='+idmovimento+'&tpimp='+tpimp, '_blank');
			},
			mtdrecebimentos(){
				if (this.lstitens.length > 0 || this.lstservicos.length > 0){
					this.$toastr.i('Existe uma venda iniciada. Impossível realizar esta operação!', 'Informação!');
					return;
				}
				if (parseInt(this.planocliente) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									});
					return;
				}				
				if (!util.opcaousuario('020Z.015Z.080Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					this.lsttitulos          	= [];
					this.rotinarecebimento   	= true;
					this.ridcliente				= '';
					this.rnomecliente			= '';
					this.rdtultrecebimento		= '';
					this.rvalorultrecebimento 	= '';													
					this.ridpedido				= '';
					this.rdtbasebaixa        	= util.DataAtual(true);
					
					$("#cbfilialrecebimento").val(null).trigger('change');
					this.vidfilialrecebimento   = null;

					if(this.utodasfiliais!==0){
						var deffil  = new Option(this.$store.state.filialpadrao.fantasia, this.$store.state.filialpadrao.codfil, true, true);
						$('#cbfilialrecebimento').append(deffil).trigger('change');
					}

					$('#cdlancamentos').hide();
					$('#cdrecebimentos').fadeIn(700);	
					$('#edrcodcli').focus();			
				}
			},
			mtdfecharrecebimentos(){
				this.rotinarecebimento   	= false;
                $('#cdrecebimentos').hide();
				$('#cdlancamentos').fadeIn(700);
				$('#edlidproduto').focus();
			},
            mtdlimpar_listagem_titulos() {
                this.lsttitulos             = [];
                this.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table
                this.vrVencidos             = 0;
                this.vrAvencer              = 0;
                this.vrJuros                = 0;
                this.vrMulta                = 0;
                this.vrTotal                = 0;
                this.vrTotcancelados        = 0;
                //variáveis dos baixados    
                this.vtotaltitulosrec       = 0;
                this.vtotaljurosrec         = 0;
                this.vtotalmultarec         = 0;
                this.vtotaldescontorec      = 0;
                this.vtotalgeralrec         = 0;   

                this.mtdcalculaselecionados();
            },			
			mtdlistartituloscliente(){				
				var vself       = this;                    
				if (vself.ridcliente === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edridcliente').focus();
					return;
				}
				let loader      = this.$loading.show();
				let filtro		= '';

				if(vself.vidfilialrecebimento!==null){
					filtro      = filtro + ' and t.idfilial=' + vself.vidfilialrecebimento;
				}


				if (vself.ridpedido === ''){
					filtro      = filtro + ' and t.sttit in ("A", "P") and t.idcliente=' + this.ridcliente;
				}else{
					filtro      = filtro + ' and t.sttit in ("A", "P") and t.idcliente=' + this.ridcliente + ' and t.idpedido=' + this.ridpedido;
				}
				vself.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table 
				vself.mtdcalculaselecionados();                   
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'situacao',     valor  : 0},//somente títulos em aberto
					{parametro: 'ordem',        valor  : 2},//ordenado por vencimento
					{parametro: 'dtbasecalculo',valor  : util.InverterData(vself.rdtbasebaixa)},                                                
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'limit',        valor : 99999999999},
					{parametro: 'offset',       valor : 0}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
				retorno.then(function (response) {
					vself.lsttitulos 		= response.data.lista;
					//iguala totais dos titulos para calcular os selecionados
					vself.vrVencidos        = response.data.vencidos;
					vself.vrAvencer         = response.data.avencer;
					vself.vrJuros           = response.data.totjuros;
					vself.vrMulta           = response.data.totmulta;
					vself.vrTotal           = response.data.totgeral;
					vself.vrTotcancelados   = response.data.totcancelados;
					loader.hide();
				}).catch(function (response) {
					vself.lsttitulos = [];
					loader.hide();
				});				
			},
            mtdzerarselecionados() {
                this.vTotalPagarSel       = 0;
                this.vTotalJurosSel       = 0;
                this.vTotalMultaSel       = 0;
                this.vTotalGeralSel       = 0;
            },            
            mtdcalculaselecionados() {
                this.mtdzerarselecionados();
                for (var i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                    this.vTotalPagarSel    = this.vTotalPagarSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                    this.vTotalJurosSel    = this.vTotalJurosSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                    this.vTotalMultaSel    = this.vTotalMultaSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                    this.vTotalGeralSel    = this.vTotalGeralSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlapagar);
                }
                this.vqtdtitsel = this.$refs.reflsttitulos.selected_items.length;
			},
            mtdbaixartitulos(){
                // if (util.verificasessao(this)){
                //     if (!util.opcaousuario('030Z.010Z.040Z', this.$store.state.perfilusuario)){
                //         this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                //     }else {                
                        if (this.ridcliente === ''){
                            this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                            $("#edrcodcli").focus();
                            return;
                        }
						this.vidclientebaixa					   = this.ridcliente;	
                        this.idnomeclientebaixa                    = this.ridcliente +' - ' + this.rnomecliente;
                        this.vvariaveisbaixar.vtottitbaixa         = this.vTotalPagarSel;
                        this.vvariaveisbaixar.vtotjurosbaixa       = this.vTotalJurosSel;
                        this.vvariaveisbaixar.vtotmultabaixa       = this.vTotalMultaSel;
                        this.vvariaveisbaixar.vtotpagarbaixa       = this.vTotalGeralSel;
                        this.valdescontojuros                      = this.vTotalJurosSel;
                        this.valdescontomulta                      = this.vTotalMultaSel;
                        this.vvariaveisbaixar.lstselecionadosbaixa = this.$refs.reflsttitulos.selected_items;
                        this.vvariaveisbaixar.vvalorrecebimento    = this.vTotalGeralSel;

                        $('#mdBaixarTitulosReceber').modal('show');
                //     }
                // }
			},
			mtdimprimirpedido(idpedido, tp){				
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
			mtdreimpressaopedido(){
				$('#mdreimpressaopedido').modal('show');
			},
			mtdimprimirultimavenda(){
				if (this.vidultimopedido !== ''){
					this.mtdimprimirpedido(this.vidultimopedido, 1);
					$('#mdreimpressaopedido').modal('hide');
				}else{
					this.$toastr.i('Número da venda deve ser informado!', 'Informação!');
					$('#edultimopedido').focus();
				}
			},
			mtdimprimirdanfe(idnotafiscal){
				if (parseInt(this.planocliente) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									});
					return;
				}				
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idnf='+idnotafiscal+'&docimp=danfe', '_blank');		
			},
			mtdimprimirextrato(){
				if (this.ridcliente === ''){
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$("#edrcodcli").focus();
					return;
                }			
				let titulos = '';
				for (let i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
					titulos = titulos+'"'+this.$refs.reflsttitulos.selected_items[i].codtit+'", ';
				}
				titulos = titulos.substring(0, titulos.length - 2);					
				window.open(this.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&oprelatorio=3'+
							'&idcliente='+this.ridcliente+
							'&nomecliente='+this.rnomecliente+
							'&idfilial='+this.lancamentousu.idfilial+
							'&titulos='+titulos+
							'&totaltitulos='+this.vTotalPagarSel+
							'&juros='+this.vTotalJurosSel+
							'&multa='+this.vTotalMultaSel+
							'&totalapagar='+this.vTotalGeralSel+
							'&nomeusuario='+this.$store.state.usuario.nome+
							'&idu='+this.$store.state.usuario.id, '_blank');
			},
			mtdfechamento(){
				if (this.lstitens.length > 0){
					this.$toastr.i('Existe uma venda iniciada. Impossível fechar o caixa!', 'Informação!');
				}else{				
					if (!util.opcaousuario('020Z.015Z.110Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {				
						this.lstformasfechamento 	= [];
						$('#mdfechamento').modal('show');
					}
				}
			},
			mtdconfirmafechamento(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma fechamento do caixa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);

								//primeiro o valor das formas de pagamento para captar movimentos enquanto rola o fechamento
								let loader      			= vself.$loading.show();
								let parametros  			= [
									{parametro: 'idclientesac', valor     : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           	valor : 'listarmovimentos'},
									{parametro: 'idlancamentopdv', 	valor : vself.lancamentousu.id}
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
								retorno.then(function (response) {
									let legformasfechamento = response.data.formas;
									for (let index = 0; index < legformasfechamento.length; index++) {
										let indforma = util.getArrayIndexForKey(vself.lstformasfechamento, 'id', legformasfechamento[index].id);
										vself.lstformasfechamento[indforma].valorregistrado = legformasfechamento[index].valorregistrado;
									}
									vself.mtdrotinafinalizafechamento();
									loader.hide();					
								}).catch(function (response) {
									loader.hide();
								});				
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});								
			},
			mtdmovimentos(lancamento){
				if (!util.opcaousuario('020Z.015Z.130Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					let vself = this;					
					vself.lancamentosmov		= lancamento;
					let loader      			= vself.$loading.show();
					let parametros  			= [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           	valor : 'listarmovimentos'},
						{parametro: 'idlancamentopdv', 	valor : lancamento.id}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
					retorno.then(function (response) {
						vself.lentradas				 = response.data.entradas;
						vself.ltotalentradas		 = response.data.totalentradas;
						vself.lrecebimentos			 = response.data.recebimentos;
						vself.ltotalrecebimentos	 = response.data.totalrecebimentos;
						vself.lpedidos				 = response.data.pedidos;
						vself.lformasvendas			 = response.data.formasvendas;
						vself.lformasrecebimentos	 = response.data.formasrecebimentos;
						vself.ltotaldescontos	     = response.data.totaldescontos;
						vself.ltotalpedidos			 = response.data.totalpedidos;
						vself.ltotalpedidoscancelados= response.data.totalpedidoscancelados;
						vself.lqtdpedidoscancelados	 = response.data.qtdpedidoscancelados;
						vself.lsaidas				 = response.data.saidas;
						vself.lstresumorecebimentofil= response.data.resumofiliais;
						vself.ltotalrecebimentosfil  = response.data.totalresumofil;
						vself.ltotalsaidas			 = response.data.totalsaidas;
						vself.lfechamento			 = response.data.fechamento;
						vself.lformas				 = response.data.formas;					

						vself.ltotalregistrado		 = 0;
						vself.ltotalfechamento		 = 0;
						vself.ltotaldiferenca		 = 0;

						if (vself.lfechamento.length > 0){
							for (let forma of vself.lfechamento[0].formas) {
								vself.ltotalregistrado		 = vself.ltotalregistrado + parseFloat(forma.valorregistrado);
								vself.ltotalfechamento		 = vself.ltotalfechamento + parseFloat(forma.valor);
							}
							vself.ltotaldiferenca = parseFloat(vself.ltotalfechamento) - parseFloat(vself.ltotalregistrado);						
						}
						
						if (vself.lentradas.length > 0){
							for (let i = 0; i < vself.lentradas.length; i++) {
								vself.lentradas[i].idperfilfluxo 	= vself.lancamentosmov.idperfilfluxoentradas;
								vself.lentradas[i].descperfilfluxo	= vself.lancamentosmov.descperfilfluxoentradas;
							} 
						}

						if (vself.lsaidas.length > 0){
							for (let i = 0; i < vself.lsaidas.length; i++) {
								vself.lsaidas[i].idperfilfluxo 	= vself.lancamentosmov.idperfilfluxosaidas;
								vself.lsaidas[i].descperfilfluxo= vself.lancamentosmov.descperfilfluxosaidas;
							} 
						}						

						loader.hide();		
						$('#mdlistamovimentos').modal('show');
					}).catch(function (response) {
						vself.lentradas				 = [];
						vself.ltotalentradas		 = 0;
						vself.lrecebimentos			 = [];
						vself.ltotalrecebimentos	 = 0;
						vself.lpedidos				 = [];
						vself.lformasvendas			 = [];
						vself.lformasrecebimentos	 = [];
						vself.ltotaldescontos		 = 0;
						vself.ltotalpedidos			 = 0;
						vself.lsaidas				 = [];
						vself.ltotalsaidas			 = 0;
						vself.lfechamento			 = [];
						vself.lformas				 = [];
						vself.ltotalregistrado		 = 0;
						vself.ltotalfechamento		 = 0;
						vself.ltotaldiferenca		 = 0;										
						loader.hide();
					});
				}
			},
			mtdadicionarservico(){
				if (this.vidpedido === ''){
					if (this.vidservicoedicao === null){
						this.$toastr.w('Serviço deve ser informado!', 'Atenção!');
						$('#cbservico').focus();
						return;
					}
					if (this.vidtecnicoedicao === null){
						this.$toastr.w('Técnico deve ser informado!', 'Atenção!');
						$('#cbtecnico').focus();
						return;
					}
					if (!Number.isInteger(parseFloat(this.vqtdservicoedicao))){
						this.$toastr.w('Quantidade não permitida!', 'Atenção!');
						$('#edqtdservedicao').focus();
						return;
					}else{
						if (this.vqtdservicoedicao == 0){
							this.$toastr.w('Informe uma quantidade válida!', 'Atenção!');
							$('#edqtdservedicao').focus();
							return;
						}
					}
					if (this.vvlservicoedicao <= 0){
						this.$toastr.w('Informe o valor unitário do serviço!!', 'Atenção!');
						$('#edvlservicoedicao').focus();
						return false;
					}


					let fatd = 0;
					if (parseInt(this.vtipodescontoservicoedicao) === 0){
						fatd = this.vvalordescontoservicoedicao;
					}else{
						fatd = parseFloat(this.vvalordescontoservicoedicao) / (parseFloat(this.vqtdservicoedicao) * parseFloat(this.vvlservicoedicao)) * 100;
					}
					if (parseFloat(fatd) > parseFloat(this.$store.state.usuario.descontoservicos)){
						this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoservicos+'%!', 'Informação!');
						$('#edvalordescontoservicoedicao').focus();					
						return;
					}	

					if (util.findValInArray(this.lstservicos, 'idservico', this.vidservicoedicao)){	
						this.$toastr.w('Serviço já lançado na venda!', 'Atenção!');
						$('#cbservico').focus();
						return;					
					}
					let servico = {
						idservico		: this.vidservicoedicao,
						descservico		: $('#cbservico').select2('data')[0]['text'],
						qtdservico		: this.vqtdservicoedicao,
						vlservico		: this.vvlservicoedicao,
						tipodesconto	: this.vtipodescontoservicoedicao,
						valordesconto	: this.vvalordescontoservicoedicao,
						vltotal			: this.vvltotalservicoedicao,
						idtecnico		: this.vidtecnicoedicao,
						nometecnico		: $('#cbtecnico').select2('data')[0]['text']
					};
					this.lstservicos.push(servico);

					this.vtotalservicos = this.vtotalservicos + parseFloat(this.vvltotalservicoedicao);//total dos serviços

					this.vtotalgeral	=  this.vtotalprodutos + this.vtotalservicos;

					this.vidservicoedicao				= null;
					this.vqtdservicoedicao				= 1;
					this.vvlservicoedicao				= 0;
					this.vtipodescontoservicoedicao		= 0;
					this.vvalordescontoservicoedicao	= 0;
					this.vvltotalservicoedicao			= 0;
					this.vidtecnicoedicao				= null;

					$("#cbservico").val('').trigger('change');
					$("#cbtecnico").val('').trigger('change');				

					$('#cbservico').focus();
				}
			},			
			mtdexcluirservico(servico){
				if (this.vidpedido === ''){
					if (!util.opcaousuario('020Z.010Z.140Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
						return;
					}								
					let indiceservico 	= util.getArrayIndexForKey(this.lstservicos, 'idservico', servico.idservico);

					this.vtotalservicos = this.vtotalservicos - parseFloat(this.lstservicos[indiceservico].vltotal);//total dos serviços

					this.vtotalgeral	=  this.vtotalprodutos + this.vtotalservicos;

					this.lstservicos.splice(indiceservico, 1);
				}
			},
			mtdmostraritens(){
                $('#dv-servicos').hide();				
				$('#dv-codigoproduto').fadeIn(700);
                $('#dv-lst-itens').fadeIn(700);
				this.mtdajustestela();
			},
			mtdmostrarservicos(){
                $('#dv-lst-itens').hide();
				$('#dv-codigoproduto').hide();	
                $('#dv-servicos').fadeIn(700);
				this.mtdajustestela();
			},
			mtdidentificaconsumidor(){
				if (parseInt(this.planocliente) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									});
					return;
				}								
				this.docclitmp = '';
				$('#mdidentificaconsumidor').modal('show');
			},
			mtdconfirmaidentidadeconsumidor(){
				if (this.docclitmp === ''){
					this.vdoccli = this.docclitmp;
					$('#mdidentificaconsumidor').modal('hide');
				}else{
					if (this.docclitmp.replace(/[^\d]+/g,'').length < 14){
						if (!util.validarCPF(this.docclitmp)){
							this.$toastr.w('CPF inválido!', 'Atenção!');
							$('#eddoccli').focus();
						}else{
							this.vdoccli = this.docclitmp.replace(/[^\d]+/g,'');
							$('#mdidentificaconsumidor').modal('hide');
						}
					}else{
						if (!util.validarCNPJ(this.docclitmp)){
							this.$toastr.w('CNPJ inválido!', 'Atenção!');
							$('#eddoccli').focus();
						}else{
							this.vdoccli = this.docclitmp.replace(/[^\d]+/g,'');
							$('#mdidentificaconsumidor').modal('hide');
						}						
					}
				}
			},
			mtddevolucaotroca(){
				if (this.vidpedido === ''){
					if (!util.opcaousuario('020Z.015Z.105Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {					
						$('#mddevolucaotroca').modal('show');
					}
				}
			},
			mtdliberatrocadev(itens, idproduto, qtdtrocadev, nrvenda){
				let vself = this;
				let qtd = 0;
				for (let i = 0; i < itens.length; i++) {
					if (parseInt(itens[i].idproduto) === parseInt(idproduto)){
						qtd = qtd + itens[i].qtditem;		
					}
				}	
				let qtdnavenda = 0;
				for (let x = 0; x < vself.lstitens.length; x++) {
					if (parseInt(vself.lstitens[x].idproduto) === parseInt(idproduto) && parseInt(vself.lstitens[x].nrvenda) === parseInt(nrvenda)){
						qtdnavenda = qtdnavenda + (vself.lstitens[x].qtditem * (-1));		
					}
				}			
				if (qtd < qtdnavenda + qtdtrocadev){
					return false;
				}else{
					return true;
				}
			},			
			mtdconfirmaitemdevolucao(){
				let vself = this;
				if (vself.vcoddigdev === ''){
					vself.$toastr.w('Código do produtos deve ser informadao', 'Atenção!');
					$('#edidprodutodev').focus();
					return;
				}				
				if (vself.vnrvenda === ''){
					vself.$toastr.w('Número da venda deve ser informada', 'Atenção!');
					$('#ednrvenda').focus();
					return;
				}
				if (parseInt(vself.vfracionadodev) === 0){
					if (!Number.isInteger(vself.vqtditemdev)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						setTimeout(() => {
							$('#edidprodutodev').focus();									
						}, 200);  									
						return;
					}
				}
				if (parseFloat(vself.vqtditemdev) <= 0){
					vself.$toastr.w('Quantidade inválida', 'Atenção!');
					$('#edqtditemdev').focus();
					return;
				}	
				if (parseFloat(vself.vvlunitariodev) <= 0){
					vself.$toastr.w('Valor do item inválido', 'Atenção!');
					$('#edvlunitariodev').focus();
					return;
				}
				//desabilita o botão pra evitar que o usuário clique várias vezes
				$('#btconfirmadevtroca').prop('disabled', true);

                let loader      = vself.$loading.show();
                let filtro      = 'and p.stpedido=1 and p.id='+vself.vnrvenda;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
					loader.hide();					
					let itensped = response.data.pedidos.length > 0 ? response.data.pedidos[0].itens : [];
					if (vself.mtdliberatrocadev(itensped, vself.vidprodutodev, vself.vqtditemdev, vself.vnrvenda)){
						vself.vitem++;
						let itemtmp = {
							idproduto		: vself.vidprodutodev,
							descproduto		: vself.vdescricaoprodutodev,
							coddig			: vself.vcoddigdev,
							item			: vself.vitem,
							qtditem			: vself.vqtditemdev * (-1),
							unditem			: vself.vundprodutodev,
							vlunitario		: vself.vvlunitariodev * (-1),
							descacres		: 0,
							tipodescacres	: 0,
							valordescacres	: 0,
							manipulaval		: 0,
							vltotal			: vself.vvtotaldev * (-1),
							idestoque		: vself.lancamentousu.idestoque,
							descestoque		: vself.lancamentousu.descestoque,
							infadprod		: '',
							qtdentregar		: vself.vqtditemdev * (-1),
							nrvenda			: vself.vnrvenda,
							adesivo         : '',
							descadesivo     : '',
							coradesivo      : ''

						};
						vself.vtotalprodutos = vself.vtotalprodutos + (parseFloat(vself.vvtotaldev) * (-1));
						vself.vtotalgeral	 = vself.vtotalprodutos + vself.vtotalservicos;
						vself.lstitens.push(itemtmp);
						
						vself.vcoddigdev 				 = '';
						vself.vidprodutodev			     = '';
						vself.vdescricaoprodutodev       = '';
						vself.vundprodutodev			 = '';
						vself.vqtditemdev			 	 = 1;
						vself.vfracionadodev			 = 0;
						vself.vvlunitariodev			 = 0;
						vself.vvtotaldev				 = 0;
						vself.vnrvenda				     = '';					

						$('#edidprodutodev').focus();
						setTimeout(() => {
							$('#btconfirmadevtroca').prop('disabled', false);
						}, 500);						
					}else{
						vself.$toastr.w('A quantidade do item informado não consta na venda, a mesma está cancelada ou a quantidade é superior a existente na mesma. Verifique e tente novamente!', 'Atenção!');
						$('#edidprodutodev').focus();
						setTimeout(() => {
							$('#btconfirmadevtroca').prop('disabled', false);
						}, 500);						
					}
                }).catch(function (response) {
                    loader.hide();
					setTimeout(() => {
						$('#btconfirmadevtroca').prop('disabled', false);
					}, 500);					
                });
			},
			mtdtemtrocadev(){
				for (let i = 0; i < this.lstitens.length; i++) {
					if (this.lstitens[i].nrvenda !== '') return true;
				}
				return false;
			},
			mtdalteraperfilabertura(origem, idperfil, descperfil){
				this.origemperfil		 = origem;
                this.aidperfilfluxo      = idperfil;
                this.adescperfilfluxo    = descperfil;
                if (parseInt(this.aidperfilfluxo) !== 0){
                    var deffluxo  = new Option(this.adescperfilfluxo, this.aidperfilfluxo, true, true);
                    $('#cbperfilfluxofinal').append(deffluxo).trigger('change');
                }else{
                    $('#cbperfilfluxofinal').val(null).trigger('change');
                }

                $('#mdlalterarperfilfluxofinal').modal('show');
			},
            mtdalterarperfilfluxo(forma, indice, origem){
				this.origemperfil		 = origem;
                this.aindiceperfilfluxo  = indice;
                this.aidperfilfluxo      = forma.idperfilfluxo;
                this.adescperfilfluxo    = forma.descperfilfluxo;
                if (parseInt(this.aidperfilfluxo) !== 0){
                    var deffluxo  = new Option(this.adescperfilfluxo, this.aidperfilfluxo, true, true);
                    $('#cbperfilfluxofinal').append(deffluxo).trigger('change');
                }else{
                    $('#cbperfilfluxofinal').val(null).trigger('change');
                }

                $('#mdlalterarperfilfluxofinal').modal('show');
            },
            mtdconfirmarperfilfluxo(){
				if (parseInt(this.origemperfil) === 0){//vendas
					this.lformasvendas[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
					this.lformasvendas[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];
				}else if(parseInt(this.origemperfil) === 1){//recebimentos					
					this.lformasrecebimentos[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
					this.lformasrecebimentos[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];					
				}else if(parseInt(this.origemperfil) === 2){//aberturas
					this.lancamentosmov.idperfilfluxoaberturas   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
					this.lancamentosmov.descperfilfluxoaberturas = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];					
				}else if(parseInt(this.origemperfil) === 3){//Entradas
					let lentradastmp = JSON.parse(JSON.stringify(this.lentradas));
					this.lentradas 	 = [];					
					
					lentradastmp[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
					lentradastmp[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];					

					this.lentradas = JSON.parse(JSON.stringify(lentradastmp));

				}else if(parseInt(this.origemperfil) === 4){//Saídas
					let lsaidastmp = JSON.parse(JSON.stringify(this.lsaidas));
					this.lsaidas   = [];					
					
					lsaidastmp[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
					lsaidastmp[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];					

					this.lsaidas = JSON.parse(JSON.stringify(lsaidastmp));
				}else if (parseInt(this.origemperfil) === 6){//finalização da venda
					let lformastmp 			= JSON.parse(JSON.stringify(this.lstformasfaturar));
					this.lstformasfaturar   = [];					

					lformastmp[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
                	lformastmp[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];					
					this.lstformasfaturar = JSON.parse(JSON.stringify(lformastmp));

				}
                $('#mdlalterarperfilfluxofinal').modal('hide');
            },
			mtdquestionafc(){
                let vself = this;
				if (!util.opcaousuario('020Z.015Z.210Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					$.confirm({
						title: 'Confirmação!',
						content: 'Este procedimento é IRREVERSÍVEL. Confirma os lançamentos deste PDV no Fluxo de Caixa?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									$('.btn-blue').prop('disabled', true);
									vself.mtdprocessafc();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});		
				}		
			},
			mtdprocessafc(){
				let vself  = this;
                let loader = vself.$loading.show();
				let idpesq = vself.lancamentosmov.id;

				let registros = {
					'idlancamento'        : vself.lancamentosmov.id,
					'idpdv'      		  : vself.lancamentosmov.idpdv,
					'idperfilabertura'    : vself.lancamentosmov.idperfilfluxoaberturas,
					'idperfiltrocovirtual': vself.vidperfiltrocovirtualvenda,
					'valorabertura'       : vself.lancamentosmov.valorabertura,
					'vendas'     		  : vself.lformasvendas,
					'recebimentos'        : vself.lformasrecebimentos,
					'entradas'            : vself.lentradas,
					'saidas'			  : vself.lsaidas
				};
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processarfc'},
                    {parametro: 'registro',     valor : JSON.stringify(registros)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.015Z.210Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
						$('#mdlistamovimentos').modal('hide');
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pconteudo     = idpesq;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapdvs(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });				
			},
			mtddetalhespedido(idpedido){
				this.vidpedidodet = 0;
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},
			mtdconfirmagerarnfce(pedido){
				let vself = this;
				if (parseInt(this.planocliente) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									});
					return;
				}				
				$('#mdlistamovimentos').modal('hide');
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma geração da NFC-e da venda: '+pedido.id+'?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader      = vself.$loading.show();
								let parametros  = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           valor : 'listagem'},
									{parametro: 'filtro',       valor : ' and p.id='+pedido.id},
									{parametro: 'limit',        valor : 1},
									{parametro: 'offset',       valor : 0}
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									vself.mtdgerarenviarnfce(response.data.pedidos[0], '65');
								}).catch(function (response) {
									vself.$toastr.e('Erro ao solicitar envio da NFC-e', 'Erro!');
									loader.hide();
								});								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});				
			},
			mtdimprimirguiaseparacao(){				
				if (this.vidultimopedido !== ''){
					$('#mdreimpressaopedido').modal('hide');
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiaseparacao.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+this.vidultimopedido+'&tpimp=1&idu='+
							this.$store.state.usuario.id, '_blank');									
				}else{
					this.$toastr.i('Número da venda deve ser informado!', 'Informação!');
					$('#edultimopedido').focus();
				}				
			},
			mtdimprimircarne(){
				if (this.vidultimopedido !== ''){
					$('#mdreimpressaopedido').modal('hide');
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimecarne.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+
								'&idpedido='+this.vidultimopedido, '_blank');
				}else{
					this.$toastr.i('Número da venda deve ser informado!', 'Informação!');
					$('#edultimopedido').focus();
				}								
			},
			mtdcancelarmovimento(idlancamentopdv, idmovimento){
                let vself = this;
				if (!util.opcaousuario('020Z.015Z.170Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					$.confirm({
						title: 'Confirmação!',
						content: 'Confirma o cancelamento?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									$('.btn-blue').prop('disabled', true);
									vself.mtdconfirmacancelamento(idlancamentopdv, idmovimento);
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});			
				}				
			},
			mtdconfirmacancelamento(idlancamentopdv, idmovimento){
				let vself  = this;
                let loader = vself.$loading.show();
				let idpesq = vself.lancamentosmov.id;

                let parametros      = [
                    {parametro: 'idclientesac', 		valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           		valor : 'cancelarmovimento'},
					{parametro: 'idlancamentopdv',    	valor : idlancamentopdv},
					{parametro: 'idmovimento',          valor : idmovimento},
                    {parametro: 'idfilial',    			valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        		valor : '020Z.015Z.170Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
						$('#mdlistamovimentos').modal('hide');
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pconteudo     = idlancamentopdv;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapdvs(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });								
			},
			mtdeditarfechamento(){
				if (!util.opcaousuario('020Z.015Z.220Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {					
					this.lstformasedicaofechamento        = JSON.parse(JSON.stringify(this.lfechamento[0].formas));
					this.ltotalregistradoedicaofechamento = this.ltotalregistrado;
					this.ltotalfechamentoedicaofechamento = this.ltotalfechamento;
					this.ltotaldiferencaedicaofechamento  = this.ltotaldiferenca;				
					this.veditarfechamento                = true;
				}
			},
			mtdrecalculaedicaofechamento(){
				this.ltotalregistradoedicaofechamento = 0;
				this.ltotalfechamentoedicaofechamento = 0;
				this.ltotaldiferencaedicaofechamento  = 0;								
				for (let i = 0; i < this.lstformasedicaofechamento.length; i++) {
					let dif = parseFloat(this.lstformasedicaofechamento[i].valor) - parseFloat(this.lstformasedicaofechamento[i].valorregistrado);
					this.ltotalregistradoedicaofechamento =	parseFloat(this.ltotalregistradoedicaofechamento) +parseFloat(this.lstformasedicaofechamento[i].valorregistrado);

					this.ltotalfechamentoedicaofechamento = parseFloat(this.ltotalfechamentoedicaofechamento) +parseFloat(this.lstformasedicaofechamento[i].valor);					

					this.ltotaldiferencaedicaofechamento  = parseFloat(this.ltotaldiferencaedicaofechamento) + dif;
				}
			},
			mtdcancelaredicaofechamento(){
				this.veditarfechamento = false;
			},
			mtdquestionaredicaofechamento(){
				let vself  = this;
				$.confirm({
						title: 'Confirmação!',
						content: 'Confirma edição do fechamento do caixa?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									$('.btn-blue').prop('disabled', true);
									vself.mtdsalvaredicaofechamento();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});				
			},
			mtdsalvaredicaofechamento(){
				let vself  = this;
				let loader = vself.$loading.show();

				let temdif = 0;								
				if (parseFloat(vself.lancamentosmov.fatordiferenca) > 0){
					for (let i = 0; i < vself.lstformasedicaofechamento.length; i++) {										
						let vlf = parseFloat(vself.lstformasedicaofechamento[i].valor) < 0 ? parseFloat(vself.lstformasedicaofechamento[i].valor) * (-1): parseFloat(vself.lstformasedicaofechamento[i].valor);
						let vlr = parseFloat(vself.lstformasedicaofechamento[i].valorregistrado);
						let dif = vlr - vlf;
						dif  	= dif < 0 ? dif * (-1) : dif;
						if (parseInt((parseFloat(dif)) * 100) > parseInt(vself.lancamentosmov.fatordiferenca * 100)){																				
							temdif = 1;
							break;
						}
					}
					//verifica no final em se tem diferença no montante
					vself.ltotaldiferencaedicaofechamento = vself.ltotaldiferencaedicaofechamento < 0 ? vself.ltotaldiferencaedicaofechamento * (-1) : vself.ltotaldiferencaedicaofechamento;									
					if (temdif === 0){
						if (parseInt((parseFloat(vself.ltotaldiferencaedicaofechamento)) * 100) > parseInt(parseFloat(vself.lancamentosmov.fatordiferenca) * 100)){
							temdif = 1;
						}	
					}
				}

				let movimento = {
					'idlancamentopdv' 	: vself.lancamentosmov.id,
					'idmovimento'		: vself.lancamentosmov.idmovimentofechamento,
					'valor'				: vself.ltotalfechamentoedicaofechamento,
					'formas'			: vself.lstformasedicaofechamento
				};
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'editarfechamento'},
					{parametro: 'movimento',    valor : JSON.stringify(movimento)},
					{parametro: 'temdif',    	valor : temdif},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        valor : '020Z.015Z.220Z'},
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentospdvs.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						vself.$toastr.s('Edição do fechamento realizada com sucesso!', 'Informação!');
						vself.mtdcancelaredicaofechamento();
						$('#mdlistamovimentos').modal('hide');
						//rotina para a impressão do documento
						vself.mtdimprimirmovimentocaixa(movimento.idlancamentopdv, movimento.idmovimento, 1);//tpimp: 0 - A4, 1 - térmica						
						vself.mtdexecutapesquisa();
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
			mtdvisualizaralerta(origem){
				let vself = this;
				vself.vidclientealerta = 0;//mudo antes o valor pro componente entender que houve alteração do valor pra poder reagir
				if(origem == 1){
					vself.vidclientealerta = vself.didcliente;	
				}
				if(origem == 2){
					vself.vidclientealerta = vself.ridcliente
				}
							
				$('#mdconteudoalertacliente').modal('show');								
			},
			//Luiz Trindade - Método para computar external codes
			computarExternalCodes(){
				this.lstExternalCodesPdvCodes = JSON.parse(localStorage.getItem("lstExternalCodesPdvCodes"));
				console.log(this.lstExternalCodesPdvCodes);

				this.lstExternalCodesPdvCodes.forEach((element) =>{
					// this.lstitens.push(element.externalCode);
					// console.log("externalCode: ", element.externalCode);
					// console.log("quantity: ", element.quantity);

					const index = parseInt(this.lstitens.length);
					this.mtdincluirprodutoifood(element, index);
				});
			},
			//Luiz Trindade - Método para incluir pedidos do ifood
			mtdincluirprodutoifood(item, indice){
				this.mtdlocalizarproduto(item.quantity+'*'+item.externalCode)
				if(parseInt(this.lstitensbotoes[indice].qtd) > 1){
					this.mtdalterarqtd(false, this.lstitensbotoes[indice].qtd - 1, indice)
				}
				
				$('#mdlistarpedidosifood').modal('hide');
				$('#mdlistarpedidosifoodanteriores').modal('hide');
			},
			//Luiz Trindade - Abrir modal do ifood
			mtdmodalifood(){
				let pedidoIfood = localStorage.getItem("ifoodOrderId");
				
				if (pedidoIfood == ""){
					$('#mdlistarpedidosifood').modal('show');
				} else {
					this.$toastr.w('Pedidos do ifood devem ser importados um de cada vez!', 'Atenção!');
				}
			},
			//Rodrigo Nascimento && Luiz Trindade ❤️💕 - Método de socketIO
			mtdconectasocketio(){
				if (this.mtdverificasistemafood()) {
					this.lstPedidosIfoodSocketIO 			= [];
					this.lstPedidosIfoodAnterioresSocketIO 	= [];
					localStorage.setItem("lstPedidosIfoodDetalhadosTamanho", 0);
					this.atzqtdpedidosbadge(localStorage.getItem("lstPedidosIfoodDetalhadosTamanho"));
	
					// console.log("Teste de exibição do merchantId: ", this.merchantId);
	
					if(this.conexaoSIO){
						// console.log("desconectando socket.io");
						this.conexaoSIO.disconnect();
					}
					// console.log("socketconnect", this.clientID, this.clientSecret);
	
					// this.conexaoSIO = io("http://localhost:3000", {
					this.conexaoSIO = io("https://app-rillsoft.com.br", {
						auth: {
							idClienteSac	: this.$store.state.usuario.idclientesac,
							idFilial		: this.$store.state.filialpadrao.codfil,
							codop			: "listagempedidosifood",
							clientID		: this.clientID,
							clientSecret	: this.clientSecret,
							merchantID		: this.merchantId
						}
					});
					
					this.conexaoSIO.on("Conectado", (resposta) => {
						console.log(resposta.message)
					});
	
					this.conexaoSIO.on("listagem-pedidos", (data) => {
						this.lstPedidosIfoodSocketIO.push(data);
	
						this.lstPedidosIfoodAnterioresSocketIO.push(data);
						setTimeout(() => {
							this.atzqtdpedidosbadge(localStorage.getItem("lstPedidosIfoodDetalhadosTamanho"));
						}, 500);
					});
	
					this.conexaoSIO.on("listagem-pedidos-antigos", (data) => {
						this.lstPedidosIfoodAnterioresSocketIO.push(data);
					});
	
					//Luiz Trindade - Ecento de escuta de erro de listagem de pedidos
					this.conexaoSIO.on("erro-listagem-pedidos", (data) => {
						const content = data;
						console.log(content);
					});
				}
			},
			mtdinformacoesclientemerchant2() {
				// console.log('teste');
				let vself = this;
                let parametros = [
                    {parametro: "op",               valor: "informacoesclientemerchant"},
                    {parametro: "idclientesac",     valor: vself.$store.state.usuario.idclientesac},
                    {parametro: "idfilial",         valor: vself.$store.state.filialpadrao.codfil},
                ];

                let retorno = util.reqaxios(
                    parametros, "post", 
                    vself.$store.state.usuario.adrsrv+
                    '/controller/API/ifood/ifoodRequestApi.php'
                );

                retorno.then((response) => {
                    vself.clientID       = response.data[0].clientid;
                    vself.clientSecret   = response.data[0].clientsecret;
                    vself.merchantId     = response.data[0].merchantid;
                }).catch((response) =>{
                    //Log do erro
                    console.log(response);
                });
            },
			//Rodrigo nascimento && Luiz Trindade ❤️💕- Função para atualizar o badge de notificações de pedidos do ifood
			atzqtdpedidosbadge(data){
				// Faz a lógica ai de contagem de pedidos
				this.qtdPedidosBadge = data;
				// console.log(`Qtd pedidos badge: ${this.qtdPedidosBadge}`);
			},
			//Luiz Trindade - Função para atualizar o badge de notificação de quantidade de pedidos
			// updatepedidosbadge(){
			// 	this.qtdPedidosBadge += 1;
			// },
        },
        mounted: function () {			
            if (util.verificasessao(this)) {
                let vself 			= this;
				vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;							
                let loader 			= vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
					vself.planocliente  = response.data.plnc;	
					vself.resumoformas  = util.opcaousuario('020Z.015Z.135Z', vself.$store.state.perfilusuario);
                    if (util.opcaousuario('020Z.015Z', vself.$store.state.perfilusuario)) {
						vself.fechamentocego		= util.opcaousuario('020Z.015Z.120Z', vself.$store.state.perfilusuario);
						vself.opeditarfechamento    = util.opcaousuario('020Z.015Z.220Z', vself.$store.state.perfilusuario);
						vself.pathimgview           = vself.$store.state.configpaths.pathimagens;
                        $('#pnlista').fadeIn(700);
                        vself.mtdinformacoesclientemerchant2();
                        vself.mtdatzvariaveisperfil();
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                        vself.mtdlancamentospdv();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            }
        },
        computed:{
			idclienteretornocadrapido(){
                return this.$store.state.cadastrorapidocliretorno.idcliente;
            },
			listaprodutosretorno(){
                return this.$store.state.listaprodutosretornoconsulta.lstprod;
            },
            validou() {
                return this.vidpdv === null || this.vidforma === null;
            },
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
			manipulaval(){
				if (!this.alteraentra) {
					this.vtipodescacresedicao 	= 0;
					this.vvalordescacresedicao 	= 0;
					this.vtipodescacresedicao 	= 0;
					this.vdescacresedicao 	    = 0;
				}
				switch (parseInt(this.vmanipulavaledicao)) {
					case 0:
						if (!this.alteraentra) {
							this.vvlunitarioedicao = this.vvltabelaitemedicao;							
						}
						return true;
						break;
					case 1:
						return false;
						break;
				}
				this.alteraentra = false;
			},
			calculatotalitem() {
				let valdescacres = 0;
				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres = this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						break;
					case 1://Valor
						valdescacres = this.vvalordescacresedicao;
						break;
				}
				switch (parseInt(this.vdescacresedicao)){
					case 0://Desconto
						this.vvltotaledicao = (this.vqtditemedicao * this.vvlunitarioedicao) - valdescacres;
						break;
					case 1://Acrescimo
						this.vvltotaledicao = (this.vqtditemedicao * this.vvlunitarioedicao) + valdescacres;
						break;
				}
            },
			calculatotalserv() {
				var valdescacres = 0;
				switch (parseInt(this.vtipodescontoservicoedicao)) {
					case 0://Percentual
						valdescacres = this.vqtdservicoedicao * this.vvlservicoedicao * this.vvalordescontoservicoedicao / 100;
						break;
					case 1://Valor
						valdescacres = this.vvalordescontoservicoedicao;
						break;
				}
				this.vvltotalservicoedicao = (this.vqtdservicoedicao * this.vvlservicoedicao) - valdescacres;
			},			
			calculadescontototalitens(){
				if (parseInt(this.vtipodesctotal) === 0){
					this.vtotalcomdesconto = this.vtotalsemdesconto - (this.vtotalsemdesconto * this.vfatordescontototal / 100);
					this.vresdesconto	   = this.vfatordescontototal * this.vtotalsemdesconto / 100;						
				}else{
					this.vtotalcomdesconto = this.vtotalsemdesconto - this.vfatordescontototal;			
					this.vresdesconto	   = this.vfatordescontototal / this.vtotalsemdesconto * 100;			
				}
            }, 
			calculaacrescimototalitens(){
				if (parseInt(this.vtipoacresctotal) === 0){
					this.vtotalcomacrescimo = this.vtotalsemacrescimo + (this.vtotalsemacrescimo * this.vfatoracrescimototal / 100);
					this.vresacrescimo	   = this.vfatoracrescimototal * this.vtotalsemacrescimo / 100;						
				}else{
					this.vtotalcomacrescimo = this.vtotalsemacrescimo + this.vfatoracrescimototal;			
					this.vresacrescimo	   = this.vfatoracrescimototal / this.vtotalsemacrescimo * 100;			
				}
            },                         
            idclienteretorno(){
                return this.$store.state.clienteretornoconsulta.idcliente;
			},
            idprodutoretorno(){
				if (!this.vrotinadevolucao){
                	return this.$store.state.produtoretornoconsulta.idproduto;
				}
            },
            idprodutoretornodev(){
				if (this.vrotinadevolucao){
                	return this.$store.state.produtoretornoconsulta.idproduto;
				}
            },			
            idpedidoretorno(){
                return this.$store.state.pedidoretornoconsulta.idpedido;
            },
            retornobaixa(){
               return this.$store.state.retornobaixareceber.retorno; 
			},
			calculatotalfechamento(){
				this.vsomavaloresfechamento = 0;
				this.vsomavaloresregistrados= 0;
				for (let forma of this.lstformasfechamento) {
					this.vsomavaloresfechamento 	= parseFloat(this.vsomavaloresfechamento) + parseFloat(forma.valorfechamento);
					this.vsomavaloresregistrados 	= parseFloat(this.vsomavaloresregistrados) + parseFloat(forma.valorregistrado);					
				}
				this.vvldiferencafechamento = parseFloat(this.vsomavaloresregistrados) - parseFloat(this.vsomavaloresfechamento);
			},
			calculatotaldev(){
				this.vvtotaldev = this.vvlunitariodev * this.vqtditemdev;
			}			            
        },
        watch:{		
			idclienteretornocadrapido(val){
				if (val !== null || val !== ''){
					if (!this.rotinarecebimento){
						this.didcliente = val;
						this.mtdlocalizarcliente(this.didcliente);					
					}else{
						this.ridcliente = val;
						this.mtdlocalizarcliente(this.ridcliente);					
					}
                }
			},
            pagina_atual(val){
                this.mtdcarregapdvs(val);
            },
            idclienteretorno(val){
                if (val !== null || val !== ''){
					if (!this.rotinarecebimento){
						this.didcliente = val;
						this.mtdlocalizarcliente(this.didcliente);					
					}else{
						this.ridcliente = val;
						this.mtdlocalizarcliente(this.ridcliente);					
					}
                }
			},			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
            },
			listaprodutosretorno(val){
				this.processaprodutos(val);
			},		
            idprodutoretornodev(val){
                if (val !== null || val !== ''){
					this.vcoddigdev = val;
					this.mtdlocalizarprodutodev(this.vcoddigdev);					
                }
            },			
            idpedidoretorno(val){
                if (val !== null || val !== ''){
                    this.mtdlocalizapedido(val);
                }
			},
            retornobaixa(val){
				let vself  = this;				
                if (parseInt(val) > 0){
                    //dispara a mutation pra esperar pela próxima baixa
                    let payload = {
                        retorno    : 0
					};
					vself.mtdimprimirmovimentocaixa(vself.lancamentousu.id, val, 1);
					vself.$store.commit('RETORNO_BAIXA_RECEBER_CHANGE',payload);										
                    vself.mtdlimpar_listagem_titulos();
					vself.mtdfecharrecebimentos();                    
					
                }
            },
			tajustarparcelas(val){
				if (val){
					this.tajustarcentavos		= false;
				}
			},
			tajustarcentavos(val){
				if (val){
					this.tajustarparcelas		= false;
				}
			}
        }
    }    
</script>
<style>
	.bdg-qtd-pedidos{
		width: 15px !important;
		height: 15px !important;
		font-size: 15px !important;
		padding: .6em !important;
		position: absolute;
		right: -15px;
		top: -5px;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			opacity: 1;
		}
		35% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
		85% {
			opacity: 1;
		}
		100% {
			opacity: 1;
		}
	}
	#mddefinircoesvenda{
		z-index: 2001!important;
	}
	#dvcorpolancamentos{
		padding-bottom: 0px;
	}	
	#dvlancamentospdv{
		margin-top: 15px;
	}
	#spn-titulo-pdv{
		font-size: 18px; 
		font-weight: 700; 
		margin-left: -15px;		
	}		
	#edlidproduto{
		font-size: 16px;
		font-weight: 700;
		text-align: center;
		color: #666666;
		border-top-left-radius: 10px;
    	border-bottom-left-radius: 10px;
	}
	#dv-lst-itens{
		padding-top: 10px;
		overflow: auto;
	}	
	#dv-menu{
		padding-left: 15px;
		padding-right: 15px;
	}
	#dv-menu > .col{
		padding: 2px!important;			
	}		
	#dv-logo{
		margin-top: 10px;
		border: 1px solid #cccccc;
		border-radius: 5px;
		margin-left: 5px;
		margin-right: 5px;
		padding: 10px;			
	}
	.inf-rodape-item{
		font-size: 14px;
	}	
	.opcoes-venda{
		cursor: pointer;
		float: left;
		font-size: 25px;
	}
	.opcoes-venda:hover{
		filter: brightness(80%)!important;
	}
	.card-header{
		color: #cccccc;
		background-color: #343a40;
		border-color: #454d55;
	}
	.card-in{
		color: #666;
		font-weight: bold;
		background: #f7f7f7;
		border-bottom: 1px solid rgba(0, 0, 0, 0.125);
	}
	.dv-subtotal{
		background: #343a40;
		min-height: 65px;
		padding: 5px!important;
		font-size: 20px;
		font-weight: bold;
		color: white;
		border-radius: 5px;
		margin-right: -5px!important;			
	}
	.dv-informacoes-venda{
		background: #343a40; 
		padding: 10px !important; 
		padding-top: 15px !important; 
		color: white; 
		font-size: 10px;
		font-weight: bold;
		border-radius: 5px;			
	}
	.spn-informacoes-venda{
		position: absolute;
		left: 80px;
	}
	#dv-menugeral{
		margin-left: -25px;
		margin-top: -15px;
	}
	#dv-menu-row{
			margin-right: -30px;
	}
	.btn-menu-pdv{
		min-height: 52px!important;		
	}		
	.fa-ajuste{
		width: 20px!important;
	}
	#dv-btn-camera{
		display: none;
	}
	#btn-camera{
		padding-top: 6px!important;
    	padding-bottom: 5px!important;		
		border-top-left-radius: 10px!important;
		border-bottom-left-radius: 10px!important;		
	}
	.def-col-forma-fechamento{
		width: 150px;
	}
	@media screen and (max-width: 767px) {
		#dv-btn-camera{
			display: block;
		}
		#edlidproduto{
			border-top-left-radius: 0px;
			border-bottom-left-radius: 0px;
		}		
		#dv-menugeral{
			margin-left: 0px;
			margin-top:  0px;
		}
		#dv-menu-row{
			margin-right: 0px;
		}			
		#dv-menu{
			margin-top: 10px;
		}			
		#dv-logo{
			display: none;
		}
		.dv-qtd-item{
			text-align: right;
		}
		.dv-subtotal{
			margin-right: -15px!important;
			margin-bottom: 10px!important;			
		}
		#spn-titulo-pdv{
			font-size: 14px; 
		}		
		.opcoes-venda{
			font-size: 22px;
		}	
	}
	.cardbtn{

		border-radius: 10px !important;
	}
	.cardbtn-ativo{

		border-radius: 10px !important;
		background-color: #add8e6 !important;
	}
	@media (max-width: 365px) {
	.descmini{
		font-size: x-small;
	}
	.responsive{
		font-size: x-small;
	}
}	
</style>